{
    "common": {
        "added": {
            "label": {},
            "msg": {},
            "code": {}
        },
        "label": {
            "Views": "Views",
            "Updating": "Updating",
            "By URL": "By URL",
            "Usage trend": "Usage trend",
            "Top {{count}} URLs": "Top {{count}} URLs",
            "Top {{count}} referring domains": "Top {{count}} referring domains",
            "Top {{count}} countries": "Top {{count}} countries",
            "{{total}} total": "{{total}} total",
            "Published target": "Published target",
            "Last viewed": "Last viewed",
            "{{count}} published": "<0>{{count}}</0> published",
            "As of {{hours}} hour(s) ago": "As of {{hours}} hour(s) ago",
            "As of {{days}} day(s) ago": "As of {{days}} day(s) ago",
            "As of less than an hour ago": "As of less than an hour ago",
            "Public URL statistics": "Public URL statistics",
            "Usage of {{count}} public URL(s)": "Usage of {{count}} public URL(s)",
            "Public URL statistics details": "Public URL statistics details",
            "{{active}} published, {{released}} unpublished": "<0>{{active}}</0> published · <1>{{released}}</1> unpublished",
            "({{active}} published, {{released}} unpublished)": "({{active}} published, {{released}} unpublished)",
            "left axis": "(left axis)",
            "right axis": "(right axis)",
            "Estimated visitors": "Estimated visitors",
            "Data transferred": "Data transferred",
            "Referring domains": "Referring domains",
            "Countries": "Countries",
            "Last {{days}} days": "Last {{days}} days",
            "Gen AI": "Gen AI",
            "Dimension": "Dimension",
            "When an asset is created": "When an asset is created",
            "When an asset is published": "When an asset is published",
            "When an asset is updated": "When an asset is updated",
            "{{from}}-{{to}} of {{count}}": "{{from}}-{{to}} of {{count}}",
            " - Total {{totalSize}}": " - Total {{totalSize}}",
            "Add Vocabulary?": "Add Vocabulary?",
            "Add to all": "Add to all",
            "All items cannot be deleted.": "All items cannot be deleted.",
            "Archiving...": "Archiving...",
            "Asset created": "Asset created",
            "Asset published": "Asset published",
            "Asset to be analyzed": "Asset to be analyzed",
            "Asset updated": "Asset updated",
            "Bucket name must be between 3 and 63 letters and start with alphabet or number with allowed special characters of -, _, and .)": "Bucket name must be between 3 and 63 letters and start with alphabet or number with allowed special characters of -, _, and .)",
            "Choose on Organizer": "Choose on Organizer",
            "Close my jobs": "Close my jobs",
            "Close tab menu": "Close tab menu",
            "Collapse panel": "Collapse panel",
            "Connection settings": "Connection settings",
            "Copy to {{name}}": "Copy to {{name}}",
            "Create Webhook": "Create Webhook",
            "Customer": "Customer",
            "Default value": "Default value",
            "Destination": "Destination",
            "Domain URL": "Domain URL",
            "Drive": "Drive",
            "Duplicate the item?": "Duplicate the item?",
            "Empty Recoding History": "Empty Recoding History",
            "Endpoint URL": "Endpoint URL",
            "Enter Vocabulary name": "Enter Vocabulary name",
            "Enter after entering": "Enter after entering",
            "Enter field description": "Enter field description",
            "Enter prefix": "Enter prefix",
            "Entering Console…": "Entering Console…",
            "Error renaming from {{item1}} to {{item2}}.": "Error renaming from {{item1}} to {{item2}}.",
            "Event Triggers": "Event Triggers",
            "Expand panel": "Expand panel",
            "Failed": "Failed",
            "Find objects by prefix": "Find objects by prefix",
            "Go to Search Results": "Go to Search Results",
            "Grouping": "Grouping",
            "Headers": "Headers",
            "Height": "Height",
            "Hide value": "Hide value",
            "HTTP Method": "HTTP Method",
            "Id": "Id",
            "If you need permission, please contact your account manager.": "If you need permission, please contact your account manager.",
            "In use": "In use",
            "Ingested": "Ingested",
            "Ingesting": "Ingesting",
            "Min": "Min",
            "Moving...": "Moving...",
            "No requests list": "No requests list",
            "Offline": "Offline",
            "Open tab menu": "Open tab menu",
            "Other": "Other",
            "Permission to access is required.": "Permission to access is required.",
            "Please create an organizer.": "Please create an organizer.",
            "Prefix cannot be empty": "Prefix cannot be empty",
            "Prefix must begin with s3://": "Prefix must begin with s3://",
            "Preview Image": "Preview Image",
            "Progressing": "Progressing",
            "Project name cannot be empty": "Project name cannot be empty",
            "Re-Approval requested": "Re-Approval requested",
            "Recent deliveries": "Recent deliveries",
            "Remove header": "Remove header",
            "Request body example": "Request body example",
            "Response": "Response",
            "Search by webhook name": "Search by webhook name",
            "Search Projects": "Search Projects",
            "Search by execution ID": "Search by execution ID",
            "Select Language": "Select Language",
            "Select Service Type": "Select Service Type",
            "Select Storage": "Select Storage",
            "Share to \"{{name}}\"": "Share to \"{{name}}\"",
            "Show value": "Show value",
            "Smiling": "Smiling",
            "Space ID": "Space ID",
            "CDN ID": "CDN ID",
            "System management": "System management",
            "There is no resource in video.": "There is no resource in video.",
            "There was an error creating the new folder {{item}}.": "There was an error creating the new folder {{item}}.",
            "Total for all projects": "Total for all projects",
            "Transport format": "Transport format",
            "Triggers": "Triggers",
            "Use all": "Use all",
            "View Files": "View Files",
            "View History": "View History",
            "Vocabularies": "Vocabularies",
            "Vocabulary Book Search Results": "Vocabulary Book Search Results",
            "Webhook": "Webhook",
            "webhook": "webhook",
            "Webhooks": "Webhooks",
            "Delivery history": "Delivery history",
            "Request ID": "Request ID",
            "Status code": "Status code",
            "Response time": "Response time",
            "Result": "Result",
            "Select result": "Select result",
            "Success": "Success",
            "Width": "Width",
            "You do not have permission.": "You do not have permission.",
            "Zoom In": "Zoom In",
            "Zoom Out": "Zoom Out",
            "and": "and",
            "canceled": "canceled",
            "complete": "complete",
            "error": "error",
            "group": "group",
            "loading...": "loading...",
            "preview": "preview",
            "remove": "remove",
            "requested": "requested",
            "user": "user",
            "weekly": "weekly",
            "{{name}} Search Results": "{{name}} Search Results",
            "READY TO DOWNLOAD": "READY TO DOWNLOAD",
            "STARTING": "STARTING",
            "STOPPING": "STOPPING",
            "SUBMITED": "SUBMITED",
            "UNKNOWN": "UNKNOWN",
            "AWS": "AWS",
            "Daglo": "Daglo",
            "S3 Glacier Deep Archive": "S3 Glacier Deep Archive",
            "S3 Glacier Flexible Retrieval": "S3 Glacier Flexible Retrieval",
            "Subsy": "Subsy",
            "Image zoom in": "Image zoom in",
            "Add Option": "Add Option",
            "Labels": "Labels",
            "Filter labels": "Filter labels",
            "Go to details": "Go to details",
            "Select Key": "Select Key",
            "Current Space": "Current Space",
            "Stage List": "Stage List",
            "Empty Widget List": "Empty Widget List",
            "Enlarge Layout": "Enlarge Layout",
            "Video Player": "Video Player",
            "Copying": "Copying",
            "Empty Published History": "Empty Published History",
            "Request Details": "Request Details",
            "Results for your Search": "Results for your Search",
            "Average Confidence (%) : More than": "Average Confidence (%) : More than",
            "Prev": "Prev",
            "Go Detail": "Go Detail",
            "By Last Created": "By Last Created",
            "day": "day",
            "Only Unused Files": "Only Unused Files",
            "Access Token": "Access Token",
            "Refresh Token": "Refresh Token",
            "Projects Allowed to Use": "Projects Allowed to Use",
            "Go to error item": "Go to error item",
            "Error message": "Error message",
            "How to resolve": "How to resolve",
            "Continue editing": "Continue editing",
            "Acknowledge and save": "Acknowledge and save",
            "Add parallel step": "Add parallel step",
            "WORKFLOW_QUEUED": "Queued",
            "WORKFLOW_READY": "Ready",
            "WORKFLOW_RUNNING": "Running",
            "WORKFLOW_COMPLETED": "Completed",
            "WORKFLOW_FAILED": "Failed",
            "WORKFLOW_EXPIRED": "Expired",
            "Start Date": "Start Date",
            "End Date": "End Date",
            "Duration (sec)": "Duration (sec)",
            "bucketName": "Bucket Name",
            "prefix": "Prefix",
            "fileUrl": "File URL",
            "extension": "Extension",
            "extensions": "Extensions",
            "minByte": "Min Byte",
            "maxByte": "Max Byte",
            "assetId": "Asset ID",
            "mediaType": "Media Type",
            "attributions": "Attributions",
            "tags": "Tags",
            "categories": "Categories",
            "description": "Description",
            "extendedMetadata": "Extended Metadata",
            "virtualLocation": "Location",
            "collection": "Collection",
            "pipelineId": "Pipeline ID",
            "videoId": "Video ID",
            "promptId": "Prompt ID",
            "storageClass": "Storage Class",
            "platform": "Platform",
            "isCreateOriginAsset": "Save the origin source as an asset",
            "AI Search Mode": "AI Search Mode",
            "Grant Space Admin": "Grant Space Admin",
            "Grant Project Admin": "Grant Project Admin",
            "1st": "1st",
            "2nd": "2nd",
            "3rd": "3rd",
            "4th": "4th",
            "5th": "5th",
            "6th": "6th",
            "- Total {{totalSize}}": "- Total {{totalSize}}",
            "{{count}} views": "{{count}} views",
            "{{name}} files": "{{name}} files",
            "{{name}} ID": "{{name}} ID",
            "{{name}} inquiry": "{{name}} inquiry",
            "{{name}} overview": "{{name}} overview",
            "New": "New",
            "24 hours": "24 hours",
            "24/7": "24/7",
            "Accept": "Accept",
            "Account": "Account",
            "Action": "Action",
            "Actions": "Actions",
            "Active": "Active",
            "ACTIVE": "ACTIVE",
            "ACTIVE / INACTIVE TOGGLE": "ACTIVE / INACTIVE TOGGLE",
            "Add": "Add",
            "Add {{name}}": "Add {{name}}",
            "Add a category": "Add a category",
            "Add caption": "Add caption",
            "Add faces": "Add faces",
            "Add files": "Add files",
            "Add image": "Add image",
            "Add images": "Add images",
            "Add lineup": "Add lineup",
            "Add roles": "Add roles",
            "Add teams": "Add teams",
            "Add users": "Add users",
            "Add posters": "Add posters",
            "Admin": "Admin",
            "Administration": "Administration",
            "Advanced search": "Advanced search",
            "ALL": "ALL",
            "All event type": "All event type",
            "All ingest type": "All ingest type",
            "All language": "All language",
            "All media type": "All media type",
            "All media types": "All media types",
            "All pipeline": "All pipeline",
            "All project": "All project",
            "All source": "All source",
            "All state": "All state",
            "All status": "All status",
            "All type": "All type",
            "All types": "All types",
            "Allowed special characters": "Allowed special characters",
            "Alternative name": "Alternative name",
            "Alternative names": "Alternative names",
            "Amount": "Amount",
            "Amount : {{amount}}": "Amount : {{amount}}",
            "Analyzed": "Analyzed",
            "Analyzing": "Analyzing",
            "Anywhere": "Anywhere",
            "Appears to be happy": "Appears to be happy",
            "Appears to be male": "Appears to be male",
            "Apply": "Apply",
            "Approval": "Approval",
            "Approval in progress": "Approval in progress",
            "Approval request": "Approval request",
            "Approval requested": "Approval requested",
            "Approval status": "Approval status",
            "Approve": "Approve",
            "Approve whitelist": "Approve whitelist",
            "Approved": "Approved",
            "Approved whitelist": "Approved whitelist",
            "Asset": "Asset",
            "Asset ID": "Asset ID",
            "Asset name": "Asset name",
            "Assets": "Assets",
            "Assets {{name}}": "Assets {{name}}",
            "Attribution": "Attribution",
            "Attributions": "Attributions",
            "Audio": "Audio",
            "Audio settings": "Audio settings",
            "Audit logs": "Audit logs",
            "Audit-Logs": "Audit-Logs",
            "Authority": "Authority",
            "Auto Start/Stop": "Auto Start/Stop",
            "Automated Workflow": "Automated Workflow",
            "AWS medialive channel": "AWS medialive channel",
            "AWS medialive input": "AWS medialive input",
            "Base video": "Base video",
            "Blank time": "Blank time",
            "Cancel": "Cancel",
            "CANCELED": "CANCELED",
            "Cannot delete the stream": "Cannot delete the stream",
            "Image": "Image",
            "Caption": "Caption",
            "Caption label": "Caption label",
            "Captions": "Captions",
            "Categories": "Categories",
            "Categories selected": "Categories selected",
            "Category": "Category",
            "Category description": "Category description",
            "Category group": "Category group",
            "Category group description": "Category group description",
            "Category group name": "Category group name",
            "Category groups": "Category groups",
            "Celebrity recognition": "Celebrity recognition",
            "Channel": "Channel",
            "Channel description": "Channel description",
            "Channel ID": "Channel ID",
            "Channel overview": "Channel overview",
            "Channel state of non-scheduled time": "Channel state of non-scheduled time",
            "Channels": "Channels",
            "Chapter": "Chapter",
            "Choose on schedules": "Choose on schedules",
            "Choose on stream": "Choose on stream",
            "Choose on streams": "Choose on streams",
            "Client ID": "Client ID",
            "Client IP": "Client IP",
            "Client secret": "Client secret",
            "Client useragent": "Client useragent",
            "Clone": "Clone",
            "Close": "Close",
            "Cloud": "Cloud",
            "Cloud inquiry": "Cloud inquiry",
            "CloudPlex Media": "CloudPlex Media",
            "CloudPlex Media subtitle editor": "CloudPlex Media subtitle editor",
            "CMS": "CMS",
            "Code": "Code",
            "COMPLETE": "COMPLETE",
            "Completed": "Completed",
            "Conditions": "Conditions",
            "Confidence": "Confidence",
            "Configuration": "Configuration",
            "Constraints": "Constraints",
            "Content moderation": "Content moderation",
            "Contents": "Contents",
            "Contents duration": "Contents duration",
            "Copy": "Copy",
            "Copyright": "Copyright",
            "Correct status": "Correct status",
            "Create": "Create",
            "Create {{name}}": "Create {{name}}",
            "Create {{name}} asset": "Create {{name}} asset",
            "Create MP4 asset": "Create VIDEO asset",
            "Create MP3 asset": "Create AUDIO asset",
            "Create IMAGE asset": "Create IMAGE asset",
            "Create CAPTION asset": "Create CAPTION asset",
            "Created": "Created",
            "Creator": "Creator",
            "Execution History": "Execution History",
            "Execution Result": "Execution Result",
            "Flow Detail Information": "Flow Detail Information",
            "Created by": "Created by",
            "Creating": "Creating",
            "CSV Export": "CSV Export",
            "Cumulative viewers": "Cumulative viewers",
            "Cumulative views": "Cumulative views",
            "Cumulative viewing time": "Cumulative viewing time",
            "Current time": "Current time",
            "Current viewers": "Current viewers",
            "Currently online": "Currently online",
            "Custom fields": "Custom fields",
            "Cycle": "Cycle",
            "Dailys": "Dailys",
            "Dashboard": "Dashboard",
            "Date": "Date",
            "Date picker": "Date picker",
            "Date format": "Date format",
            "Day": "Day",
            "Days": "Days",
            "Default": "Default",
            "Delete": "Delete",
            "Delete all": "Delete all",
            "Deleted": "Deleted",
            "Deleted output asset retention": "Deleted output asset retention",
            "Description": "Description",
            "Desktop": "Desktop",
            "Destination A": "Destination A",
            "Destination B": "Destination B",
            "Detach": "Detach",
            "Detach {{name}}": "Detach {{name}}",
            "Detail": "Detail",
            "Direct": "Direct",
            "Direct input": "Direct input",
            "Disable": "Disable",
            "Down": "Down",
            "Download": "Download",
            "Download apps": "Download apps",
            "Download filtered list": "Download filtered list",
            "Download full list": "Download full list",
            "DRAFT": "Draft",
            "Draft": "Draft",
            "DUAL": "DUAL",
            "Dual": "Dual",
            "Dubbing": "Dubbing",
            "MultipleAudios": "Multiple audios",
            "Duration": "Duration",
            "Edit": "Edit",
            "Email": "Email",
            "Embed code": "Embed code",
            "Employee Sign in": "LX Hausys Employee Sign in",
            "Empty": "Empty",
            "Empty {{name}}": "Empty {{name}}",
            "Every {{interval}} days": "Every {{interval}} days",
            "Enable": "Enable",
            "Encoding profile": "Encoding profile",
            "End": "End",
            "End date": "End date",
            "End now": "End now",
            "End time": "End time",
            "Endpoint": "Endpoint",
            "Endpoints": "Endpoints",
            "Error": "Error",
            "ERROR": "ERROR",
            "Etc": "Etc",
            "Event": "Event",
            "EVENT": "EVENT",
            "Event triggers": "Event triggers",
            "Event type": "Event type",
            "EventTrigger": "EventTrigger",
            "EventTrigger description": "EventTrigger description",
            "EventTrigger name": "EventTrigger name",
            "EventTriggers": "EventTriggers",
            "Every": "Every",
            "Expired": "Expired",
            "Expired at": "Expired at",
            "Expired date": "Expired date",
            "Face": "Face",
            "Face anlaysis": "Face anlaysis",
            "Face index": "Face index",
            "Face search": "Face search",
            "Facebook": "Facebook",
            "Faces": "Faces",
            "Faces selected": "Faces selected",
            "Field type search": "Field type search",
            "Field {{count}}": "Field {{count}}",
            "File": "File",
            "File name": "File name",
            "File source": "File source",
            "Files": "Files",
            "Folder name": "Folder name",
            "Folder search": "Folder search",
            "Follow default values": "Follow default values",
            "Force inheritance": "Force inheritance",
            "Fri": "Fri",
            "Friday": "Friday",
            "General": "General",
            "Go to schedule": "Go to schedule",
            "Grand additional roles": "Grant additional roles",
            "Grant all permissions": "Grant all permissions",
            "Grant project access": "Grant project access",
            "Granted": "Granted",
            "Granted roles": "Granted roles",
            "Hide": "Hide",
            "High": "High",
            "Highest": "Highest",
            "Hub scope": "All projects",
            "Hyper Browser": "Hyper Browser",
            "ID": "ID",
            "Idle": "Idle",
            "IMAGE": "IMAGE",
            "Image setting": "Image setting",
            "Image sources": "Image sources",
            "Images selected": "Images selected",
            "Inactive": "Inactive",
            "Index": "Index",
            "Indexing": "Indexing",
            "Indexed": "Indexed",
            "Index file": "Index file",
            "Individual settings": "Individual settings",
            "Ingest type": "Ingest type",
            "Ingest": "Ingest",
            "INGEST": "INGEST",
            "INGESTED": "INGESTED",
            "INGESTING": "INGESTING",
            "Inherit": "Inherit",
            "Input {{index}}": "Input {{index}}",
            "Input asset auto delete": "Input asset auto delete",
            "Input detail": "Input detail",
            "Input path": "Input path",
            "Input storage": "Input storage",
            "Input storage path": "Input storage path",
            "Inputs": "Inputs",
            "Instagram": "Instagram",
            "Interval": "Interval",
            "IP range": "IP range",
            "Job": "Job",
            "Job {{name}}": "Job {{name}}",
            "Job ID": "Job ID",
            "Job overview": "Job overview",
            "Jobs": "Jobs",
            "Key": "Key",
            "Kind": "Kind",
            "Label": "Label",
            "Label detection": "Label detection",
            "Language": "Language",
            "Last access": "Last access",
            "Last accessed at": "Last accessed at",
            "Leave": "Leave",
            "Leave comment": "Leave comment",
            "Linear": "Linear",
            "LINEAR": "LINEAR",
            "Lineup": "Lineup",
            "Lineup copy": "Lineup copy",
            "Lineup count": "Lineup count",
            "Lineup detail": "Lineup detail",
            "Lineup name": "Lineup name",
            "List": "List",
            "Listing": "Listing",
            "Schedules": "Schedules",
            "SCHEDULES": "SCHEDULES",
            "Schedules detail": "Schedules detail",
            "Schedules ID": "Schedules ID",
            "Schedules overview": "Schedules overview",
            "Live": "Live",
            "Live player URL": "Live player URL",
            "Loading...": "Loading...",
            "Local": "Local",
            "Local file": "Local file",
            "Logo": "Logo",
            "Looks like a face": "Looks like a face",
            "Loop": "Loop",
            "Loop to fill lineup duration": "Loop to fill lineup duration",
            "Low": "Low",
            "Lowest": "Lowest",
            "Main": "Main",
            "Mark in": "Mark in",
            "Mark in~out": "Mark in~out",
            "Mark out": "Mark out",
            "Max": "Max",
            "Maximum object size": "Maximum object size",
            "Maximum schedule amount": "Maximum schedule amount",
            "Media": "Media",
            "Media service": "Media service",
            "Media service inquiry": "Media service inquiry",
            "Media type": "Media type",
            "Medium": "Medium",
            "Megazone ID": "Megazone ID",
            "Members": "Members",
            "Metadata": "Metadata",
            "Metadata description": "Metadata description",
            "Metadata name": "Metadata name",
            "Metadata schema description": "Metadata schema description",
            "Mon": "Mon",
            "Monday": "Monday",
            "Month": "Month",
            "Months": "Months",
            "More than 50%": "More than 50%",
            "MP4": "MP4",
            "Multi Audio": "Multi Audio",
            "My jobs": "My jobs",
            "Name": "Name",
            "Name / ID": "Name / ID",
            "Name constraints": "Name constraints",
            "Never": "Never",
            "No": "No",
            "No options": "No options",
            "No {{name}}": "No {{name}}",
            "No asset contents": "No asset contents",
            "No asset searched.": "No asset searched.",
            "No category searched": "No category searched",
            "None": "None",
            "Not copy to": "Not copy to",
            "Not deleted": "Not deleted",
            "Not found": "Not found",
            "NOT_READY": "NOT_READY",
            "Now": "Now",
            "Number": "Number",
            "Off": "Off",
            "On": "On",
            "OR": "OR",
            "Origin": "Origin",
            "Origins": "Origins",
            "Output": "Output",
            "Outputs": "Outputs",
            "Output {{index}}": "Output {{index}}",
            "Output path": "Output path",
            "Output preview": "Output preview",
            "Output storage": "Output storage",
            "Output storage path": "Output storage path",
            "Overview": "Overview",
            "Owner": "Owner",
            "Path": "Path",
            "Parent device": "Parent device",
            "Parent region": "Parent region",
            "Payload": "Payload",
            "Pending ingesting": "Pending ingesting",
            "Pending transcoding": "Pending transcoding",
            "People": "People",
            "People description": "People description",
            "Period": "Period",
            "Period setting": "Period setting",
            "Permissions": "Permissions",
            "Pipeline": "Pipeline",
            "Pipeline {{name}}": "Pipeline {{name}}",
            "Player": "Player",
            "Please create a schedules.": "Please create a schedules.",
            "Please create a stream.": "Please create a stream.",
            "Poster": "Poster",
            "Posters": "Posters",
            "Prefix": "Prefix",
            "Preview": "Preview",
            "Preview button": "Preview button",
            "Preview in browser URL": "Preview in browser URL",
            "Priority": "Priority",
            "Privacy policy": "Privacy policy",
            "Private": "Private",
            "Profile": "Profile",
            "Profile {{name}}": "Profile {{name}}",
            "Program": "Program",
            "Program duration": "Program duration",
            "Programes count": "Programes count",
            "Programs": "Programs",
            "PENDING": "In progress",
            "PROGRESSING": "PROGRESSING",
            "Project": "Project",
            "Project description": "Project description",
            "Project ID": "Project ID",
            "Project in use": "Project in use",
            "Project manager": "Project manager",
            "Project name": "Project name",
            "Project Name / ID": "Project Name / ID",
            "Project overview": "Project overview",
            "Project settings": "Project settings",
            "Projects": "Projects",
            "Projects in use": "Projects in use",
            "Provider": "Provider",
            "Provider / Service": "Provider / Service",
            "Public": "Public",
            "Publish": "Publish",
            "QR": "QR",
            "Quick search": "Quick search",
            "Range": "Range",
            "READY": "READY",
            "Reanalysis": "Reanalysis",
            "Retry AI search indexing": "Retry AI search indexing",
            "Retry indexing": "Retry indexing",
            "Reason": "Reason",
            "Reason for approval requested": "Reason for approval requested",
            "Reason for reclaimed": "Reason for reclaimed",
            "Reason for rejected": "Reason for rejected",
            "Reason for request": "Reason for request",
            "Reason for response": "Reason for response",
            "Reason for return requested": "Reason for return requested",
            "Reclaim": "Reclaim",
            "Reclaim in progress": "Reclaim in progress",
            "Reclaimed": "Reclaimed",
            "Recorded": "Recorded",
            "Redirect URL": "Redirect URL",
            "Redundancy level": "Redundancy level",
            "Reference": "Reference",
            "Refresh": "Refresh",
            "Refresh token": "Refresh token",
            "Reject": "Reject",
            "Rejected": "Rejected",
            "Related {{pascalK}}": "Related {{pascalK}}",
            "Remaining time": "Remaining time",
            "Remote": "Remote",
            "Remote file": "Remote file",
            "Remove": "Remove",
            "Rendition": "Rendition",
            "Renditions": "Renditions",
            "Repeat": "Repeat",
            "Request": "Request",
            "Request approval": "Request approval",
            "Request body": "Request body",
            "Request cancel": "Request cancel",
            "Request return": "Request return",
            "Reset": "Reset",
            "Resolution": "Resolution",
            "Resource": "Resource",
            "Response body": "Response body",
            "Restore to default": "Restore to default",
            "Retry": "Retry",
            "Return": "Return",
            "Return cancel": "Return cancel",
            "Return in progress": "Return in progress",
            "Return request": "Return request",
            "Return requested": "Return requested",
            "Returned": "Returned",
            "Role description": "Role description",
            "Role name": "Role name",
            "Role overview": "Role overview",
            "Role": "Role",
            "Roles": "Roles",
            "rules": "rules",
            "Running": "Running",
            "S3://~": "S3://~",
            "Sat": "Sat",
            "Saturday": "Saturday",
            "Save": "Save",
            "Save origin asset": "Save origin asset",
            "Schedule": "Schedule",
            "Schedule {{index}}": "Schedule {{index}}",
            "Schedule repeat": "Schedule repeat",
            "Scheduled lineups": "Scheduled lineups",
            "Scheduled time": "Scheduled time",
            "Scope": "Scope",
            "Search": "Search",
            "Search assets name": "Search assets name",
            "Search by workflow name": "Search by workflow name",
            "Search program name": "Search program name",
            "Search team name": "Search team name",
            "Search videos name": "Search videos name",
            "Security": "Security",
            "Select": "Select",
            "Select {{name}}": "Select {{name}}",
            "Select a file": "Select a file",
            "Select a one {{type}} file": "Select a one {{type}} file",
            "Select a one caption file.": "Select a one caption file.",
            "Select assets": "Select assets",
            "Select categories": "Select categories",
            "Select category": "Select category",
            "Select event type": "Select event type",
            "Select files": "Select files",
            "Select folder": "Select folder",
            "Select kind": "Select kind",
            "Select language": "Select language",
            "Select one MP4 file": "Select one MP4 file",
            "Select pipeline": "Select pipeline",
            "Select roles to grant": "Select roles to grant",
            "Select whitelist": "Select whitelist",
            "Select...": "Select...",
            "Selected {{name}}": "Selected {{name}}",
            "Separate by newlines": "Separate by newlines",
            "Service": "Service",
            "Set": "Set",
            "Set as default": "Set as default",
            "Set as primary": "Set as primary",
            "Settings": "Settings",
            "Show all": "Show all",
            "Show more": "Show more",
            "Sign in": "Sign in",
            "Sign in with Megazone Accounts": "Sign in with Megazone Accounts",
            "Single": "Single",
            "Single IP": "Single IP",
            "Size": "Size",
            "smiling": "smiling",
            "Source": "Source",
            "Source A": "Source A",
            "Source B": "Source B",
            "Source end behavior": "Source end behavior",
            "Sources": "Sources",
            "Specifications": "Specifications",
            "Stage": "Stage",
            "Stage scope": "Stage scope",
            "Project scope": "Project scope",
            "Start": "Start",
            "Space": "Space",
            "Start {{name}}": "Start {{name}}",
            "Start analysis": "Start analysis",
            "Start date": "Start date",
            "Start indexing": "Start indexing",
            "Start time": "Start time",
            "Start~End": "Start~End",
            "Started": "Started",
            "Starting": "Starting",
            "State": "State",
            "Statistics": "Statistics",
            "Status": "Status",
            "Stop": "Stop",
            "Stopped": "Stopped",
            "Stopping": "Stopping",
            "Storage path": "Storage path",
            "Stream": "Stream",
            "STREAM": "STREAM",
            "Stream ID": "Stream ID",
            "Streams": "Streams",
            "Submit": "Submit",
            "SUBMITTED": "SUBMITTED",
            "Submitted": "Submitted",
            "Subtitle": "Subtitle",
            "Sun": "Sun",
            "Sunday": "Sunday",
            "Supported file formats": "Supported file formats",
            "Supported inputs": "Supported Inputs",
            "Supported URL patterns": "Supported URL patterns",
            "Supported URLs": "Supported URLs",
            "Synchronization": "Synchronization",
            "table": "table",
            "Tag": "Tag",
            "Tags": "Tags",
            "Target ID": "Target ID",
            "Target resource": "Target resource",
            "Team": "Team",
            "Team ID": "Team ID",
            "Team overview": "Team overview",
            "Teams": "Teams",
            "Terms & Conditions": "Terms & Conditions",
            "Text": "Text",
            "Text area": "Text area",
            "Text field": "Text field",
            "There is no Stream to select.": "There is no Stream to select.",
            "This {{name}}": "This {{name}}",
            "Thumbnails": "Thumbnails",
            "THUMBNAILS": "THUMBNAILS",
            "Thur": "Thur",
            "Thursday": "Thursday",
            "Time": "Time",
            "Timestamp": "Timestamp",
            "Timezone": "Timezone",
            "Title": "Title",
            "Today": "Today",
            "Total": "Total",
            "Total {{name}}": "Total {{name}}",
            "Total <strong className=\\\"emphasis\\\">{{elementsLength}}</strong>": "Total <0>{{elementsLength}}</0>",
            "Total <0>{{elementsLength}}</0>": "Total <0>{{elementsLength}}</0>",
            "Total time": "Total time",
            "Transcode": "Transcode",
            "Transcode profile": "Transcode profile",
            "Transcoded": "Transcoded",
            "Transcoder Job ID": "Transcoder Job ID",
            "Transcoding": "Transcoding",
            "Transcoding canceled": "Transcoding canceled",
            "Transcoding complete": "Transcoding complete",
            "Transcoding error": "Transcoding error",
            "Transcoding failed": "Transcoding failed",
            "Transcoding time": "Transcoding time",
            "Tree": "Tree",
            "Tue": "Tue",
            "Tuesday": "Tuesday",
            "Twitch": "Twitch",
            "Twitter": "Twitter",
            "Type": "Type",
            "Undefined": "Undefined",
            "Unique": "Unique",
            "Unknown": "Unknown",
            "(Unknown)": "(Unknown)",
            "Unscheduled time": "Unscheduled time",
            "Unset default": "Unset default",
            "Up": "Up",
            "Update file": "Update file",
            "Updated": "Updated",
            "Updated at": "Updated at",
            "Updated by": "Updated by",
            "Updating...": "Updating...",
            "Upload": "Upload",
            "Upload {{status}}.": "Upload {{status}}.",
            "Upload rules": "Upload rules",
            "Uploading": "Uploading",
            "UPLOADING": "UPLOADING",
            "URL": "URL",
            "User ID": "User ID",
            "User information": "User information",
            "User name": "User name",
            "User overview": "User overview",
            "User username": "User username",
            "Username": "Username",
            "Users": "Users",
            "Value": "Value",
            "Video": "Video",
            "Video ID": "Video ID",
            "Video AI": "Video AI",
            "Video setting": "Video setting",
            "Videos": "Videos",
            "View analytics data": "View analytics data",
            "View more": "View more",
            "VOD player URL": "VOD player URL",
            "Warning": "Warning",
            "Wearing glasses": "Wearing glasses",
            "Wed": "Wed",
            "Wednesday": "Wednesday",
            "Week": "Week",
            "Weekly": "Weekly",
            "Weeks": "Weeks",
            "Welcome": "Welcome",
            "Whitelist": "Whitelist",
            "Whitelist rules": "Whitelist rules",
            "Whitelist to request": "Whitelist to request",
            "Workflow": "Workflow",
            "Workflow Name": "Workflow Name",
            "workflow": "workflow",
            "Years old": "Years old",
            "Yes": "Yes",
            "Youtube": "Youtube",
            "Youtube syndication": "Youtube syndication",
            "Every months on": "Every months on",
            "PREPARING": "PREPARING",
            "Restrict bucket access": "Restrict bucket access",
            "Active on creation": "Active on creation",
            "ACTIVATING": "ACTIVATING",
            "INACTIVATING": "INACTIVATING",
            "Archive": "Archive",
            "Archving...": "Archving...",
            "Folder path": "Folder path",
            "No assets folder": "No assets folder",
            "Restoring...": "Restoring...",
            "Search in folder": "Search in folder",
            "Root": "Root",
            "Search results": "Search results",
            "Restoring": "Restoring",
            "Archiving": "Archiving",
            "days": "days",
            "Achived Assets": "Achived Assets",
            "Archived": "Archived",
            "Empty Archived": "Empty Archived",
            "Archived by": "Archived by",
            "Archived Period": "Archived Period",
            "Archived Assets": "Archived Assets",
            "Restored": "Restored",
            "Archive ID": "Archive ID",
            "Auto Categorization": "Auto Categorization",
            "Site access": "Site access",
            "Console": "Console",
            "File meta": "File meta",
            "Operator": "Operator",
            "Contains": "Contains",
            "Duration range": "Duration range",
            "Date range": "Date range",
            "Greater than": "Greater than",
            "Less than": "Less than",
            "OverWrite": "OverWrite",
            "Overwrite": "Overwrite",
            "Skip": "Skip",
            "OK": "OK",
            "Source name": "Source name",
            "Partial {{type}} to completed.": "Partial {{type}} to completed.",
            "Folder Upload": "Folder Upload",
            "Files Upload": "Files Upload",
            "New Folder": "New Folder",
            "Upload Files": "Upload Files",
            "References": "References",
            "사용자 설정 위젯": "User Preference Widget",
            "팀 설정 위젯": "User Group Preference Widget",
            "프로젝트 설정 위젯": "Project Preference Widget",
            "전체 기간": "Entire Period",
            "빠른 지정": "Quick select",
            "사용자 지정": "User Custom",
            "이번주": "This week",
            "이번달": "This month",
            "올해": "This Year",
            "지난 15분": "Recent 15 Min.",
            "지난 30분": "Recent 30 Min.",
            "지난 1시간": "Recent 1Hour",
            "지난 4시간": "Recent 4Hours",
            "선택됨": "Selected",
            "에 업데이트됨": "Updated at",
            "위젯 설정": "Widget Preference",
            "선택된 위젯": "Selected Widget",
            "프로젝트 설정으로 적용": "Save as project preference",
            "선 그래프": "Line Graph",
            "바 그래프": "Bar Graph",
            "동영상": "Video",
            "시청자 수": "Unique viewer",
            "시청 횟수": "View",
            "디바이스별 시청자 수 (기간)": "Viewer by device (Period)",
            "디바이스별 시청자 수 (백분율)": "Viewer by device (%)",
            "현재 시청자 수": "Concurrent Viewer",
            "누적 시청자 수": "Total Viewer",
            "누적 시청 횟수": "Total View",
            "누적 시청 시간": "Total playing Time",
            "상위 지역": "Most watched at (Region)",
            "상위 디바이스": "Most watched on (Device)",
            "VIDEOS": "VIDEOS",
            "VIEWERS": "Unique viewer",
            "WATCH_COUNT": "View",
            "DEVICE_VIEWERS_ON_TERM": "Viewer by device (Period)",
            "DEVICE_VIEWERS_ON_PERCENTAGE": "Viewer by device (%)",
            "COUNTRY_VIEWERS_ON_TERM": "Viewer by Country (Period)",
            "COUNTRY_VIEWERS_ON_PERCENTAGE": "Viewer by Country (%)",
            "REGION_VIEWERS_ON_TERM": "Viewer by Region (Period)",
            "REGION_VIEWERS_ON_PERCENTAGE": "Viewer by Region (%)",
            "CITY_VIEWERS_ON_TERM": "Viewer by city (Period)",
            "CITY_VIEWERS_ON_PERCENTAGE": "Viewer by city (%)",
            "VIEWERS_PROGRESS": "Viewer by timeline",
            "Restore": "Restore",
            "New folder": "New folder",
            "Folder": "Folder",
            "Search in {{name}}": "Search in {{name}}",
            "{{name}} View": "{{name}} View",
            "Hierarchy": "Hierarchy",
            "{{name}} Search": "{{name}} Search",
            "Confirm": "Confirm",
            "All lineups": "All lineups",
            "Repeat lineups": "Repeat lineups",
            "All Copy to": "All Copy to",
            "Date to All copy to": "Date to All copy to",
            "Daily Copy": "Daily Copy",
            "Check date to all copy to": "Check date to all copy to",
            "Available": "Available",
            "No assets category": "No assets category",
            "No videos folder": "No videos folder",
            "No videos category": "No videos category",
            "No channels category": "No channels category",
            "Create Auto Captions": "Create Auto Captions",
            "Creating Auto Caption": "Creating Auto Caption",
            "Create Auto Caption": "Create Auto Caption",
            "Default Language": "Default Language",
            "Last login": "Last login",
            "Change view": "Change view",
            "Of": "Of",
            "All approval status": "All approval status",
            "Action rules": "Action rules",
            "Delete Constraints": "Delete Constraints",
            "Copy to Constraints": "Copy to Constraints",
            "Published History": "Published History",
            "Channel Name": "Channel Name",
            "Accounts": "Accounts",
            "Account settings": "Account settings",
            "Add Accounts": "Add Accounts",
            "URL for Posting": "URL for Posting",
            "Kakaotalk": "Kakaotalk",
            "Select Accounts": "Select Accounts",
            "Go to": "Go to",
            "Expired date :": "Expired date :",
            "Timeshift": "Timeshift",
            "Sec": "sec",
            "DeleteFaceIndex": "Unindex Face",
            "ModifyFaceIndex": "Modify FaceIndex",
            "EditFaces": "Edit Faces",
            "FaceToIndex": "Face to Index",
            "FaceToUnindex": "Face to Unindex",
            "FacesIndexed": "Faces Indexed",
            "StorageClass": "Storage Class",
            "Last Modified": "Last Modified",
            "Objects": "Objects",
            "View More": "View More",
            "No buckets folder": "No buckets folder",
            "Access": "Access",
            "Manage": "Manage",
            "Source Buckets": "Source Buckets",
            "Bucket": "Bucket",
            "Custom": "Custom",
            "Header": "Header",
            "Setting": "Setting",
            "Theme": "Theme",
            "White": "White",
            "Black": "Black",
            "CI": "CI",
            "BG": "BG",
            "Color": "Color",
            "Text button": "Text Button",
            "Quick Select": "Quick Select",
            "User": "User",
            "Language Settings": "Language Settings",
            "Specific Language": "Specific Language",
            "Auto Language": "Auto Language",
            "Extension": "Extension",
            "All extensions": "All extensions",
            "Create FILE asset": "Create FILE asset",
            "Go analysis": "Go analysis",
            "Copy to": "Copy to",
            "Move": "Move",
            "All Storage Class": "All Storage Class",
            "Standard": "Standard",
            "Reduced Redundancy": "Reduced Redundancy",
            "Stanard-IA": "Stanard-IA",
            "One Zone-IA": "One Zone-IA",
            "Intelligent Tiering": "Intelligent Tiering",
            "Glacier": "Glacier",
            "Deep Archive": "Deep Archive",
            "Outposts": "Outposts",
            "Meeting": "Meeting",
            "Rooms": "Rooms",
            "Recent Schedule": "Recent Schedules",
            "out of {{total}}": "out of {{total}}",
            "Channel Overview": "Channel Overview",
            "Basic": "Basic",
            "Lock": "Lock",
            "people": "people",
            "Disabled": "Disabled",
            "Create Channel": "Create Channel",
            "Meetings": "Meetings",
            "Unlock": "Unlock",
            "Locked": "Locked",
            "All": "All",
            "Megazone Accounts": "Megazone Accounts",
            "Megazone Login": "Megazone Login",
            "Sign in with Megazone Login": "Sign in with Megazone Login",
            "or": "or",
            "Analyze by timestamp": "Analyze By Timestamp",
            "Usage Time": "Usage Time",
            "Music": "Music",
            "Photo": "Photo",
            "Audio Sources": "Audio Sources",
            "Album Images": "Album Images",
            "Teaser Images": "Teaser Images",
            "Music Videos": "Music Videos",
            "Teaser Videos": "Teaser Videos",
            "Live Videos": "Live Videos",
            "Music Description": "Music Description",
            "No musics category": "No musics category",
            "INACTIVE": "INACTIVE",
            "Update {{name}}": "Update {{name}}",
            "{{name}} Description": "{{name}} Description",
            "Share": "Share",
            "Shared Box": "Shared Box",
            "Share Box": "Shared Box",
            "Shared Date": "Shared Date",
            "Share to me": "Share to me",
            "Share by me": "Share by me",
            "Add to Shared Box": "Add to Shared Box",
            "Remove from Share Box": "Remove from Share Box",
            "Shared {{name}}": "Shared {{name}}",
            "Share Management": "Share Management",
            "Shared with Me": "Shared with Me",
            "Requested to Share": "Requested to Share",
            "Requester": "Requester",
            "Requested": "Requested",
            "Review Request": "Review Request",
            "Review Access Request": "Review Access Request",
            "Please add {{name1}} and {{name2}}.": "Please add {{name1}} and {{name2}}.",
            "Phone Number": "Phone Number",
            "Asset Sharer": "Asset Sharer",
            "Quick": "Quick",
            "Advanced": "Advanced",
            "Show": "Show",
            "{{view}} Search fields": "{{view}} Search fields",
            "Search for assets by all projects.": "Search for assets by all projects.",
            "<0>{{count}}</0> Results for your Search": "<0>{{count}}</0> Results for your Search",
            "Management": "Management",
            "Assets to be shared": "Assets to be shared",
            "Please add {{name}}.": "Please add {{name}}.",
            "Image Viewer": "Image Viewer",
            "Images Viewer": "Images Viewer",
            "Result of <0>{{name}}</0>": "Result of <0>{{name}}</0>",
            "Download Link": "Download Link",
            "Elements": "Elements",
            "This download link URL is only available for one week from now.": "This download link URL is only available for one week from now.",
            "Preparing download link URL": "Preparing download link URL",
            "No Images List": "No Images List",
            "File Meta": "File Meta",
            "Operation": "Operation",
            "Versions": "Versions",
            "Version": "Version",
            "My Activity": "My Activity",
            "Current Version": "Current Version",
            "Share Management Rules": "Share Management Rules",
            "Users and groups belonging to the project for the selected asset are excluded from sharing.": "Users and groups belonging to the project for the selected asset are excluded from sharing.",
            "Search for assets in this project.": "Search for assets in this project.",
            "Recent People": "Recent People",
            "Recent Music": "Recent Music",
            "Recent Photos": "Recent Photos",
            "Recent Photo": "Recent Photo",
            "Reason for sharing request (Optional)": "Reason for sharing request (Optional)",
            "Request Access": "Request Access",
            "Display Name": "Display Name",
            "Department": "Department",
            "results": "results",
            "Sharer": "Sharer",
            "Shared": "Shared",
            "Last Login": "Last Login",
            "Spec": "Spec",
            "Asset’s Project": "Asset’s Project",
            "All Projects": "All Projects",
            "All Users": "All Users",
            "Only mine": "Only mine",
            "Rename": "Rename",
            "Moving": "Moving",
            "Copying to": "Copying to",
            "Deleting": "Deleting",
            "Renaming": "Renaming",
            "{{type}} completed.": "{{type}} completed.",
            "Partial {{type}} completed.": "Partial {{type}} completed.",
            "{{type}} canceled.": "{{type}} canceled.",
            "{{type}} error.": "{{type}} error.",
            "Overwrite or skip file": "Overwrite or skip file",
            "Pending {{type}}...": "Pending {{type}}...",
            "Ask": "Ask",
            "Always Overwrite": "Always Overwrite",
            "Always Skips": "Always Skips",
            "Handling in case of duplicate files": "Handling in case of duplicate files",
            "Apply to all": "Apply to all",
            "Shares": "Shares",
            "Accessible Projects": "Accessible Projects",
            "Recent Videos": "Recent Videos",
            "Recent Assets Shared with Me": "Recent Assets Shared with Me",
            "Search all assets": "Search all Assets",
            "Search assets": "Search assets",
            "Add Users and Teams": "Add Users and Teams",
            "Project Settings": "Project Settings",
            "Back to Console": "Back to Console",
            "No related assets": "No related assets",
            "No reference": "No reference",
            "My Assets": "My Assets",
            "Group": "Group",
            "Group ID": "Group ID",
            "Groups": "Groups",
            "No Groups": "No Groups",
            "Add groups": "Add groups",
            "Add Users and Groups": "Add Users and Groups",
            "Enter Users and Groups": "Enter Users and Groups",
            "Assets shared with the group are not deleted": "Assets shared with the group are not deleted",
            "Group overview": "Group overview",
            "Selected files": "Selected files",
            "Create by Transcoding": "Create by Transcoding",
            "Create as Assets": "Create as Assets",
            "ItemSet for Metadata": "ItemSet for Metadata",
            "ItemSet": "ItemSet",
            "Items": "Items",
            "Multiple": "Multiple",
            "Storage": "Storage",
            "CaptionSync": "CaptionSync",
            "Fast": "Fast",
            "Slow": "Slow",
            "No Time Change": "No Time Change",
            "Time Control": "Time Control",
            "No captions": "No captions",
            "Edit Captions": "Edit Captions",
            "sec": "sec",
            "Interactive Video": "Interactive Video",
            "Interactive Videos": "Interactive Videos",
            "Open Chatting": "Open Chatting",
            "Group Chatting": "Group Chatting",
            "Add Attendees": "Add Attendees",
            "Recording": "Recoding",
            "Ending Video": "Ending Video",
            "msec": "msec",
            "Enter Email Address": "Enter Email Address",
            "Intro Video URL": "Intro Video URL",
            "Ending Video URL": "Ending Video URL",
            "Empty Recording History": "Empty Recording History",
            "Recording History": "Recording History",
            "Recording Time": "Recording Time",
            "Intro Videos": "Intro Videos",
            "Ending Videos": "Ending Videos",
            "No Schedule": "No Schedule",
            "Input file upload error": "Input file upload error",
            "Input file preprocessing error": "Input file preprocessing error",
            "MediaConvert transcoding error": "MediaConvert transcoding error",
            "Input file post processing error": "Input file post processing error",
            "Console first entry screen": "Console first entry screen",
            "Add attendees to join the Group Chatting": "Add attendees to join the Group Chatting",
            "Add attendees": "Add attendees",
            "Schedule Name": "Schedule Name",
            "Schedule Time": "Schedule Time",
            "Channel type": "Channel type",
            "Video latency": "Video latency",
            "Playback authorization": "Playback authorization",
            "Standard latency": "Standard latency",
            "Ultra-low latency": "Ultra-low latency",
            "Amazon IVS": "Amazon IVS",
            "Amazon Chime": "Amazon Chime",
            "Playback": "Playback",
            "Recordings": "Recordings",
            "Recorded Videos": "Recorded Videos",
            "Event Time": "Event Time",
            "Storage Path": "Storage Path",
            "Change after channel creation": "Change after channel creation",
            "Create Assets on creation": "Create Assets on creation",
            "Manage Access": "Manage Access",
            "Search with subcategories": "Search with subcategories",
            "Service Provider": "Service Provider",
            "Sync complete": "Sync complete",
            "Sync failed": "Sync failed",
            "Synchronizing": "Synchronizing",
            "Sync refresh": "Sync refresh",
            "Projects Allowed To Use": "Projects Allowed To Use",
            "SPACE ADMINISTRATION": "SPACE ADMINISTRATION",
            "CloudPlex Delivery": "CloudPlex Delivery",
            "CloudPlex Start": "CloudPlex Start",
            "Switch to Admin": "Switch to Admin",
            "Add User": "Add User",
            "UserName": "UserName",
            "Last Access": "Last Access",
            "Add teaser images": "Add Teaser Images",
            "out of": "out of ",
            "Indexed Faces": " Indexed Faces",
            "Products": "Products",
            "Customer Service": "Customer Service",
            "Invitation Pending": "Invitation Pending",
            "Has Space Access": "Has Space Access",
            "No Space Access": "No Space Access",
            "Member": "Member",
            "Trusted": "Trusted",
            "No role": "No role",
            "Revoke space access": "Revoke space access",
            "Last Name": "Last Name",
            "First Name": "First Name",
            "Phone number": "Phone number",
            "Company": "Company",
            "Position": "Position",
            "’s Detail": "’s Detail",
            "Has access on Space": "Has access on Space",
            "Administrator": "Administrator",
            "Any role": "Any role",
            "Last Activity": "Last Activity",
            "Grant space access": "Grant space access",
            "Remove user": "Remove user",
            "Add {{number}} users": "Add {{number}} users",
            "Add user": "Add user",
            "Add attribute": "Add attribute",
            "Next": "Next",
            "Photos": "Photos",
            "Zoom in": "Zoom in",
            "Zoom out": "Zoom out",
            "Previous": "Previous",
            "Compressing": "Compressing",
            "Ready to {{type}}": "Ready to {{type}}",
            "Select Files": "Select Files",
            "Edit Default Metadata": "Edit Default Metadata",
            "Edit and Create Assets": "Edit and Create Assets",
            "Create assets": "Create assets",
            "create assets": "create assets",
            "Create Assets": "Create Assets",
            "assets": "assets",
            "Asset creation": "Asset creation",
            "Create Assets Bulk": "Create Assets Bulk",
            "Selected Files": "Selected Files",
            "Edit Metadata": "Edit Metadata",
            "APPLY ALL OVER Options": "APPLY ALL OVER Options",
            "Apply All Over": "Apply All Over",
            "Set as Options": "Set as Options",
            "Asset Name Alias": "Asset Name Alias",
            "Choose Bulk Operation": "Choose Bulk Operation",
            "Asset Type": "Asset Type",
            "Asset Composition Type": "Asset Composition Type",
            "Set to Default": "Set to Default",
            "Preparing {{type}}...": "Preparing {{type}}...",
            "Add Files to Bulk": "Add Files to Bulk",
            "Choose Files": "Choose Files",
            "A total of <0> {{number}} </0> files can be added.": "A total of <0> {{number}} </0> files can be added.",
            "Add All": "Add All",
            "If a file is changed or deleted from the storage list": "If a file is changed or deleted from the storage list",
            "Asset Composition Types": "Asset Composition Types",
            "Auto-apply language & labels": "Auto-apply language & labels",
            "Ex": "Ex",
            "Single Asset": "Single Asset",
            "Multiple Asset": "Multiple Asset",
            "Filters": "Filters",
            "Add Assets": "Add Assets",
            "No Files": "No Files",
            "Caption Type Asset Creation Rules": "Caption Type Asset Creation Rules",
            "Language & Label": "Language & Label",
            "If there is a language code after the file name (_)": "If there is a language code after the file name (_)",
            "If there is no language code after the file name (_)": "If there is no language code after the file name (_)",
            "Add <0> {{number}} </0> file(s)": "Add <0> {{number}} </0> file(s)",
            "Ready": "Ready",
            "In Progress": "In Progress",
            "FAILED": "Failed",
            "NOT_SUPPORTED": "Unsupported",
            "PARTIAL_COMPLETED": "Partially completed",
            "Video and image content analysis": "Video and image content analysis",
            "Metadata analysis": "Metadata analysis",
            "AI search mode indexing": "AI search mode indexing",
            "AI search indexing status": "AI search indexing status",
            "AI search mode": "AI search mode",
            "Indexing status": "Indexing status",
            "Request to Create Assets": "Request to Create Assets",
            "In Order of Accuracy": "In Order of Accuracy",
            "Latest Order": "Latest Order",
            "Only Mine": "Only Mine",
            "Other then Mine": "Other then Mine",
            "Detailed Filter": "Detailed Filter",
            "Storage Class": "Storage Class",
            "Search for storage and assets by all projects.": "Search for storage and assets by all projects.",
            "Please enter your search term": "Please enter your search term",
            "Please check the search term you entered again.": "Please check the search term you entered again.",
            "All Buckets": "All Buckets",
            "Only My Buckets": "Only My Buckets",
            "Other Buckets": "Other Buckets",
            "Only My Projects": "Only My Projects",
            "Other Projects": "Other Projects",
            "No results were found for your search.": "No results were found for your search.",
            "Please re-enter your search term.": "Please re-enter your search term.",
            "Please enter your search term.": "Please enter your search term.",
            "Select Bucket": "Select Bucket",
            "Choose the bucket you want to use.": "Choose the bucket you want to use.",
            "Current Project": "Current Project",
            "Accessible": "Accessible",
            "Not Accessible": "Not Accessible",
            "Current": "Current",
            "Project other than this one": "Project other than this one",
            "Use of features based on access": "Use of features based on access",
            "All functions available": "All functions available",
            "All functions unavailable": "All functions unavailable",
            "Partial functions unavailable": "Partial functions unavailable",
            "Folder path to check": "Folder path to check",
            "Current project": "Current project",
            "Switch Project": "Switch Project",
            "Project to switch to": "Project to switch to",
            "Add users and teams to share": "Add users and teams to share",
            "Link Setting": "Link Setting",
            "Password": "Password",
            "Link": "Link",
            "download link URL": "download link URL",
            "Download Period": "Download Period",
            "Number of Downloads": "Number of Downloads",
            "Files to share": "Files to share",
            "The files to download are ready.": "The files to download are ready.",
            "The number of password errors has been exceeded.": "The number of password errors has been exceeded.",
            "The download period of times has expired.": "The download period of times has expired.",
            "The download number of times has expired.": "The download number of times has expired.",
            "The page not found.": "The page not found.",
            "Enter your Password": "Enter your Password",
            "Show Password": "Show Password",
            "Enter {{name}}": "Enter {{name}}",
            "Done": "Done",
            "Enter Name": "Enter Name",
            "Share Link": "Share Link",
            "Share Request": "Share Request",
            "Choose One Approver": "Choose One Approver",
            "File to request": "File to request",
            "Send request": "Send request",
            "Expires At": "Expires At",
            "History of my request to share": "History of my request to share",
            "History of requests to share": "History of requests to share",
            "Previous Request": "Previous Request",
            "Linked Requests": "Linked Requests",
            "Shared History": "Shared History",
            "Permission": "Permission",
            "Reason for Approval (Optional)": "Reason for Approval (Optional)",
            "Reason for Reject (Optional)": "Reason for Reject (Optional)",
            "Select User": "Select User",
            "Canceled": "Canceled",
            "Shared by me": "Shared by me",
            "Shared with me": "Shared with me",
            "Shared with": "Shared with",
            "Revoke": "Revoke",
            "Revoked": "Revoked",
            "Revoke access": "Revoke access",
            "Revoke link": "Revoke link",
            "File to be shared": "File to be shared",
            "By last shared": "By last shared",
            "By last modified": "By last modified",
            "By name": "By name",
            "By type": "By type",
            "Removed": "Removed",
            "Manage shared with": "Manage shared with",
            "Send email with password": "Send email with password",
            "Include": "Include",
            "Not Include": "Not Include",
            "Request expired": "Request expired",
            "Shared by": "Shared by",
            "Share Expires Date": "Share Expires Date",
            "Create Videos": "Create Videos",
            "Create People": "Create People",
            "Create Music": "Create Music",
            "Create Photo": "Create Photo",
            "Folder Path": "Folder Path",
            "Select Folder Path": "Select Folder Path",
            "Folder View": "Folder View",
            "Category View": "Category View",
            "View All": "View All",
            "Zendesk Widget": "Zendesk Widget",
            "Widget": "Widget",
            "Widget Settings": "Widget Settings",
            "Zendesk Settings": "Zendesk Settings",
            "Zendesk Domain": "Zendesk Domain",
            "API Token": "API Token",
            "Locale": "Locale",
            "Page URL": "Page URL",
            "Show API Token": "Show API Token",
            "Section ID": "Section ID",
            "Topic ID": "Topic ID",
            "Minimum Image Size": "Minimum Image Size",
            "Metadata Template": "Metadata Template",
            "Name Prefix": "Name Prefix",
            "Metadata Preset": "Metadata Preset",
            "Metadata Name Prefix": "Metadata Name Prefix",
            "Metadata Template Name": "Metadata Template Name",
            "Metadata Template Description": "Metadata Template Description",
            "Select Metadata Template": "Select Metadata Template",
            "Asset Name Prefix": "Asset Name Prefix",
            "Folder Path Option": "Folder Path Option",
            "Save assets to the top-level path on the drive": "Save assets to the top-level path on the drive",
            "Save assets according to the storage folder path": "Save assets according to the storage folder path",
            "Save assets to the selected folder": "Save assets to the selected folder",
            "Asset to share": "Asset to share",
            "Message": "Message",
            "Message (Optional)": "Message (Optional)",
            "Send": "Send",
            "Add Users": "Add Users",
            "Pending changes": "Pending changes",
            "Access Updated": "Access Updated",
            "<0> {{number}} </0> days": "<0> {{number}} </0> days",
            "<0/> times": "<0/> times",
            "Search Category Group": "Search Category Group",
            "Discard": "Discard",
            "In Use": "In Use",
            "Not Used": "Not Used",
            "No Assets Folders": "No Assets Folders",
            "Select Category Group": "Select Category Group",
            "File to share": "File to share",
            "Clear All": "Clear All",
            "Grouping View mode": "Grouping View mode",
            "View All mode": "View All mode",
            "Archived ID": "Archived ID",
            "Requested At": "Requested",
            "Subject": "Subject",
            "Approval Status": "Approval Status",
            "Status Updated": "Status Updated",
            "Shared History Action": "Action",
            "Approver": "Approver",
            "Sharehistory": "Shared History",
            "Sharebox": "Shared Box",
            "Internal Share": "Internal Share",
            "External Share": "External Share",
            "asset creation": "asset creation",
            "Creating asset...": "creating asset...",
            "No {{type}} Categories": "No {{type}} Categories",
            "Delete the asset?": "Delete the asset?",
            "Apply All": "Apply All",
            "Delete the item?": "Delete the item?",
            "Move the item?": "Move the item?",
            "Move these items?": "Move these items?",
            "Location": "Location",
            "Specify Here": "Specify Here",
            "Dimensions": "Dimensions",
            "Asset Created": "Asset Created",
            "History of my internal share requests": "History of my internal share requests",
            "History of internal sharing requests to me": "History of internal sharing requests to me",
            "History of my external sharing": "History of my external sharing",
            "No list": "No list",
            "Restore the item?": "Restore the item?",
            "Change Restore Option": "Change Restore Option",
            "Users shared with": "Users shared with",
            "Status of ready": "Status of ready",
            "Expiration Date": "Expiration Date",
            "Mail Language Settings": "Mail Language Settings",
            "Items Shared": "Items Shared",
            "Histories": "Histories",
            "Shared Histories": "Shared Histories",
            "Search owner": "Search owner",
            "Search extension": "Search extension",
            "Search type": "Search type",
            "Search filter": "Search filter",
            "Search status": "Search status",
            "History of external share": "History of external share",
            "Calulating...": "Calulating...",
            "Asset Details": "Asset_Details",
            "Asset Search Results": "Asset Search Results",
            "API Endpoint": "API Endpoint",
            "USED": "USED",
            "UNUSED": "UNUSED",
            "Archive after adding assets": "Archive after adding assets",
            "Moving to CloudPlex Assets": "Moving to CloudPlex Assets",
            "Download All": "Download All",
            "Starred": "Starred",
            "Hi, {{name}}": "Hi, {{name}}",
            "Switch to": "Switch to",
            "Add to Starred": "Add to Starred",
            "Remove from Starred": "Remove from Starred",
            "Column Settings": "Column Settings",
            "Sort in descending order": "Sort in descending order",
            "Sort in ascending order": "Sort in ascending order",
            "Project Name": "Project Name",
            "Project Lead": "Project Lead",
            "Sort by": "Sort by",
            "by name": "by name",
            "by most recent": "by most recent",
            "by update": "by update",
            "Last Updated": "Last Updated",
            "Hide all": "Hide all",
            "CPA_ARCHIVED": "ARCHIVED",
            "CPA_ARCHIVING": "ARCHIVING",
            "CPA_RESTORING": "RESTORING",
            "CPA_ERROR": "ERROR",
            "PUBLIC": "PUBLIC",
            "PRIVATE": "PRIVATE",
            "Add Project": "Add Project",
            "Grid Layout": "Grid Layout",
            "List Layout": "List Layout",
            "Lead": "Lead",
            "View all Projects": "View all Projects",
            "Project unassigned": "Project unassigned",
            "Replace Asset": "Replace Asset",
            "Set lockout for other users": "Set lockout for other users",
            "locked by": "locked by",
            "Me": "Me",
            "Locked by": "Locked by",
            "locked by '{{name}}({{username}})'": "locked by '{{name}}({{username}})'",
            "locked by 'Me'": "locked by 'Me'",
            "Automatic Bucket Lock Options": "Automatic Bucket Lock Options",
            "Auto-Lock Enabled": "Auto-Lock Enabled",
            "Size of files Option": "Size of files Option",
            "Size of files": "Size of files",
            "Number of files": "Number of files",
            "Number of files Option": "Number of files Option",
            "Default Archive Option": "Default Archive Option",
            "Allow customization when archiving": "Allow customization when archiving",
            "Default Restore Options": "Default Restore Options",
            "Archive Option": "Archive Option",
            "Restore Option": "Restore Option",
            "Back to Project": "Back to Project",
            "Archive the item?": "Archive the item?",
            "Archive items?": "Archive items?",
            "Restore items?": "Restore items?",
            "files": "files",
            "CPD Integrations": "CPD Integrations",
            "Credentials Information": "Credentials Information",
            "CloudPlex Delivery Information": "CloudPlex Delivery Information",
            "Switch Admin": "Switch Admin",
            "Space List": "Space List",
            "App Download": "App Download",
            "REQUEST_ARCHIVE": "REQUEST_ARCHIVE",
            "REQUEST_RESTORE": "REQUEST_RESTORE",
            "ARCHIVE_ERROR": "ARCHIVE_ERROR",
            "RESTORE_ERROR": "RESTORE_ERROR",
            "RESTORED": "RESTORED",
            "ARCHIVING": "ARCHIVING",
            "ARCHIVED": "ARCHIVED",
            "RESTORING": "RESTORING",
            "Add Collection": "Add Collection",
            "Collections": "Collections",
            "Assets Count": "Assets Count",
            "Collection Details": "Collection Details",
            "Collection ID": "Collection ID",
            "Linked Collections": "Linked Collections",
            "All Media Types": "All Media Types",
            "Specify the folder location?": "Specify the folder location?",
            "Select assets through search": "Select assets through search",
            "Select assets in a specific folder?": "Select assets in a specific folder?",
            "Select assets in a specific folder": "Select assets in a specific folder",
            "Selected Assets": "Selected Assets",
            "max": "max",
            "Also include assets from subfolders": "Also include assets from subfolders",
            "Only assets in that folder are selected": "Only assets in that folder are selected",
            "Selected a Folder": "Selected a Folder",
            "Selected Collections": "Selected Collections",
            "Add assets?": "Add assets?",
            "Collections Search Results": "Collections Search Results",
            "Enter ID": "Enter ID",
            "Enter the creator": "Enter the creator",
            "Enter the person who modified it": "Enter the person who modified it",
            "Enter name": "Enter name",
            "Collection": "Collection",
            "Specify the collection?": "Specify the collection?",
            "Assets to be created can be managed by applying them to a specific collection.": "Assets to be created can be managed by applying them to a specific collection.",
            "Specify the folder where the assets will be located. If not specified, it will be saved in the top path.": "Specify the folder where the assets will be located. If not specified, it will be saved in the top path.",
            "Duplicate": "Duplicate",
            "Add Fields": "Add Fields",
            "Metadata Fields": "Metadata Fields",
            "Reference Fields": "Reference Fields",
            "Hidden": "Hidden",
            "Fields": "Fields",
            "Enter default text": "Enter default text",
            "Enter default number": "Enter default number",
            "Required": "Required",
            "Create Content Schema": "Create Content Schema",
            "Content Schemas": "Content Schemas",
            "Details": "Details",
            "Search for the project name.": "Search for the project name.",
            "Fields Search": "Fields Search",
            "No Metadata Fields yet.": "No Metadata Fields yet.",
            "No Reference Fields yet.": "No Reference Fields yet.",
            "Custom Fields": "Custom Fields",
            "No {{isReference}} Fields yet.": "No {{isReference}} Fields yet.",
            "Enter field name": "Enter field name",
            " {{name}}": " {{name}}",
            " '{{name}}' and <emp>{{count}}</emp> others": " '{{name}}' and <emp>{{count}}</emp> others",
            "Select type": "Select type",
            "Select status": "Select status",
            "Remove the item?": "Remove the item?",
            "Remove items?": "Remove items?",
            "Delete items?": "Delete items?",
            "Archiving asset...": "archiving asset...",
            "Restoring asset...": "restoring asset...",
            "Create {{schemaName}}": "Create {{schemaName}}",
            "Selected Image": "Selected Image",
            "Selected {{referenceType}}": "Selected {{referenceType}}",
            "Enter text": "Enter text",
            "Enter number": "Enter number",
            "No {{name}} yet.": "No {{name}} yet.",
            "Enter description": "Enter description",
            "Engine to Use": "Engine to Use",
            "Service Type": "Service Type",
            "Auto Language (<Strong>{{n}}</Strong>/max. {{max}})": "Auto Language (<Strong>{{n}}</Strong>/max. {{max}})",
            "Vocabulary Book": "Vocabulary Book",
            "Select Vocabulary Book": "Select Vocabulary Book",
            "Not Selected": "Not Selected",
            "Select Default Language": "Select Default Language",
            "Go to vocabulary book": "Go to vocabulary book",
            "Speaker Classification": "Speaker Classification",
            "Enter Label": "Enter Label",
            "Enter Asset name": "Enter Asset name",
            "Sounds Like": "Sounds Like",
            "Display As": "Display As",
            "Add Vocabulary": "Add Vocabulary",
            "Enter Display As": "Enter Display As",
            "Enter Sounds Like (Enter after typing)": "Enter Sounds Like (Enter after typing)",
            "Credentials": "Credentials",
            "Engines": "Engines",
            "Available in Auto Captions.": "Available in Auto Captions.",
            "Before input": "Before input",
            "Typing": "Typing",
            "Editing": "Editing",
            "Input complete": "Input complete",
            "Assets > Video Asset Detail > Related Assets": "Assets > Video Asset Detail > Related Assets",
            "Contents > Videos Detail > Captions > Auto Captions": "Contents > Videos Detail > Captions > Auto Captions",
            "Additional informations": "Additional informations",
            "Auto caption": "Auto caption",
            "Console Default Language": "Console Default Language",
            "List Default Layout": "List Default Layout",
            "Additional AI analysis": "Additional analysis",
            "View timestamps": "View timestamps",
            "Start AI analysis": "Start AI analysis",
            "AI analysis completed": "AI analysis completed",
            "AI Analysis": "AI Analysis",
            "Added to Check timestamp": "Added to 'Check timestamp'",
            "Removed from Check timestamp": "Removed from 'Check timestamp'",
            "Removed from Metadata tags": "Removed from 'Metadata tags'",
            "Added to Metadata tags": "Added to 'Metadata tags'",
            "Engine": "Engine",
            "Summary analysis result": "Summary analysis result",
            "Original analysis result": "Original analysis result",
            "Top 10 most exposed labels": "Top 10 most exposed labels",
            "Exposure Point (First / Last)": "Exposure Point (First / Last)",
            "Label detection in Video": "Label detection in Video",
            "Recognize Faces in Video": "Recognize Faces in Video",
            "Recognize Celebrity in Video": "Recognize Celebrity in Video",
            "Content Moderation in Video": "Content Moderation in Video",
            "Video transcription": "Video transcription",
            "Long audio transcription": "Long audio transcription",
            "Annotate Scenes in Video": "Annotate Scenes in Video",
            "Recognize Texts in Video": "Recognize Texts in Video",
            "Avg. Confidence (%)": "Avg. Confidence (%)",
            "Timestamp - Start": "Timestamp - Start",
            "Timestamp - End": "Timestamp - End",
            "Analysis result {{number}}": "Analysis result {{number}}",
            "Auto Detected": "Auto Detected",
            "Check timestamp for each label": "Check timestamp for each label",
            "View Details": "View Details",
            "Fold": "Fold",
            "Expand": "Expand",
            "point of initial exposure": "point of initial exposure",
            "last exposure point": "last exposure point",
            "Update Asset": "Update Asset",
            "Reply to thread": "Reply to thread",
            "Edit message": "Edit message",
            "Add reaction": "Add reaction",
            "Delete message": "Delete message",
            "{{commentCount}} replies": "{{commentCount}} replies",
            "See all replies": "See all replies",
            "replies": "replies",
            "Thread": "Thread",
            "Reply": "Reply",
            "Replied to :": "Replied to :",
            "Please enter your message.": "Please enter your message.",
            "Yesterday": "Yesterday",
            "member of comment": "member of comment",
            "Change name": "Change name",
            "Private comment name (maximum <0>{{count}}</0> characters)": "Private comment name (maximum <0>{{count}}</0> characters)",
            "Add member": "Add member",
            "Delete private comment": "Delete private comment",
            "All public": "All public",
            "member": "member",
            "Check": "Check",
            "Private comment name": "Private comment name",
            "Comments where I was mentioned": "Comments where I was mentioned",
            "Comments written by me": "Comments written by me",
            "Comments in threads I belong to": "Comments in threads I belong to",
            "Reply to my comment": "Reply to my comment",
            "My Comments": "My Comments",
            "Waiting for invitation": "Waiting for invitation",
            "User invitation": "User invitation",
            "Would you like to invite users?": "Would you like to invite users?",
            "Invite": "Invite",
            "Accessible project": "Accessible project",
            "Invitation date": "Invitation date",
            "Pending Invitation": "Pending Invitation",
            "User waiting to be invited": "User waiting to be invited",
            "Projects you want to allow access to": "Projects you want to allow access to",
            "Create Roles": "Create Roles",
            "Manual settings": "Manual settings",
            "Auto settings": "Auto settings",
            "ROLES_Read": "Read Permission",
            "ROLES_Edit": "Edit Permission",
            "ROLES_Archive": "Archive Permission",
            "ROLES_Download": "Download Permission",
            "ROLES_Internal": "Internal Share Permission",
            "ROLES_External": "Internal・External Share Permission",
            "ROLES_Publish": "Publish Permission",
            "ROLES_Internal Request": "Internal Request Permission",
            "Custom Metadata": "Custom Metadata",
            "Select Content Schema": "Select Content Schema",
            "Search by content schema name.": "Search by content schema name.",
            "Selected schema": "Selected schema",
            "Accessed": "Accessed",
            "CreatedAt": "Created",
            "Add Users or Groups": "Add Users or Groups",
            "Share Settings": "Share Settings",
            "Add to Added Users": "Add to Added Users",
            "Maximum": "Maximum",
            "times": "times",
            "Current location": "Current location",
            "Where to clone": "Where to clone",
            "Save to top path": "Save to top path",
            "Parent folder": "Parent folder",
            "Parent folder location": "Parent folder location",
            "Select file": "Select file",
            "Unapply": "Unapply",
            "Undo add": "Undo add",
            "Clear": "Clear",
            "Choose one custom data.": "Choose one custom data.",
            "Folder Duplication": "Folder Duplication",
            "Duplication target folder": "Duplication target folder",
            "Asset to be duplicated": "Asset to be duplicated",
            "Request share": "Request share",
            "Share link": "Share link",
            "Downloader Permission Settings": "Downloader Permission Settings",
            "Sharing Period": "Sharing Period",
            "Related Assets": "Related Assets",
            "Linked Assets": "Linked Assets",
            "Remove Asset": "Remove Asset",
            "Add Linked Assets?": "Add Linked Assets?",
            "Menu Display": "Menu Display",
            "info": "info",
            "Specify Folder Location": "Specify Folder Location",
            "Select by Recent Location": "Select by Recent Location",
            "Create a private comment": "Create a private comment",
            "Open comment window": "Open comment window",
            "Close comment window": "Close comment window",
            "Specify Collection": "Specify Collection",
            "Moving to CloudPlex Media…": "Moving to CloudPlex Media…",
            "edited": "edited",
            "Uploading files": "Uploading files",
            "Cancel Upload": "Cancel Upload",
            "Attach Files": "Attach Files",
            "Mention": "Mention",
            "Attach Emoji": "Attach Emoji",
            "Files cannot be attached.": "Files cannot be attached.",
            "Asset Duplication": "Asset Duplication",
            "Please search by folder name": "Please search by folder name",
            "Added Users": "Added Users",
            "Custom Content": "Custom Content",
            "Storages": "Storages",
            "Custom Contents": "Custom Contents",
            "All categories": "All categories",
            "Default Custom Metadata": "Default Custom Metadata",
            "Default View Mode": "Default View Mode",
            "List view": "List view",
            "Folder view": "Folder view",
            "Category view": "Category view",
            "Select default metadata template": "Select default metadata template",
            "Select default custom metadata": "Select default custom metadata",
            "Please enter a message for your request (Optional)": "Please enter a message for your request (Optional)",
            "Enter name or email": "Enter name or email",
            "Duplicate this role?": "Duplicate this role?",
            "Change Name": "Change Name",
            "Enter required values": "Enter required values",
            "Select Custom Metadata": "Select Custom Metadata",
            "Select custom metadata": "Select custom metadata",
            "Duplicate within a subfolder": "Duplicate within a subfolder",
            "Duplication target assets": "Duplication target assets",
            "Asset to be copied": "Asset to be copied",
            "Create assets from all files individually": "Create assets from all files individually",
            "Creating image and caption files as one asset": "Creating image and caption files as one asset",
            "Please select files to add": "Please select files to add",
            "Select all files": "Select all files",
            "InteractiveVideos": "Interactive Videos",
            "and <emp>{{count}}</emp> others": "and <emp>{{count}}</emp> others",
            "Asset Bulk Create": "Asset Bulk Create",
            "An error occurred while preparing the asset for {{type}}.": "An error occurred while preparing the asset for {{type}}.",
            "Transcode in progress": "Transcode in progress",
            "Transcode has been cancelled.": "Transcode has been cancelled.",
            "Transcode completed.": "Transcode completed.",
            "An error occurred while transcoding.": "An error occurred while transcoding.",
            "Asset Duplicate": "Asset Duplicate",
            "Asset Jobs": "Asset Jobs",
            "Source Jobs": "Source Jobs",
            "Change Menu Name": "Change Menu Name",
            "Default menu name": "Default menu name",
            "Menu name to change": "Menu name to change",
            "Apply as default menu name": "Apply as default menu name",
            "History of share link": "History of share link",
            "Select collections in a specific folder?": "Select collections in a specific folder?",
            "Delete Group": "Delete Group",
            "COPY_ASSETS": "Duplicate Assets",
            "UPLOAD_ASSET": "Asset Create",
            "CREATE_ASSETS": "Asset Bulk Create",
            "UPLOAD": "Upload Files",
            "ASSET_DOWNLOAD": "Asset Download",
            "STORAGE_DOWNLOAD": "Storage Download",
            "Create Asset": "Create Asset",
            "Asset Download": "Asset Download",
            "Storage Download": "Storage Download",
            "TRANSCODE": "Trasncode",
            "COPY": "Copy",
            "RENAME": "Rename",
            "REMOVE": "Remove",
            "DELETE": "Delete",
            "Replication location": "Replication location",
            "existing location": "existing location",
            "Copy assets": "Copy assets",
            "Drag files here": "Drag files here",
            "Browse": "browse",
            "drop your files to upload": "drop your files to upload",
            "Downloader": "Downloader",
            "Viewer": "Viewer",
            "Adjust": "Adjust",
            "Back to list": "Back to list",
            "Back to comments": "Back to comments",
            "View private comments": "View private comments",
            "Close private comments": "Close private comments",
            "Select project": "Select project",
            "Role settings": "Role settings",
            "All projects": "All projects",
            "Comments": "Comments",
            "Folders": "Folders",
            "Integrated Search": "Integrated Search",
            "Users & Groups": "Users & Groups",
            "Project In Use": "Project In Use",
            "Manage Account": "Manage Account",
            "Log out": "Log out",
            "Sub menu": "Sub menu",
            "Storage files": "Storage files",
            "Please enter a description of the asset.": "Please enter a description of the asset.",
            "Create Role": "Create Role",
            "Create Workflow": "Create Workflow",
            "Comment": "Comment",
            "Specific": "Specific",
            "Go to space list": "Go to space list",
            "Bold": "Bold",
            "Underline": "Underline",
            "Strikethrough": "Strikethrough",
            "Share request": "Share request",
            "contents": "contents",
            "collections": "collections",
            "preview images": "preview images",
            "Add {{name}}?": "Add {{name}}?",
            "User invited to group": "User invited to group",
            "Space Admin": "Space Admin",
            "Project Admin": "Project Admin",
            "Recent Assets Shared To Me": "Recent Assets Shared to Me",
            "Recent Assets": "Recent Assets",
            "archive assets": "archive assets",
            "ARCHIVE_ASSETS": "Asset Archive",
            "An error occurred while preparing {{type}}.": "An error occurred while preparing {{type}}.",
            "Preparing {{type}}": "Preparing {{type}}",
            "{{type}} in progress": "{{type}} in progress",
            "Metadata Export": "Metadata Export",
            "Completed At": "Completed At",
            "PROCESSING": "PROCESSING",
            "search options": "search options",
            "Export": "Export",
            "Asset creation period": "Asset creation period",
            "COMPLETED": "Completed",
            "Created At": "Created At",
            "Updated At": "Updated At",
            "Project count": "Project count",
            "Additional items": "Additional items",
            "Make": "Make",
            "Export metadata": "Export metadata",
            "Name setting": "Name setting",
            "Selected projects": "Selected projects",
            "Asset creation date": "Asset creation date",
            "Directly assigned": "Directly assigned",
            "Create Collection": "Create Collection",
            "Select scope": "Select scope",
            "METADATA_DOWNLOAD": "Metadata Download",
            "Metadata download": "Metadata download",
            "Vocabulary": "Vocabulary",
            "Assets Name": "Assets Name",
            "Assets ID": "Assets ID",
            "Preview Settings": "Preview Settings",
            "Assets to share": "Assets to share",
            "Collections to share": "Collections to share",
            "Folder to share": "Folder to share",
            "Archive assets": "Archive assets",
            "COLLECTION_DOWNLOAD": "Collection download",
            "collection download": "Collection download",
            "Event occurrence date and time": "Event occurrence date and time",
            "Domain": "Domain",
            "Admin Audit Logs": "Admin Audit Logs",
            "Audit log details": "Audit log details",
            "User Agent": "User Agent",
            "Select domain": "Select domain",
            "Select action": "Select action",
            "Select requestedBy": "Select user",
            "Publishing options": "Publishing options",
            "Player ControlBar Control": "Player ControlBar Control",
            "Start the Player Fullscreen": "Start the Player Fullscreen",
            "Continue after Stopping the Player": "Continue after Stopping the Player",
            "Video Download": "Video Download",
            "Embed code options": "Embed code options",
            "Player Width": "Player Width",
            "Auto Play": "Auto Play",
            "Loop Play": "Loop Play",
            "Play directly with the player within the web page": "Play directly with the player within the web page",
            "Copied": "Copied",
            "Open in new window": "Open in new window",
            "Add Vocabulary Book": "Add Vocabulary Book",
            "Vocabulary Book ID": "Vocabulary Book ID",
            "Shrink": "Shrink",
            "Example": "Example",
            "1024px or 100%": "1024px or 100%",
            "Publishing": "Publishing",
            "Reclaiming": "Reclaiming",
            "Published": "Published",
            "Unpublished": "Unpublished",
            "Enter ResourceId": "Enter resource ID",
            "Enter ThreadResourceId": "Enter resource ID",
            "Select projects": "Select projects",
            "ResourceId": "Resource ID",
            "ThreadResourceId": "Resource ID",
            "Select user": "Select user",
            "Report collection period": "Report collection period",
            "Whether to send mail": "Whether to send mail",
            "SEND": "SEND",
            "NOT SEND": "NOT SEND",
            "Targets and actions": "Targets and actions",
            "Email recipients": "Email recipients",
            "Sending cycle": "Sending cycle",
            "REPORT_Create": "Create",
            "REPORT_Delete": "Delete",
            "Reports": "Reports",
            "{{value}} people": "{{value}} people",
            "Total asset count": "Total asset count",
            "Total asset size": "Total asset size",
            "{{period}} {{condition}} tasks": "{{period}} {{condition}} tasks",
            "A week ago": "A week ago",
            "tasks": "tasks",
            "{{period}} total": "{{period}} total",
            "Top <emp>10</emp> projects by {{period}} tasks": "Top <emp>10</emp> projects by {{period}} tasks",
            "Table": "Table",
            "Chart": "Chart",
            "{{period}} task count": "{{period}} task count",
            "PM": "PM",
            "AM": "AM",
            "{{hour}}:{{minute}} {{period}}": "{{hour}}:{{minute}} {{period}}",
            "Pipeline during video creation": "Pipeline during video creation",
            "Resource ID": "Resource ID",
            "Video editing": "Video editing",
            "Video image capture": "Video image capture",
            "Pan": "Pan",
            "Zoom": "Zoom",
            "Cut": "Cut",
            "Pull start marker": "Pull start marker",
            "Pull end marker": "Pull end marker",
            "Video name": "Video name",
            "Create a video": "Create a video",
            "Create an edited video": "Create an edited video",
            "Edit and save images": "Edit and save images",
            "Save as asset": "Save as asset",
            "Current video time": "Current video time",
            "Aspect custom": "Custom",
            "Scale": "Scale",
            "Coordinate": "Coordinate",
            "Incision": "Incision",
            "frame {{id}}": "frame {{id}}",
            "Image size": "Image size",
            "Folder location": "Folder location",
            "Get instant download": "Get instant download",
            "Auto-archive status": "Auto-archive status",
            "Auto-archive enabled": "Auto-archive enabled",
            "Auto-archive schedule date": "Auto-archive schedule date",
            "Automatic storage date after asset creation": "Automatic storage date after asset creation",
            "Prefix before asset name": "Prefix before asset name",
            "days later": "days later",
            "or more": "or more",
            "days left": "days left",
            "Select content in a specific folder?": "Select content in a specific folder?",
            "Failure reason": "Failure reason",
            "Unsupported reason": "Unsupported reason",
            "Field description": "Field description",
            "Field default value": "Field default value",
            "Enter field link": "Enter field link",
            "Add link": "Add link",
            "Add group": "Add group",
            "Enter your name": "Enter your name",
            "Preparing to share": "Preparing to share",
            "Send again": "Send again",
            "Cancel invitation": "Cancel invitation",
            "Total file size": "Total file size",
            "Total Usage": "Total Usage",
            "Project Settings > Settings > Menu (e.g. Assets) > Category Groups": "Project Settings > Settings > Menu (e.g. Assets) > Category Groups",
            "Setting location": "Setting location",
            "Category group settings": "Category group settings",
            "Please select a custom metadata preset.": "Please select a custom metadata preset.",
            "Load custom metadata schema": "Load custom metadata schema",
            "Load Metadata": "Load Metadata",
            "PROJECT_RESOURCES_DOWNLOAD": "Download Project Resources",
            "Project resources download": "Download Project Resources",
            "Statistics period": "Statistics period",
            "Weekly change": "Weekly change",
            "Weekly Asset Count": "Weekly asset updates",
            "Weekly File Size": "Weekly file usage",
            "Asset count": "Asset count",
            "Comment Room Option": "Comment Room Option",
            "Project Comment": "Project Comment",
            "preview image": "preview image",
            "Activity History": "Activity History",
            "Activity": "Activity",
            "Select location": "Select location",
            "item selected": "item selected",
            "Include subfolders": "Include subfolders",
            "Thumbnail": "Thumbnail",
            "Maintain image proportions": "Fill to fit container",
            "Crop": "Crop",
            "Create asset": "Create asset",
            "Menu": "Menu",
            "Cusom settings": "Custom settings",
            "Submenu": "Submenu",
            "Add menu": "Add menu",
            "Add submenu": "Add submenu",
            "Library": "Library",
            "Menu item settings": "Menu item settings",
            "Menu name": "Menu name",
            "Add assets from folder": "Add assets from folder",
            "Downloads": "Downloads",
            "Select menu": "Select menu",
            "Default settings": "Default settings",
            "Custom settings": "Custom settings",
            "First entry screen": "First entry screen",
            "First entry screen(Create page)": "First entry screen(Create page)",
            "Edit menu": "Edit",
            "role_Copy": "Copy",
            "Shared At": "Shared At",
            "VIDEO": "Video",
            "AUDIO": "Audio",
            "PEOPLE": "People",
            "TEXT": "Text",
            "FILE": "File",
            "Select media type": "Select media type",
            "Widget Preference": "Widget Preference",
            "LastName/FirstName": "Last name/First name",
            "Site access permission": "Site access permission",
            "Person in charge": "Person in charge",
            "Request date": "Request date",
            "Request I made": "Request I made",
            "Request received": "Request received",
            "Inquiry history": "Inquiry history",
            "In Review": "In Review",
            "Respond": "Respond",
            "Attachment": "Attachment",
            "Request download": "Request download",
            "Setting download permissions": "Setting download permissions",
            "Unlimited": "Unlimited",
            "Unstarred": "Unstarred",
            "Selected Categories": "Selected Categories",
            "Select requester": "Select requester",
            "Select person in charge": "Select person in charge",
            "Common": "Common",
            "Download permission": "Download permission",
            "Not assigned": "Not assigned",
            "Attached file": "Attached file",
            "Shared users": "Shared users",
            "Shared management": "Shared management",
            "Share expiration date": "Share expiration date",
            "Number of downloads remaining": "Number of downloads remaining",
            "Share date": "Share date",
            "Asset Create": "Asset Create",
            "Asset Archive": "Asset Archive",
            "COMMENT_ATTACHMENT_DOWNLOAD": "Comment Attachment Download",
            "Metadata Download": "Metadata Download",
            "Comment Attachment Download": "Comment Attachment Download",
            "My Jobs": "My Jobs",
            "Requests": "Requests",
            "Upload from My PC": "Upload from My PC",
            "Upload from cloud": "Upload from cloud",
            "To Start Page": "To Start Page",
            "Go to previous page": "Go to previous page",
            "Go to first page": "Go to first page",
            "Go to next page": "Go to next page",
            "Go to last page": "Go to last page",
            "Go to page {{page}}": "Go to page {{page}}",
            "Go to start-ellipsis page": "Go to start-ellipsis page",
            "Go to end-ellipsis page": "Go to end-ellipsis page",
            "Open": "Open",
            "REQUEST_ATTACHMENT_DOWNLOAD": "Request Attachment Download",
            "Request Attachment Download": "Request Attachment Download",
            "Partial": "Partial",
            "Request attachment download": "Request attachment download",
            "Reverse sort direction": "Reverse sort direction",
            "Selected Attachment": "Selected Attachment",
            "No Channel Categories": "No Channel Categories",
            "Search Engine": "Search Engine",
            "Create caption asset": "Create caption asset",
            "Create video asset": "Create video asset",
            "Create audio asset": "Create audio asset",
            "Create image asset": "Create image asset",
            "Create file asset": "Create file asset",
            "Caption asset": "Caption asset",
            "Video asset": "Video asset",
            "Audio asset": "Audio asset",
            "Image asset": "Image asset",
            "File asset": "File asset",
            "Caption kind": "Caption kind",
            "Caption language": "Caption language",
            "Create Event Triggers": "Create Event Triggers",
            "Task": "Task",
            "TRIGGER": "TRIGGER",
            "CHOICE": "CHOICE",
            "TASK": "TASK",
            "Input Path": "Input Path",
            "Options": "Options",
            "Enter key": "Enter key",
            "Enter value": "Enter value",
            "Auto Language ({{n}}/max. {{max}})": "Auto Language ({{n}}/max. {{max}})",
            "Add Task": "Add Task",
            "Keep original folder structure": "Keep original folder structure",
            "AI Analysis Settings": "AI Analysis Settings",
            "Transcribe": "Transcribe",
            "STT": "STT",
            "Video annotation": "Video annotation",
            "OCR": "OCR",
            "Vocabulary book": "Vocabulary book",
            "Speaker classification": "Speaker classification",
            "Asset creation options": "Asset creation options",
            "Create per file": "Create per file",
            "Create as a batch": "Create as a batch",
            "Create collection": "Create collection",
            "Invited user": "Invited user",
            "Space admin permission": "Space admin permission",
            "Grant space admin": "Grant space admin",
            "Please search by name": "Please search by name",
            "Grant site access": "Grant site access",
            "Admin permission": "Admin permission",
            "Select admin": "Select admin",
            "Grant project admin": "Grant project admin",
            "Bucket Settings": "Bucket Settings",
            "Essential": "Essential",
            "AWS Account Connection": "AWS Account Connection",
            "Create Project": "Create Project",
            "Use Service Account": "Use Service Account",
            "Connect External Account": "Connect External Account",
            "Region Settings": "Region Settings",
            "AWS Account Connection Guide": "AWS Account Connection Guide",
            "Create IAM Permission": "Create IAM Permission",
            "Copy code": "Copy code",
            "Create IAM Role": "Create IAM Role",
            "View Connection Guide": "View Connection Guide",
            "Group Access Management": "Group Access Management",
            "User Access Management": "User Access Management",
            "Change Owner": "Change Owner",
            "Change": "Change",
            "Not locked": "Not locked",
            "Locked state": "Locked state",
            "Region": "Region",
            "AWS account connection": "AWS account connection",
            "Retrieving analysis results...": "Retrieving analysis results...",
            "AI Auto Tagging": "AI Auto Tagging",
            "Use": "Use",
            "Don't Use": "Don't Use",
            "Min. Confidence": "Min. Confidence",
            "API Key": "API Key",
            "Summary": "Summary",
            "Usage Dashboard": "Usage Dashboard",
            "Unique accessed users": "Unique accessed users",
            "Transcoding jobs": "Transcoding jobs",
            "Total assets": "Total assets",
            "Metadata registration rate": "Metadata registration rate",
            "AI jobs": "AI jobs",
            "A month ago": "A month ago",
            "Usage Trend": "Usage Trend",
            "Asset count and storage usage by {{target}}": "Asset count and storage usage by {{target}}",
            "AI jobs by service type": "AI jobs by service type",
            "AI jobs by engine": "AI jobs by engine",
            "Assets by media type": "Assets by media type",
            "Daily asset creation count": "Daily asset creation count",
            "All customers": "All customers",
            "Segment detection": "Segment detection",
            "Text detection": "Text detection",
            "Translate": "Translate",
            "{{target}} detail data": "{{target}} detail data",
            "File size": "File size",
            "Customer name": "Customer name",
            "customer": "customer",
            "project": "project",
            "Grant role": "Grant role",
            "Loading Data...": "Loading Data...",
            "MimeType": "MimeType",
            "Inviter": "Inviter",
            "Mark as read": "Mark as read",
            "Mark as unread": "Mark as unread",
            "Mark all as read": "Mark all as read",
            "Notifications": "Notifications",
            "Show only unread items": "Show only unread items",
            "Subtitle generation basic settings": "Subtitle generation basic settings",
            "Auto-delete input bucket": "Auto-delete input bucket",
            "Try again": "Try again",
            "Ask a new question": "Ask a new question",
            "New Task": "New Task",
            "Tasks": "Tasks",
            "Go Back": "Go Back",
            "Create Shortform": "Create Shortform",
            "AI WorkSpace Preset": "AI WorkSpace Preset",
            "Active presets": "Active presets",
            "Creation location": "Creation location",
            "Create Prompt Presets": "Create Prompt Presets",
            "Prompt": "Prompt",
            "Response format": "Response format",
            "Timeline for editing": "Timeline for editing",
            "AI Workspace": "AI Workspace",
            "Unsupported video file format": "Unsupported video file format",
            "Name ascending order": "Name ascending",
            "Name descending order": "Name descending",
            "Expiration date": "Expiration date",
            "Save Tags": "Save Tags",
            "Deleted after {{day}} day(s)": "Deleted after {{day}} day(s)",
            "Single type": "Single type",
            "Chat type": "Chat type",
            "Save description immediately": "Save description immediately",
            "Save Description": "Save description",
            "Start ingest": "Start ingest",
            "End ingest": "End ingest",
            "Start transcoding": "Start transcoding",
            "End transcoding": "End transcoding",
            "Copy description": "Copy",
            "Whether transcoded assets are exposed": "Whether transcoded assets are exposed",
            "Create original quality video only": "Create original quality video only",
            "Automatically activated": "Automatically activated",
            "Publish to YouTube": "Publish to YouTube",
            "Create and manage video URL": "Create and manage video URL",
            "Published channels": "Published channels",
            "Delete URL": "Delete URL",
            "Create URL": "Create URL",
            "You can create a URL for video sharing.": "You can create a URL for video sharing.",
            "Creating video URL": "Creating video URL",
            "MODAL_Publishing": "Publishing",
            "Selected": "Selected",
            "audit logs": "audit logs",
            "Select description": "Select action",
            "List View Settings": "List View Settings",
            "User Preference Widget": "User Preference Widget",
            "User Group Preference Widget": "User Group Preference Widget",
            "Project Preference Widget": "Project Preference Widget",
            "Entire Period": "Entire Period",
            "This Week": "This Week",
            "This Month": "This Month",
            "This Year": "This Year",
            "Last 15 Minutes": "Last 15 Minutes",
            "Last 30 Minutes": "Last 30 Minutes",
            "Last 1 Hour": "Last 1 Hour",
            "Last 4 Hours": "Last 4 Hours",
            "Apply with Project Settings": "Apply with Project Settings",
            "Line Chart": "Line Chart",
            "Bar Chart": "Bar Chart",
            "Notice": "Notice",
            "Cancel Update": "Cancel Update",
            "Widget Type": "Widget Type",
            "Wide Type": "Wide Type",
            "Default Dashboard Exposure": "Default Dashboard Exposure",
            "Widget Exposure Settings": "Widget Exposure Settings",
            "Not Entered": "Not Entered",
            "Show Search Options": "Show Search Options",
            "Project Settings > Settings > Menu (e.g. Asset) > Category Group": "Project Settings > Settings > Menu (e.g. Asset) > Category Group",
            "Date to automatically retain assets after creation or restoration": "Date to automatically retain assets after creation or restoration",
            "Category Group": "Category Group",
            "Asset name 1": "Asset name 1",
            "Empty notifications": "Empty notifications",
            "Unread only": "Unread only",
            "Read only": "Read only",
            "Mixed read/unread": "Mixed read/unread",
            "All comment types mixed": "All comment types mixed",
            "All domains mixed": "All domains mixed",
            "All asset media types mixed": "All asset media types mixed",
            "Turn off test mode": "Turn off test mode",
            "Turn on test mode": "Turn on test mode",
            "Select a preset": "Select a preset",
            "Recommended": "Recommended",
            "More": "More",
            "Hide Presets": "Hide Presets",
            "See More Presets": "See More Presets",
            "Duplicate {{name}}": "Duplicate {{name}}",
            "Schedule ID": "Schedule ID",
            "Enter Owner": "Enter Owner",
            "24 hour operation": "24 hour operation",
            "CAPTION": "CAPTION",
            "Search all Assets": "Search all Assets",
            "Add Content Schema": "Add Content Schema",
            "Add {{schemaName}}": "Add {{schemaName}}",
            "Enter Sounds Like": "Enter Sounds Like",
            "There are no analysis results for {{name}}.": "There are no analysis results for {{name}}.",
            "Change menu name": "Change menu name",
            "Delete group": "Delete group",
            "Recent Assets Shared to Me": "Recent Assets Shared to Me",
            "Empty Data": "Empty Data",
            "Users and teams belonging to the project for the selected asset are excluded from sharing.": "Users and teams belonging to the project for the selected asset are excluded from sharing.",
            "Recoding": "Recoding",
            "share": "share",
            "Information": "Information",
            "No permission": "No permission",
            "MOVE": "MOVE",
            "metadata export": "metadata export",
            "Collection Download": "Collection Download",
            "Selected {{referenceType}}s": "Selected {{referenceType}}s",
            "Source Upload": "Source Upload",
            "This operation was not entirely successful.": "This operation was not entirely successful.",
            "View": "View",
            "Unable to use AI-Workspace": "Unable to use AI-Workspace",
            "Read Only": "Read Only",
            "Switch": "Switch",
            "Switching": "Switching",
            "S3_OBJECT_CREATED": "When a file is uploaded",
            "ASSET_CREATED": "When an asset is created",
            "FILTER_BY_FILE_EXTENSION": "Filter by file extension",
            "FILTER_BY_FILE_SIZE": "Filter by file size",
            "FILTER_BY_ASSET_MEDIA_TYPE": "Filter by asset media type",
            "FILTER_BY_ASSET_SIZE": "Filter by asset size",
            "ATTACH_ASSET_METADATA": "Attach metadata",
            "CREATE_ASSET": "Create asset",
            "CREATE_VIDEO": "Create video",
            "SUBMIT_AI_WORKSPACE_SINGLE_TYPE_JOB": "Submit AI Workspace job",
            "ARCHIVE_ASSET": "Archive asset",
            "PUBLISH_VIDEO": "Publish video",
            "File URL": "File URL",
            "File Extension": "File Extension",
            "File Size": "File Size",
            "Asset Media Type": "Asset Media Type",
            "Asset Size": "Asset Size",
            "Condition": "Condition",
            "Flow Edit": "Flow Edit",
            "Flow Details": "Flow Details",
            "Auto": "Auto",
            "Manual": "Manual",
            "Select a step": "Select a step",
            "clippings": "Clippings",
            "accountId": "Account ID",
            "AiWorkspaceJob SingleTypeJob Output": "AI Workspace Job Output",
            "AI Mode": "AI Mode",
            "AI Mode OFF": "AI Mode OFF",
            "Ask anything": "Ask anything",
            "Hi, this is AI search mode": "Hi, this is AI search mode",
            "Describe a scene or feature in the video you are looking for!": "Describe a scene or feature in the video you are looking for!",
            "AI Search Preset Recently modified videos": "Recently modified videos",
            "AI Search Preset Golden sunset on the beach": "Golden sunset on the beach",
            "AI Search Preset People in a meeting at the office": "People in a meeting at the office",
            "AI Search Preset Cinematic mood videos": "Cinematic mood videos",
            "AI Search Preset City night view by drone": "City night view by drone",
            "AI Search Preset Children smiling brightly": "Children smiling brightly",
            "View indexing status": "View indexing status",
            "AI Analysis Plan and Usage": "AI Analysis Plan and Usage",
            "Ai-billing": "AI Analysis Plan and Usage",
            "Current subscription": "Current subscription",
            "No active subscription": "No active subscription",
            "Concurrent sessions": "Concurrent sessions",
            "Fees and usage": "Fees and usage",
            "Fees": "Fees",
            "Usage": "Usage",
            "Aggregating": "Aggregating",
            "Settled": "Settled",
            "Total so far": "Total so far",
            "Settled total": "Settled total",
            "Period subtotal": "Period subtotal",
            "Cumulative usage": "Cumulative usage",
            "Year option {{year}}": "{{year}}",
            "Month option {{month}}": "{{month}}",
            "Pay-as-you-go": "Pay-as-you-go",
            "No change": "No change",
            "vs. last month": "vs. last month",
            "min": "min",
            "AI applied": "AI applied",
            "Apply all": "Apply all",
            "Cancel setting": "Cancel setting",
            "Custom metadata": "Custom metadata",
            "Differs from preset schema": "Differs from preset schema",
            "Not extracted": "Not extracted",
            "Replace": "Replace",
            "Replace with preset schema": "Replace with preset schema",
            "Revert to existing schema": "Revert to existing schema",
            "Same as preset schema": "Same as preset schema",
            "Save custom metadata directly": "Save custom metadata directly",
            "Set preset schema": "Set preset schema",
            "Save metadata": "Save metadata",
            "Add publish": "Add publish",
            "Back to manage": "Back to manage",
            "Copy public URL": "Copy public URL",
            "Last published": "Last published",
            "Manage public URL": "Manage public URL",
            "Open public URL": "Open public URL",
            "Open URL": "Open URL",
            "Publish ({{count}})": "Publish ({{count}})",
            "Publish and manage public URL": "Publish and manage public URL",
            "Publish public URL": "Publish public URL",
            "Publish target": "Publish target",
            "Unpublish": "Unpublish",
            "Unpublish ({{count}})": "Unpublish ({{count}})",
            "{{count}} files": "{{count}} files",
            "English (en-US)": "English (en-US)",
            "Korean (ko-KR)": "Korean (ko-KR)",
            "Related Videos": "Related Videos",
            "and <emp>{{count}}</emp> others' shared": "and <emp>{{count}}</emp> others' shared",
            "(<emp>{{count}}</emp> days left)": "(<emp>{{count}}</emp> days left)",
            "Info": "Info",
            "Filter": "Filter",
            "Create Highlights": "Create Highlights",
            "Create Description": "Create Description",
            "Remove all Shares": "Remove all Shares",
            "Create date": "Create date",
            "Complete date": "Complete date",
            "Start Failure": "Start Failure",
            "Recording Started": "Recording Started",
            "Upload Cancel": "Upload Cancel",
            "Select Content in a specific folder?": "Select Content in a specific folder?",
            "Template preview": "Template preview",
            "Terms and Conditions": "Terms and Conditions",
            "toggle password visibility": "toggle password visibility",
            "{{type}} Asset Name": "{{type}} Asset Name",
            "Enter {{type}} Asset Name": "Enter {{type}} Asset Name",
            "' shared": "' shared",
            "Minimap": "Minimap",
            "Go back": "Go back",
            "Use service account": "Use service account",
            "{{names}} and {{restCount}} more": "{{names}} and {{restCount}} more",
            "Proxy video": "Proxy video",
            "Proxy video status": "Proxy video status",
            "Auto generate proxy video": "Auto generate proxy video",
            "Proxy video ready": "Proxy video ready",
            "Extracting proxy video": "Extracting proxy video",
            "Proxy extraction failed": "Proxy extraction failed",
            "Best match": "Best match",
            "AI Search": "AI Search",
            "{{count}} errors": "{{count}} errors",
            "View by country and referrer": "View by country and referrer",
            "Countries (this URL)": "Countries (this URL)",
            "Referring domains (this URL)": "Referring domains (this URL)",
            "persons": "people",
            "and {{count}} more": "and {{count}} more",
            "All URLs": "All URLs",
            "All unpublished": "All unpublished",
            "View all URLs": "View all URLs",
            "Search URL": "Search URL",
            "Share of total": "Share",
            "Country": "Country",
            "CF address": "CF address"
        },
        "msg": {
            "How many times the asset was opened through its public URL. Downloads and on-screen views are counted together, and for video, starting playback counts as one - watching to the end is not measured. If there is no access for 30 minutes after the first view, the next view is counted separately.": "How many times the asset was opened through its public URL. Downloads and on-screen views are counted together, and for video, starting playback counts as one - watching to the end is not measured. If there is no access for 30 minutes after the first view, the next view is counted separately.",
            "Total data sent out through this asset's public URLs. Opening the same file again adds to it.": "Total data sent out through this asset's public URLs. Opening the same file again adds to it.",
            "An estimate, not a headcount. Several people in one company may count as one, and one person switching devices may count as several.": "An estimate, not a headcount. Several people in one company may count as one, and one person switching devices may count as several.",
            "The site the visitor came from right before opening this URL. Whether the asset was actually embedded in that page or reached by a link is not distinguished. Entries with no value are grouped as Unknown.": "The site the visitor came from right before opening this URL. Whether the asset was actually embedded in that page or reached by a link is not distinguished. Entries with no value are grouped as Unknown.",
            "Could not load statistics": "Could not load statistics",
            "Could not update. Showing the previous result.": "Could not update. Showing the previous result.",
            "Data is aggregated hourly, not in real time.": "Data is aggregated hourly, not in real time.",
            "Aggregated hourly, so the most recent views may not be here yet. Do not decide whether a URL is still in use from this column alone.": "Aggregated hourly, so the most recent views may not be here yet. Do not decide whether a URL is still in use from this column alone.",
            "The country the viewer was in.": "The country the viewer was in.",
            "CDN logs are not real-time, so today and yesterday are still filling in. Downloads and on-screen views are counted together, and referring domains do not distinguish embedded pages from link clicks.": "CDN logs are not real-time, so today and yesterday are still filling in. Downloads and on-screen views are counted together, and referring domains do not distinguish embedded pages from link clicks.",
            "Please try again in a moment.": "Please try again in a moment.",
            "No views recorded yet": "No views recorded yet",
            "Views appear here once someone opens the asset through its public URL.": "Views appear here once someone opens the asset through its public URL.",
            "Add request headers such as an authorization token if needed.": "Add request headers such as an authorization token if needed.",
            "Only letters, numbers, and hyphens are allowed.": "Only letters, numbers, and hyphens are allowed.",
            "This header cannot be used.": "This header cannot be used.",
            "Line breaks are not allowed.": "Line breaks are not allowed.",
            "Headers can be up to {{maxLength}} characters in total. (currently {{length}})": "Headers can be up to {{maxLength}} characters in total. (currently {{length}})",
            "The URL is too long.": "The URL is too long.",
            "Internal addresses (private, loopback, or link-local) cannot be used.": "Internal addresses (private, loopback, or link-local) cannot be used.",
            "\"{{name}}\" will be deleted forever and you won't be able to restore it.": "\"{{name}}\" will be deleted forever and you won't be able to restore it.",
            "The webhook has been activated.": "The webhook has been activated.",
            "The webhook has been deactivated. Events will no longer be sent.": "The webhook has been deactivated. Events will no longer be sent.",
            "A webhook sends asset event data to an external endpoint whenever a selected trigger occurs.": "A webhook sends asset event data to an external endpoint whenever a selected trigger occurs.",
            "Deliveries appear here once a selected trigger occurs.": "Deliveries appear here once a selected trigger occurs.",
            "Are you sure you want to delete this webhook?": "Are you sure you want to delete this webhook?",
            "HTTP method is fixed to POST and cannot be changed.": "HTTP method is fixed to POST and cannot be changed.",
            "https://example.com/webhooks": "https://example.com/webhooks",
            "Key is required.": "Key is required.",
            "Key must be unique.": "Key must be unique.",
            "Please enter a valid URL.": "Please enter a valid URL.",
            "Please select at least one trigger.": "Please select at least one trigger.",
            "Select a trigger to preview the request body.": "Select a trigger to preview the request body.",
            "The request body is determined automatically by the system based on the trigger and cannot be edited.": "The request body is determined automatically by the system based on the trigger and cannot be edited.",
            "We recommend using https.": "We recommend using https.",
            "'{{item}}' has been added.": "'{{item}}' has been added.",
            "'{{name}}' AI analysis has begun.": "'{{name}}' AI analysis has begun.",
            "'{{name}}' has been added.": "'{{name}}' has been added.",
            "AI Caption task failed.": "AI Caption task failed.",
            "Access has Expired": "Access has Expired",
            "An error has occurred": "An error has occurred",
            "An error occured while changing Custom Metadata {type}": "An error occured while changing Custom Metadata {type}",
            "An error occured while changing collection name": "An error occured while changing collection name",
            "An error occured while changing collection {{type}}": "An error occured while changing collection {{type}}",
            "An error occured while changing custom content {{type}}": "An error occured while changing custom content {{type}}",
            "An organizer can be selected.": "An organizer can be selected.",
            "Assets must only be in DRM-free MP4 video type.": "Assets must only be in DRM-free MP4 video type.",
            "Collection '{{name}}' has been created.": "Collection '{{name}}' has been created.",
            "Content schema '{{name}}' has been duplicated.": "Content schema '{{name}}' has been duplicated.",
            "Creating video URL.": "Creating video URL.",
            "Creation of new Metadata Export {{item}} is completed.": "Creation of new Metadata Export {{item}} is completed.",
            "Detach {{name}}": "Detach {{name}}",
            "Download request failed": "Download request failed",
            "Enter your name": "Enter your name",
            "Error adding collection '{{name}}'. {{line}} Please refresh the page and try again.": "Error adding collection '{{name}}'. {{line}} Please refresh the page and try again.",
            "Expired date :": "Expired date :",
            "Face collection is not registered. Please contact to admin.": "Face collection is not registered. Please contact to admin.",
            "Failed to configure AI analysis trigger.": "Failed to configure AI analysis trigger.",
            "Failed to move.": "Failed to move.",
            "File is empty.": "File is empty.",
            "Group '{{name}}' has been added.": "Group '{{name}}' has been added.",
            "I agree to the above terms and conditions": "I agree to the above terms and conditions",
            "If you apply a different category group, those items can be found under ‘<NotClassified>Categories Not Classified into Assets</NotClassified>’ in the category view.": "If you apply a different category group, those items can be found under ‘<NotClassified>Categories Not Classified into Assets</NotClassified>’ in the category view.",
            "If you delete <0>{{name}}</0>,  will also be removed from reference and you won't be able to revert this.<1/>Are you sure you want to delete?": "If you delete <0>{{name}}</0>,  will also be removed from reference and you won't be able to revert this.<1/>Are you sure you want to delete?",
            "If you delete <0>{{name}}</0>, you won't be able to revert this.<1/>Are you sure you want to delete?": "If you delete <0>{{name}}</0>, you won't be able to revert this.<1/>Are you sure you want to delete?",
            "If you have issues with Space approval, please contact Megazone Cloud. ": "If you have issues with Space approval, please contact Megazone Cloud. ",
            "Korean can not contain numbers.": "Korean can not contain numbers.",
            "Please enter title": "Please enter title",
            "Please search by collection name": "Please search by collection name",
            "Please uncheck the items you wish to leave and try to delete them.": "Please uncheck the items you wish to leave and try to delete them.",
            "Saving of changes to '{{tab}}' failed. - {{error}}": "Saving of changes to '{{tab}}' failed. - {{error}}",
            "Shortform creation has been requested.": "Shortform creation has been requested.",
            "Since this is a category group that is not used in {{name}}s, you can check the created {{name}} in 'categories not classified in {{name}}s'.": "Since this is a category group that is not used in {{name}}s, you can check the created {{name}} in 'categories not classified in {{name}}s'.",
            "The Key field be up to {{tag}} characters long.": "The Key field be up to {{tag}} characters long.",
            "The Lineup Name field be up to {{name}} characters long.": "The Lineup Name field be up to {{name}} characters long.",
            "The Value field be up to {{tag}} characters long.": "The Value field be up to {{tag}} characters long.",
            "The caption of the program can be edited in the caption of the <0> {{number}} </0> ": "The caption of the program can be edited in the caption of the <0> {{number}} </0> ",
            "The language of the captions to be applied to the video must not be duplicated.": "The language of the captions to be applied to the video must not be duplicated.",
            "There is already a {{target}} with the same email. Please change it to a different email.": "There is already a {{target}} with the same email. Please change it to a different email.",
            "There is no Organizers to select.": "There is no Organizers to select.",
            "There is no file to retry.": "There is no file to retry.",
            "There was an error sharing asset {{item}}": "There was an error sharing asset {{item}}",
            "This field can be at least {{minByte}} bytes.": "This field can be at least {{minByte}} bytes.",
            "This field can be at least {{minLength}} characters.": "This field can be at least {{minLength}} characters.",
            "This field must be in email address format.": "This field must be in email address format.",
            "This listings has updated information.<0/>Please refresh and try again. Do you want to refresh now?": "This listings has updated information.<0/>Please refresh and try again. Do you want to refresh now?",
            "Try another search to find an vocabulary.": "Try another search to find an vocabulary.",
            "User invitation has been completed.": "User invitation has been completed.",
            "Video '{{name}}' has been requested.": "Video '{{name}}' has been requested.",
            "Videos must only be in DRM-free MP4 video type among the sources.": "Videos must only be in DRM-free MP4 video type among the sources.",
            "Words to display - Enter Korean, English, numbers, spaces, and special characters (~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?) You can.": "Words to display - Enter Korean, English, numbers, spaces, and special characters (~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?) You can.",
            "Words to display - You can enter English, numbers, spaces, and special characters (~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?) there is.": "Words to display - You can enter English, numbers, spaces, and special characters (~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?) there is.",
            "You can create a URL for video sharing.": "You can create a URL for video sharing.",
            "You can enter up to 30 whitelist rules.": "You can enter up to 30 whitelist rules.",
            "You can see all your current assets. You can find the asset you are looking for using the search option.": "You can see all your current assets. You can find the asset you are looking for using the search option.",
            "You cannot upload files to this list.": "You cannot upload files to this list.",
            "You must leave at least one entry in your vocabulary book.": "You must leave at least one entry in your vocabulary book.",
            "You will receive an email letting you know that <0/>  the asset has been shared with you.": "You will receive an email letting you know that <0/>  the asset has been shared with you.",
            "Your folder name is too long including parent folders, you can shorten the folder name and try again.": "Your folder name is too long including parent folders, you can shorten the folder name and try again.",
            "{{resourceName}} '{{name}}' has been updated.": "{{resourceName}} '{{name}}' has been updated.",
            "{{schemaName}} '{{name}}' has been created.": "{{schemaName}} '{{name}}' has been created.",
            "No labels": "No labels",
            "This user does not exist.": "This user does not exist.",
            "No Sharer.": "No Sharer.",
            "No Users.": "No Users.",
            "No Groups.": "No Groups.",
            "Please manage your assets by adding the new folder.": "Please manage your assets by adding the new folder.",
            "The video list is missing.": "The video list is missing.",
            "Delete completely from Music": "Delete completely from Music",
            "You have selected <0>{{count}}</0> other than <1>{{name}}</1>": "You have selected <0>{{count}}</0> other than <1>{{name}}</1>",
            "Remove from category <0>{{name}}</0> only": "Remove from category <0>{{name}}</0> only",
            "You won’t be able to revert this.": "You won’t be able to revert this.",
            "If you delete <0>{{name}}</0>, it will also be removed from <0>Reference</0> and you won’t be able to revert this.<1/>Are you sure you want to delete <0>{{name}}</0>?": "If you delete <0>{{name}}</0>, it will also be removed from <0>Reference</0> and you won’t be able to revert this.<1/>Are you sure you want to delete <0>{{name}}</0>?",
            "If you delete <0>{{count}}</0> other than <0>{{name}}</0>, it will also be removed from <0>Reference</0> and you won’t be able to revert this.<1/>Are you sure you want to delete <0>{{name}}</0>?": "If you delete <0>{{count}}</0> other than <0>{{name}}</0>, it will also be removed from <0>Reference</0> and you won’t be able to revert this.<1/>Are you sure you want to delete <0>{{name}}</0>?",
            "{{verb}} <0>{{count}}</0> files from <1>{{path}}</1> to <2>{{to}}</2>": "{{verb}} <0>{{count}}</0> files from <1>{{path}}</1> to <2>{{to}}</2>",
            "An item with the name <0>{{name}}</0> is already in this location.<1/>Do you want to overwrite it with the target file?": "An item with the name <0>{{name}}</0> is already in this location.<1/>Do you want to overwrite it with the target file?",
            "Delete completely from Photo": "Delete completely from Photo",
            "Upload Failed.": "Upload Failed.",
            "Upload failed.": "Upload failed.",
            "<0>{{date}} (24 hours) </0> schedule is complete, or there is not enough<br />blank time than video duration.<br />If you want to add a schedule, please manual schedule it.": "<0>{{date}} (24 hours) </0> schedule is complete, or there is not enough<br />blank time than video duration.<br />If you want to add a schedule, please manual schedule it.",
            "{{count}} fields auto-filled": "{{count}} fields auto-filled",
            "The current workflow can be saved as a draft, but some connection structures are invalid, which may cause issues when running.": "The current workflow can be saved as a draft, but some connection structures are invalid, which may cause issues when running.",
            "You can save the current workflow, but saving your changes will cancel <0>{{queuedCount}} queued executions</0>.": "You can save the current workflow, but saving your changes will cancel <0>{{queuedCount}} queued executions</0>.",
            "The current workflow has items that need to be resolved and cannot be saved. Please fix the items below and save again.": "The current workflow has items that need to be resolved and cannot be saved.\nPlease fix the items below and save again.",
            "Add at least one task.": "Add at least one task.",
            "User list export has been requested.": "User list export has been requested.",
            "Failed to export the user list.": "Failed to export the user list.",
            "This setting may take some time to take effect after being changed, and the status cannot be changed again while it is being applied.": "This setting may take some time to take effect after being changed, and the status cannot be changed again while it is being applied.",
            "This setting is currently being applied. You can change it again after it takes effect.": "This setting is currently being applied. You can change it again after it takes effect.",
            "Please select {{type}}.": "Please select {{type}}.",
            "Please select a step.": "Please select a step.",
            "Select a step node.": "Select a step node.",
            "No available step": "No available step",
            "Up to 5 parallel steps.": "Up to 5 parallel steps.",
            "Drag anywhere to move the canvas.": "Drag anywhere to move the canvas.",
            "The step tree for workflow \"{{name}}\" has been updated.": "The step tree for workflow \"{{name}}\" has been updated.",
            "Input conditions are not satisfied by upstream steps.": "Input conditions are not satisfied by upstream steps.",
            "This may take some time to apply, depending on the amount of data.": "This may take some time to apply, depending on the amount of data.",
            "You have no permission to view this page.": "You have no permission to view this page.",
            "Attribution cannot be empty.<0/>Please enter a valid attribution.": "\"Attribution\" cannot be empty.<0/>Please enter a valid attribution.",
            "\"Tags\" can be up to 30.": "\"Tags\" can be up to 30.",
            "\"Tags\" can be up to {{count}}.": "\"Tags\" can be up to {{count}}.",
            "ㆍCIDR : xxx.xxx.xxx.xxx/yy\n \n \n ㆍseparate by newlines": "ㆍCIDR : xxx.xxx.xxx.xxx/yy\n \n \n ㆍseparate by newlines",
            "Add file by drag and drop or double-clicking in the select sources.": "Add file by drag and drop or double-clicking in the select sources.",
            "A maximum of 2 streams can be selected.": "A maximum of 2 streams can be selected.",
            "A one schedules can be selected.": "A one schedules can be selected.",
            "Access denied.": "Access denied.",
            "An error occured while trying to analyze the asset": "An error occured while trying to analyze the asset",
            "An attempt to 'Archive' failed. Please try again.": "An attempt to 'Archive' failed. Please try again.",
            "An attempts to change the status from 'Active' to 'Inactive' failed. Please try again.": "An attempts to change the status from 'Active' to 'Inactive' failed. Please try again.",
            "Analyzed automatically labels objects, concepts and scenes in video.": "Analyzed automatically labels objects, concepts and scenes in video.",
            "And {{count}} Other - Total {{total}}": "And {{count}} Other - Total {{total}}",
            "Approve the channel after creation": "Approve the channel after creation",
            "Are you sure ? You won't be able to revert this!": "Are you sure ? You won't be able to revert this!",
            "Are you sure you delete the selected lineups?": "Are you sure you delete the selected lineups?",
            "Are you sure you want to approve the selected?": "Are you sure you want to approve the selected?",
            "Are you sure you want to cancel the request the selected?": "Are you sure you want to cancel the request the selected?",
            "Are you sure you want to cancel the return the selected?": "Are you sure you want to cancel the return the selected?",
            "Are you sure you want to delete": "Are you sure you want to delete",
            "Are you sure you want to delete <0>{{name}} ({{id}})</0>?": "Are you sure you want to delete <0>{{name}} ({{id}})</0>?",
            "Are you sure you want to delete <0>{{name}}</0>?": "Are you sure you want to delete <0>{{name}}</0>?",
            "Are you sure you want to reclaim the selected?": "Are you sure you want to reclaim the selected?",
            "Are you sure you want to reject the request?": "Are you sure you want to reject the request?",
            "Are you sure you want to request the selected?": "Are you sure you want to request the selected?",
            "Are you sure you want to return the selected?": "Are you sure you want to return the selected?",
            "Automatically detects explicit adult content in video.": "Automatically detects explicit adult content in video.",
            "Automatically recognizes celebrities in video.": "Automatically recognizes celebrities in video.",
            "Base video file can be set only for english without special characters and spaces.": "Base video file can be set only for english without special characters and spaces.",
            "Base video file to be used for the channel can be set only for English without special characters and spaces. (Allowed special characters: ~! () _-.)": "Base video file to be used for the channel can be set only for English without special characters and spaces. (Allowed special characters: ~! () _-.)",
            "Bucket name must be between 3 and 63 letters and start with alphabet or number with allowed special characters of -, _, and .)": "Bucket name must be between 3 and 63 letters and start with alphabet or number with allowed special characters of -, _, and .)",
            "Cannot apply because no schema is set": "Cannot apply because no schema is set",
            "Cannot apply because the schema is different": "Cannot apply because the schema is different",
            "Cannot create a job": "Cannot create a job",
            "CloudPlex Media subtitle editor works with the platform to provide flexible workflows from subtitle registration to publishing.<0/>Quickly create subtitles with user experience-based UI.": "CloudPlex Media subtitle editor works with the platform to provide flexible workflows from subtitle registration to publishing.<0/>Quickly create subtitles with user experience-based UI.",
            "Deleted output assets will be kept for the specified days": "Deleted output assets will be kept for the specified days",
            "Do not have an account yet?": "Do not have an account yet?",
            "Do you really want to change?": "Do you really want to change?",
            "Do you really want to delete it?": "Do you really want to delete it?",
            "Drag and drop a file here": "Drag and drop a file here",
            "Drag your files to upload": "Drag your files to upload",
            "Duplicate key. The key must be unique.": "Duplicate key. The key must be unique.",
            "Duplicate values. This field must be unique.": "Duplicate values. This field must be unique.",
            "Every month on the": "Every month on the",
            "Every month on the {{interval}} days": "Every month on the {{interval}} days",
            "Every months on": "Every months on",
            "Every weeks on": "Every weeks on",
            "Failed to get file information from the url.": "Failed to get file information from the url.",
            "Reindexing has been requested.": "Reindexing has been requested.",
            "AI search indexing failed.": "AI search indexing failed.",
            "AI search indexing is not supported for this asset.": "AI search indexing is not supported for this asset.",
            "This is an unsupported media type.": "This is an unsupported media type.",
            "This is an unsupported source format.": "This is an unsupported source format.",
            "This image is smaller than the minimum size (128x128 pixels).": "This image is smaller than the minimum size (128x128 pixels).",
            "This image exceeds the maximum file size (5 MiB).": "This image exceeds the maximum file size (5 MiB).",
            "This video exceeds the maximum file size (6 GB).": "This video exceeds the maximum file size (6 GB).",
            "This video exceeds the maximum duration (4 hours).": "This video exceeds the maximum duration (4 hours).",
            "Failed to prepare indexing.": "Failed to prepare indexing.",
            "Failed to extract metadata.": "Failed to extract metadata.",
            "Failed to create the source.": "Failed to create the source.",
            "Failed to check source support.": "Failed to check source support.",
            "Failed to analyze the source.": "Failed to analyze the source.",
            "Failed to analyze metadata.": "Failed to analyze metadata.",
            "Failed to create the search index.": "Failed to create the search index.",
            "An internal error occurred.": "An internal error occurred.",
            "AI search indexing is in progress.": "AI search indexing is in progress.",
            "This analysis failed.": "This analysis failed.",
            "This analysis is outside the supported range.": "This analysis is outside the supported range.",
            "This analysis was only partially indexed.": "This analysis was only partially indexed.",
            "Only part of the source was analyzed.": "Only part of the source was analyzed.",
            "Only some index entries were created.": "Only some index entries were created.",
            "Some parts were not indexed, so this asset may not appear in all AI search results.": "Some parts were not indexed, so this asset may not appear in all AI search results.",
            "Click the button on the badge to retry.": "Click the button on the badge to retry.",
            "You can find this asset in AI search.": "You can find this asset in AI search.",
            "Assets that have not finished indexing may not appear in AI search results.": "Assets that have not finished indexing may not appear in AI search results.",
            "No results for \"{{keyword}}\".": "No results for \"{{keyword}}\".",
            "Depending on indexing status, some assets may not appear in AI search results.": "Depending on indexing status, some assets may not appear in AI search results.",
            "The index is already up to date.": "The index is already up to date.",
            "Failed to request reindexing.": "Failed to request reindexing.",
            "Granted roles will be deleted.": "Granted roles will be deleted.",
            "Has scheduled lineups.": "Has scheduled lineups.",
            "Hi, {{name}}": "Hi, {{name}}",
            "http(s)://~ or s3://~": "http(s)://~ or s3://~",
            "Hyper Browser is an enterprise cloud storage client.<0/>Accelerate a variety of workloads with a multi-CDN integration environment and powerful features such as multi-part upload/download, purge and pre-patch.": "Hyper Browser is an enterprise cloud storage client.<0/>Accelerate a variety of workloads with a multi-CDN integration environment and powerful features such as multi-part upload/download, purge and pre-patch.",
            "If \\\"program duration\\\" is more than \\\"24 hours\\\", you can not repeat the schedule.": "If \\\"program duration\\\" is more than \\\"24 hours\\\", you can not repeat the schedule.",
            "If it is not the scheduled time, it automatically changes the state of the channel to 'Idle'.": "If it is not the scheduled time, it automatically changes the state of the channel to 'Idle'.",
            "If the value is the same, next event has the highest priority": "If the value is the same, next event has the highest priority",
            "If you are not a member yet, please sign up and use.": "If you are not a member yet, please sign up and use.",
            "If you delete <0>{{name}}</0>, it will also be removed from Related the videos.": "If you delete <0>{{name}}</0>, it will also be removed from Related the videos.",
            "If you delete <0>{{deleteLineupTargetName}}</0>, only future events including this one will be deleted.": "If you delete <0>{{deleteLineupTargetName}}</0>, only future events including this one will be deleted.",
            "If you delete <0>{{name}}</0>, only future events including this one will be deleted.<1/>Are you sure you want to delete <0>{{name}}</0>?": "If you delete <0>{{name}}</0>, only future events including this one will be deleted.<1/>Are you sure you want to delete <0>{{name}}</0>?",
            "If you delete <0>{{name}}</0>, the scheduled lineups will be deleted together.<1/>Are you sure you want to delete <0>{{name}}</0>?": "If you delete <0>{{name}}</0>, the scheduled lineups will be deleted together.<1/>Are you sure you want to delete <0>{{name}}</0>?",
            "If you delete a lineup that is set to repeat, all future schedule will be deleted.": "If you delete a lineup that is set to repeat, all future schedule will be deleted.",
            "If you have a problem with your account, or would like to use the cloud <0/>Platform, please contact our sales team. We'll assist you with more details.": "If you have a problem with your account, or would like to use the cloud <0/>Platform, please contact our sales team. We'll assist you with more details.",
            "If you have any problem using the stage,<0/> please contact Megazone.": "If you have any problem using the stage,<0/> please contact Megazone.",
            "If you have any problem using this space,<0/> please contact Megazone Cloud.": "If you have any problem using this space,<0/> please contact Megazone Cloud.",
            "If you want to access this page, please contact your administrator.": "If you want to access this page, please contact your administrator.",
            "Indexing faces and get a complete analysis of facial attributes, <0/>including confidence scores.": "Indexing faces and get a complete analysis of facial attributes, <0/>including confidence scores.",
            "Ingest path setting for pipeline is required. Please contact your manager.": "Ingest path setting for pipeline is required. Please contact your manager.",
            "Input assets will be automatically deleted after specified days": "Input assets will be automatically deleted after specified days",
            "Input name is required.": "Input name is required.",
            "Internal server error": "Internal server error",
            "Invalid CIDR. It must be in pattern of xxx.xxx.xxx.xxx/zz.": "Invalid CIDR. It must be in pattern of xxx.xxx.xxx.xxx/zz.",
            "Invalid upload path": "Invalid upload path",
            "Multiple image files can be selected.": "Multiple image files can be selected.",
            "No {{name}} is set.<0/>Please set the {{name}} and try again.": "No {{name}} is set.<0/>Please set the {{name}} and try again.",
            "No {{name}} searched.": "No {{name}} searched.",
            "No members is granted": "No members is granted",
            "No aduits is granted.": "No aduits is granted.",
            "No role is granted": "No role is granted",
            "One stream can be selected.": "One stream can be selected.",
            "Page not found": "Page not found",
            "This page is not supported on mobile.": "This page is not supported on mobile.",
            "Please use the button below to go back to the previous page.": "Please use the button below to go back to the previous page.",
            "Path was not created. Please set again.": "Path was not created. Please set again.",
            "Pending to upload...": "Pending to upload...",
            "Please add a caption to use.": "Please add a caption to use.",
            "Please add a custom field to use.": "Please add a custom field to use.",
            "Please add a poster assets to use.": "Please add a poster assets to use.",
            "Please add images to use.": "Please add images to use.",
            "Please add people images.": "Please add people images.",
            "Please check and try again": "Please check and try again",
            "Please check the support format and try again.": "Please check the support format and try again.",
            "Please check valid single IP, IP range or CIDR.": "Please check valid single IP, IP range or CIDR.",
            "Please contact your stage administrator to access the project.": "Please contact your stage administrator to access the project.",
            "Please go back to the main with the button below.": "Please go back to the main with the button below.",
            "Please select a file to add": "Please select a file to add",
            "Please select a file to add.": "Please select a file to add.",
            "Please select a valid file.": "Please select a valid file.",
            "Please select the project of the stage you want to access.": "Please select the project of the stage you want to access.",
            "Please try again.": "Please try again.",
            "Prefix cannot be empty": "Prefix cannot be empty",
            "Prefix must begin with s3://": "Prefix must begin with s3://",
            "Remove connected medialive input.": "Remove connected medialive input.",
            "Request a channel approval after creation": "Request a channel approval after creation",
            "Save the origin source as an asset": "Save the origin source as an asset",
            "Schedule repeat can not be modified after setting. (Repeated lineups can only be deleted)": "Schedule repeat can not be modified after setting. (Repeated lineups can only be deleted)",
            "Search for faces in the video using saved face information.": "Search for faces in the video using saved face information.",
            "Select a metadata": "Select a metadata",
            "Select AI analysis item": "Select AI analysis item",
            "Select an face to analyze <0/>From the list of registered images on the left.": "Select an face to analyze <0/>From the list of registered images on the left.",
            "Select an face to index <0/>From the list of registered images on the left.": "Select an face to index <0/>From the list of registered images on the left.",
            "Select files from the image type of assets.": "Select files from the image type of assets.",
            "Select one caption file.": "Select one caption file.",
            "Source must be selected in order to request a channel approval.": "Source must be selected in order to request a channel approval.",
            "Source selection is done after channel creation": "Source selection is done after channel creation",
            "Special chacters are not allowed": "Special chacters are not allowed",
            "Special chacters can not be entered.": "Special chacters can not be entered.",
            "The \\\"End time\\\" must be later than \\\"Start time\\\"": "The \\\"End time\\\" must be later than \\\"Start time\\\"",
            "The \\\"Loop To Fill Lineup Duration\\\" setting applies only when the duration of the video is more than \\\"1 minute\\\".": "The \\\"Loop To Fill Lineup Duration\\\" setting applies only when the duration of the video is more than \\\"1 minute\\\".",
            "The asset list is missing.": "The asset list is missing.",
            "The asset is only MP4 type video.": "The asset is only MP4 type video.",
            "The base video is applied only when the source type is schedules": "The base video is applied only when the source type is schedules",
            "The begin date time can not be past time.": "The begin date time can not be past time.",
            "The begin date time must be registered after 2 minutes on the current time basis.": "The begin date time must be registered after 2 minutes on the current time basis.",
            "The changed roles will be applied to users below.": "The changed roles will be applied to users below.",
            "The comment field can be up to {{byte}} byte long.": "The comment field can be up to {{byte}} byte long.",
            "The description can be up to {{byte}} byte": "The description can be up to {{byte}} byte",
            "The description field can be up to {{limit}} byte long.": "The description field can be up to {{limit}} byte long.",
            "The file is not valid.": "The file is not valid.",
            "The file source list is missing.": "The file source list is missing.",
            "The lineup Name field be up to {{name}} byte long.": "The lineup Name field be up to {{name}} byte long.",
            "The lineup priority field is greater than 0 and less than 100.": "The lineup priority field is greater than 0 and less than 100.",
            "The name field be up to {{title}} byte long.": "The name field be up to {{title}} byte long.",
            "The name field can be up to {{limit}} byte long.": "The name field can be up to {{limit}} byte long.",
            "The name field is required": "The name field is required",
            "The page you requested could not be found.": "The page you requested could not be found.",
            "The same file could not be found": "The same file could not be found",
            "The selected Whitelist rules can be modified.": "The selected Whitelist rules can be modified.",
            "The team has no members.": "The team has no members.",
            "The value field be up to {{tag}} byte long.": "The value field be up to {{tag}} byte long.",
            "There is an event in the listing or a linked channel, so you can not delete that stream": "There is an event in the listing or a linked channel, so you can not delete that stream",
            "There is no analyzable item. Only non-DRM MP4 types are supported for analysis.": "There is no analyzable item. Only non-DRM MP4 types are supported for analysis.",
            "There is no input to select.": "There is no input to select.",
            "There is no schedules to select.": "There is no schedules to select.",
            "There is no project available to access.": "There is no project available to access.",
            "There is work in progress. Would you really go out?": "There is work in progress. Would you really go out?",
            "{{count}} upload(s) transferring — do not close or reload this page": "{{count}} upload(s) transferring — do not close or reload this page",
            "Processing continues on the server.": "Processing continues on the server.",
            "Moving between menus or closing this panel is fine.": "Moving between menus or closing this panel is fine.",
            "{{count}} upload(s) transferred — you can close this page": "{{count}} upload(s) transferred — you can close this page",
            "Uploading. Do not close or refresh this page.": "Uploading. Do not close or refresh this page.",
            "There is work in progress. Would you really leave the page?": "There is work in progress. Would you really leave the page?",
            "There was either CORS or network error.": "There was either CORS or network error.",
            "This field can be up to {{maxByte}} bytes.": "This field can be up to {{maxByte}} bytes.",
            "This field must pass today's datetime.": "This field must pass today's datetime.",
            "This file format is not supported.": "This file format is not supported.",
            "This is not a valid URL pattern.": "This is not a valid URL pattern.",
            "This schedules has updated information.<0/>Please refresh and try again. Do you want to refresh now?": "This schedules has updated information.<0/>Please refresh and try again. Do you want to refresh now?",
            "This stage is not accessible.": "This stage is not accessible.",
            "This space is not accessible.": "This space is not accessible.",
            "This whitelist field is required.": "This whitelist field is required.",
            "To request a channel approval, you must select a source.": "To request a channel approval, you must select a source.",
            "View only <0>requested channels</0>": "View only <0>requested channels</0>",
            "We're sorry!": "We're sorry!",
            "You can enter up to {{count}} whitelist rules": "You can enter up to {{count}} whitelist rules",
            "You can only enter {{count}} whitelist rules": "You can only enter {{count}} whitelist rules",
            "You can upload files up to 500KB in size.": "You can upload files up to 500KB in size.",
            "You can watch preview for 1 minute": "You can watch preview for 1 minute",
            "You do not have permission to access.": "You do not have permission to access.",
            "You don't have any {{name}} to select.": "You don't have any {{name}} to select.",
            "You don't have permission to view this page.": "You don't have permission to view this page.",
            "You need to sign in a Megazone Accounts account to get started.": "You need to sign in a Megazone Accounts account to get started.",
            "Inactivated by error": "Inactivated by error",
            "Error while inactivating": "Error while inactivating",
            "Error while activating": "Error while activating",
            "An attempt to 'Archive' failed.": "An attempt to 'Archive' failed.",
            "An attempt to 'Restore' failed. Please try again.": "An attempt to 'Restore' failed. Please try again.",
            "Please select a project you want to access.": "Please select a project you want to access.",
            "You have no site access.": "You have no site access.",
            "There is already a folder with the same name. Please change it to a different name.": "There is already a folder with the same name. Please change it to a different name.",
            "{{target}} names can’t contain “/”.": "{{target}} names can’t contain “/”.",
            "There is already a {{target}} with the same name. Please change it to a different name.": "There is already a {{target}} with the same name. Please change it to a different name.",
            "deleteModalReferenceNesting1": "$t(common::msg::deleteModalReferenceKey1)<1/>$t(common::msg::deleteModalReferenceKey3)",
            "deleteModalReferenceNesting2": "$t(common::msg::deleteModalReferenceKey2)<1/>$t(common::msg::deleteModalReferenceKey3)",
            "deleteModalReferenceKey1": "If you delete <0>{{name}}</0>, it will also be removed from Reference and you won’t be able to revert this{{dot}}",
            "deleteModalReferenceKey2": "If you delete <0>{{name}}</0>, You won’t be able to revert this{{dot}}",
            "deleteModalReferenceKey3": "Are you sure you want to delete <0>{{name}}</0>?",
            "Don’t ask again": "Don’t ask again",
            "Deleting {{currentIndex}} of {{deleteItemLength}}": "Deleting {{currentIndex}} of {{deleteItemLength}}",
            "You have selected <0>{{name}}</0>": "You have selected <0>{{name}}</0>",
            "Remove from category <0>{{name}}</0>": "Remove from category <0>{{name}}</0>",
            "Delete completely from Assets": "Delete completely from Assets",
            "It will also be removed from Reference and you won’t be able to revert this.": "It will also be removed from Reference and you won’t be able to revert this.",
            "If you archive the asset, you will be charged <0>the 90-day</0> archive amount immediately.": "If you archive the asset, you will be charged <0>the 90-day</0> archive amount immediately.",
            "Are you sure you want to archive?": "Are you sure you want to archive?",
            "If you restore the Archived Asset, You will be charged for the <0>remaining {{remainingDays}} days.</0>": "If you restore the Archived Asset, You will be charged for the <0>remaining {{remainingDays}} days.</0>",
            "Are you sure you want to restore?": "Are you sure you want to restore?",
            "Of the <0>{{currentDate}}</0> schedule, <0>only {{lineupCount}}</0> excluding the repeat lineup will be a all Copy to. Lineups with repeat lineups are excluded from the all copy to.": "Of the <0>{{currentDate}}</0> schedule, <0>only {{lineupCount}}</0> excluding the repeat lineup will be a all Copy to. Lineups with repeat lineups are excluded from the all copy to.",
            "Are you sure you all copy to?": "Are you sure you all copy to?",
            "There is a schedule on that date and it cannot be selected.<0/>Please delete the schedule for the selected date or select a different date.": "There is a schedule on that date and it cannot be selected.<0/>Please delete the schedule for the selected date or select a different date.",
            "The <0> {{lineupCount}} lineups </0> included in the <0>{{currentDate}}</0> schedule will be all Copy to. <1/>However, the repeat lineups of the selected lineup will stop repeating this and future schedules.": "The <0> {{lineupCount}} lineups </0> included in the <0>{{currentDate}}</0> schedule will be all Copy to. <1/>However, the repeat lineups of the selected lineup will stop repeating this and future schedules.",
            "<0>{{x}}</0> day(s) remaining": "<0>{{x}}</0> day(s) remaining",
            "Past broadcast lineup cannot be deleted.": "Past broadcast lineup cannot be deleted.",
            "Lineup currently being broadcast cannot be delete.": "Lineup currently being broadcast cannot be delete.",
            "Schedules within 1 minute from the current time cannot be deleted.": "Schedules within 1 minute from the current time cannot be deleted.",
            "If you want All Copy to, lineups with the repeat schedule will stop repeating this and future schedules.": "If you want All Copy to, lineups with the repeat schedule will stop repeating this and future schedules.",
            "If you want to delete lineups with repeat schedule, you cannot delete the past lineup that was broadcast, but you can delete future Lineups including this one will be deleted.": "If you want to delete lineups with repeat schedule, you cannot delete the past lineup that was broadcast, but you can delete future Lineups including this one will be deleted.",
            "Set up a YouTube account to publish.": "Set up a YouTube account to publish.",
            "To add the channels of the account you want to publish, sign in to Youtube with that account.": "To add the channels of the account you want to publish, sign in to Youtube with that account.",
            "Duplicate login status.": "Duplicate login status.",
            "You are currently logged in from another web browser with your information, the connection is terminated and you are directed to the welcome page.": "You are currently logged in from another web browser with your information, the connection is terminated and you are directed to the welcome page.",
            "Your account has been expired.": "Your account has been expired.",
            "Your account has been inactivated.": "Your account has been inactivated.",
            "Your account has been deleted.": "Your account has been deleted.",
            "You cannot access the project.<0/>The connection is terminated and you are directed to the welcome page.": "You cannot access the project.<0/>The connection is terminated and you are directed to the welcome page.",
            "After starting the channel, you can watch past broadcasts by changing the playback position for up to 14 days.": "After starting the channel, you can watch past broadcasts by changing the playback position for up to 14 days.",
            "Find objects by prefix": "Find objects by prefix",
            "A total of <0>{{type}}</0> participants can be invited per account, and participants must be divided into the schedule of the channels to be created.": "A total of <0>{{type}}</0> participants can be invited per account, and participants must be divided into the schedule of the channels to be created.",
            "Megazone Accounts members, please sign in through the button below.": "Megazone Accounts members, please sign in through the button below.",
            "Megazone Login users, please sign in through the button below.": "Megazone Login users, please sign in through the button below.",
            "If you do not have an account yet, please sign up through": "If you do not have an account yet, please sign up through.",
            "If you don’t have an account yet, please ask your Organization Administrator.": "If you don’t have an account yet, please ask your Organization Administrator.",
            "Go to log in with": "Go to log in with",
            "You need to sign in a {{Megazone Accounts}} {{or}} {{Megazone Login}} account to get started.": "You need to sign in a {{Megazone Accounts}} {{or}} {{Megazone Login}} account to get started.",
            "You do not have permission to Show Hidden Metadata.": "You do not have permission to Show Hidden Metadata.",
            "If you to Show Hidden Metadata, please ask your administration.": "If you to Show Hidden Metadata, please ask your administration.",
            "Select a one file from the audio type of assets.": "Select a one file from the audio type of assets.",
            "Select a one file from the image type of assets.": "Select a one file from the image type of assets.",
            "The key field be up to {{tag}} byte long.": "The key field be up to {{tag}} byte long.",
            "Please add a {{name}} assets to use.": "Please add a {{name}} assets to use.",
            "You can't access the space.": "You can't access the space.",
            "The space is inaccessible because your account has expired or has been deleted.": "The space is inaccessible because your account has expired or has been deleted.",
            "Please contact your space manager.": "Please contact your space manager.",
            "If you have issues with Space approval, please contact Megazone Cloud.": "If you have issues with Space approval, please contact Megazone Cloud.",
            "If you want to site access, please contact your space manager.": "If you want to site access, please contact your space manager.",
            "You need access": "You need access",
            "If you want to check the assets you have selected, <0/> please ask for access.": "If you want to check the assets you have selected, <0/> please ask for access.",
            "Request sent": "Request sent",
            "You will receive an email letting you know that <0/> the asset has been shared with you.": "You will receive an email letting you know that <0/> the asset has been shared with you.",
            "Enter Display Name or Username": "Enter Display Name or Username",
            "This asset has been deleted.": "This asset has been deleted.",
            "The deleted asset is removed from the Requested to Share.": "The deleted asset is removed from the Requested to Share.",
            "If necessary, contact the administrator.": "If necessary, contact the administrator.",
            "Are you sure you want to reject sharing request for <0>{{name}}</0>?": "Are you sure you want to reject sharing request for <0>{{name}}</0>?",
            "Reason for rejection of sharing request (optional)": "Reason for rejection of sharing request (optional)",
            "There is no analytics data.": "There is no analytics data.",
            "Detailed view of <0> {{number}} </0> tasks": "Detailed view of <0> {{number}} </0> tasks",
            "files to the <0>{{name}}</0>": "files to the <0>{{name}}</0>",
            "An item with the name '<0>{{name}}</0>' is already in this location.": "An item with the name '<0>{{name}}</0>' is already in this location.",
            "Do you want to overwrite it with the target file?": "Do you want to overwrite it with the target file?",
            "Renaming in <0>{{name}}</0>": "Renaming in <0>{{name}}</0>",
            "Moving <0>{{totalCount}}</0> files from the <0>{{sourceFolderName}}</0> to the <0>{{distFolderName}}</0>": "Moving <0>{{totalCount}}</0> files from the <0>{{sourceFolderName}}</0> to the <0>{{distFolderName}}</0>",
            "Copying <0>{{totalCount}}</0> files from the <0>{{sourceFolderName}}</0> to the <0>{{distFolderName}}</0>": "Copying <0>{{totalCount}}</0> files from the <0>{{sourceFolderName}}</0> to the <0>{{distFolderName}}</0>",
            "All linked video source assets have been deleted, <0/> so the video preview cannot be seen.": "All linked video source assets have been deleted, <0/> so the video preview cannot be seen.",
            "There are no items for video AI analysis.": "There are no items for video AI analysis.",
            "Please add music file.": "Please add music file.",
            "Select files from the Audio type of assets.": "Select files from the Audio type of assets.",
            "Cannot change settings from Project Settings.": "Cannot change settings from Project Settings.",
            "Cannot change settings from Console.": "Cannot change settings from Console.",
            "Add one caption asset to use.<0/>The kind of caption can only select subtitles.": "Add one caption asset to use.<0/>The kind of caption can only select subtitles.",
            "Select files from the video type of assets.": "Select files from the video type of assets.",
            "Please add itemSet for metadata.": "Please add itemSet for metadata.",
            "There is no ItemSet to select. Please add a ItemSet.": "There is no ItemSet to select. Please add a ItemSet.",
            "The caption of the program can be edited in the caption of the <0> {{number}} </0>": "The caption of the program can be edited in the caption of the <0> {{number}} </0>",
            "There is a duplicate language among the captions applied to the <0> {{name}} </0>": "There is a duplicate language among the captions applied to the <0> {{name}} </0>",
            "Please create a lineup after editing in the video as it is difficult to create a lineup if there are duplicate languages.": "Please create a lineup after editing in the video as it is difficult to create a lineup if there are duplicate languages.",
            "Changed data exists. Are you sure you want to escape?": "Changed data exists. Are you sure you want to escape?",
            "Add attendees to join the Group Chatting": "Add attendees to join the Group Chatting",
            "Enter Email Address": "Enter Email Address",
            "Saving of changes to '{{tab}}' failed.": "Saving of changes to '{{tab}}' failed.",
            "Changes to the '{{tab}}' have been saved.": "Changes to the '{{tab}}' have been saved.",
            "File upload failed.": "File upload failed.",
            "An invalid input file was selected.": "An invalid input file was selected.",
            "Asset creation failed.": "Asset creation failed.",
            "The input file is in an unsupported format.": "The input file is in an unsupported format.",
            "The transcoding operation failed due to an unexpected problem.": "The transcoding operation failed due to an unexpected problem.",
            "If the problem persists, please contact the management.": "If the problem persists, please contact the management.",
            "Please use a different file after checking the file upload rules.": "Please use a different file after checking the file upload rules.",
            "Please use a different file after checking the 'Supported File Formats' of the file upload rules.": "Please use a different file after checking the ‘Supported File Formats’ of the file upload rules.",
            "The media information may not be queried, or an invalid file may have been entered.": "The media information may not be queried, or an invalid file may have been entered.",
            "Use streaming software to send live streams to Amazon IVS, providing users with low-latency live stream services and interactive video experiences.": "Use streaming software to send live streams to Amazon IVS, providing users with low-latency live stream services and interactive video experiences.",
            "Provides real-time communication components such as online conferencing services by leveraging messaging, audio, video and screen sharing capabilities to web or mobile applications.": "Provides real-time communication components such as online conferencing services by leveraging messaging, audio, video and screen sharing capabilities to web or mobile applications.",
            "Broadcast and deliver live video in up to Full HD.": "Broadcast and deliver live video in up to Full HD.",
            "Broadcast and deliver live video in up to SD.": "Broadcast and deliver live video in up to SD.",
            "Best for near real-time interactions with viewers.": "Best for near real-time interactions with viewers.",
            "Enable if real-time interactivity with viewers is not required. May improve reliability in certain regions.": "Enable if real-time interactivity with viewers is not required. May improve reliability in certain regions.",
            "Enable token-authorization requirement for video playback.": "Enable token-authorization requirement for video playback.",
            "Channel’s live stream is automatically recorded and created as Videos and Assets.": "Channel’s live stream is automatically recorded and created as Videos and Assets.",
            "A chat where all attendees on the channel can join the chat.": "A chat where all attendees on the channel can join the chat.",
            "A chat that allows for close interaction between invited attendees.": "A chat that allows for close interaction between invited attendees.",
            "If the chat type is modified after channel creation, all previously set values are initialized.": "If the chat type is modified after channel creation, all previously set values are initialized.",
            "Failed to save changes": "Failed to save changes",
            "Search for files in Assets.": "Search for files in Assets.",
            "You are about to revoke site access for <0>{{name}}</0>.<1/>This user won’t be able to use your space. You can give them access at any time.<1/>Are you sure you want to revoke site access for this user?": "You are about to revoke site access for <0>{{name}}</0>.<1/>This user won’t be able to use your space. You can give them access at any time.<1/>Are you sure you want to revoke site access for this user?",
            "You are about to remove  <0>{{name}}</0> from space.<1/>This user will no longer have access to the space. Your space will still keep all of this user’s contributions.<1/>Are you sure you want to remove user from space?": "You are about to remove  <0>{{name}}</0> from space.<1/>This user will no longer have access to the space. Your space will still keep all of this user’s contributions.<1/>Are you sure you want to remove user from space?",
            "Bucket names must be between 3 and 63 characters long.": "Bucket names must be between 3 and 63 characters long.",
            "Bucket names can consist only of lowercase letters, numbers, dots (.), and hyphens (-).": "Bucket names can consist only of lowercase letters, numbers, dots (.), and hyphens (-).",
            "Bucket names must begin and end with a letter or number.": "Bucket names must begin and end with a letter or number.",
            "Bucket names must not be formatted as an IP address (for example, 192.168.5.4).": "Bucket names must not be formatted as an IP address (for example, 192.168.5.4).",
            "Bucket names must not start with the prefix xn--.": "Bucket names must not start with the prefix xn--.",
            "Bucket names must not end with the suffix -s3alias.": "Bucket names must not end with the suffix -s3alias.",
            "Bucket names cannot have consecutive periods.": "Bucket names cannot have consecutive periods.",
            "You can enter up to 10 users.": "You can enter up to 10 users.",
            "Of the selected assets, {{createItemLength}} out of {{selectedItemLength}} can be created as photos. <1/>Choose whether you want <0>the {{createItemLength}} assets</0> to be multiple photos or a single photo.": "Of the selected assets, {{createItemLength}} out of {{selectedItemLength}} can be created as photos. <1/>Choose whether you want <0>the {{createItemLength}} assets</0> to be multiple photos or a single photo.",
            "The {{createItemLength}} selected assets have been selected to be created as multiple photos.<0/>Would you like to create a photo now?": "The {{createItemLength}} selected assets have been selected to be created as multiple photos.<0/>Would you like to create a photo now?",
            "The photo name is applied to the name being used in the asset, and metadata can be edited in the created photo.": "The photo name is applied to the name being used in the asset, and metadata can be edited in the created photo.",
            "Would you like to log out from the account service as well?": "Would you like to log out from the account service as well?",
            "Conveniently apply to asset types through the Apply All Over option.": "Conveniently apply to asset types through the Apply All Over option.",
            "There is a history of individual modification of some metadata among assets of this asset type.": "There is a history of individual modification of some metadata among assets of this asset type.",
            "If you save, all the changed metadata will be applied.": "If you save, all the changed metadata will be applied.",
            "Are you sure you want to fix it though?": "Are you sure you want to fix it though?",
            "When applied, all default metadata is applied.": "When applied, all default metadata is applied.",
            "Do you still want to apply?": "Do you still want to apply?",
            "Changes made to files in the storage list are not updated here.": "Changes made to files in the storage list are not updated here.",
            "If you want to change the file, you must close the ‘Create Asset Bulk’ screen and re-enter after making changes in the storage list.": "If you want to change the file, you must close the ‘Create Asset Bulk’ screen and re-enter after making changes in the storage list.",
            "If the asset contains only one single file": "If the asset contains only one single file",
            "If the asset contains multiple files": "If the asset contains multiple files",
            "If the language code for the file is appended after the file name (_), the language and label are automatically applied.": "If the language code for the file is appended after the file name (_), the language and label are automatically applied.",
            "If the language code is not applied after the file name (_), the language and label are applied in English (United States).": "If the language code is not applied after the file name (_), the language and label are applied in English (United States).",
            "Add files in the first step, Add Files to Bulk.": "Add files in the first step, Add Files to Bulk.",
            "Language and label are automatically applied language and label.": "Language and label are automatically applied language and label.",
            "Language and labels apply in English (United States).": "Language and labels apply in English (United States).",
            "Kind default is applied as caption type.": "Kind default is applied as caption type.",
            "Creation for {{count}} assets requested.": "Creation for {{count}} assets requested.",
            "It may take some time for stable processing because it is downloading a file from a location far away from the current location (overseas) or a large file.": "It may take some time for stable processing because it is downloading a file from a location far away from the current location (overseas) or a large file.",
            "If you want to check the file you have selected, <0/> Please contact your space administrator.": "If you want to check the file you have selected, <0/> Please contact your space administrator.",
            "If it is an item in the 'Current Project', all functions can be used.": "If it is an item in the 'Current Project', all functions can be used.",
            "If it is an accessible 'Not Accessible' item, all functions cannot be used.": "If it is an accessible 'Not Accessible' item, all functions cannot be used.",
            "If it is an accessible 'other project' item, you can use the download function.": "If it is an accessible 'other project' item, you can use the download function.",
            "To check the folder, select the project to which the bucket the folder<0/>belongs to, and then switch the site to the selected project.": "To check the folder, select the project to which the bucket the folder<0/>belongs to, and then switch the site to the selected project.",
            "Are you sure you want to check the folder<0/>after switching to the selected project?": "Are you sure you want to check the folder<0/>after switching to the selected project?",
            "Download period is up to <0>{{totalCount}}</0> days, and the number of downloads is up to <0>{{sourceFolderName}}</0> times.": "Download period is up to <0>{{totalCount}}</0> days, and the number of downloads is up to <0>{{sourceFolderName}}</0> times.",
            "The download period is up to <0> {{number}} </0> days.": "The download period is up to <0> {{number}} </0> days.",
            "The number of downloads is up to <0/> times.": "The number of downloads is up to <0/> times.",
            "The download period is up to <0>{{period}}</0> days,<1/>and the number of downloads is up to <0>{{count}}</0> times left.": "The download period is up to <0>{{period}}</0> days,<1/>and the number of downloads is up to <0>{{count}}</0> times left.",
            "The password is wrong <0>{{count}}</0> times. Please check the password.": "The password is wrong <0>{{count}}</0> times. Please check the password.",
            "In case of error <0>{{count}}</0> times, the download link URL is no longer available.": "In case of error <0>{{count}}</0> times, the download link URL is no longer available.",
            "If you want to continue downloading,<0/>please get the download link URL back.": "If you want to continue downloading,<0/>please get the download link URL back.",
            "The requested page may have disappeared or the path may be incorrect.<0/>Please check and try again.": "The requested page may have disappeared or the path may be incorrect.<0/>Please check and try again.",
            "The download period is up to <0>{{period}}</0> days.": "The download period is up to <0>{{period}}</0> days.",
            "up to <0/> times.": "up to <0/> times.",
            "Are you sure you want to approval the selected<0/><1>{{name}}</1>?": "Are you sure you want to approval the selected<0/><1>{{name}}</1>?",
            "Are you sure you want to reject the selected<0/><1>{{name}}</1>?": "Are you sure you want to reject the selected<0/><1>{{name}}</1>?",
            "If you remove <0>{{name}}</0>, the item is deleted from the view.": "If you remove <0>{{name}}</0>, the item is deleted from the view.",
            "Other users will still have access.": "Other users will still have access.",
            "Are you sure you want to remove the item?": "Are you sure you want to remove the item?",
            "If you remove <0>{{number}}</0> other then <0>{{name}}</0>, the items is deleted from the view.": "If you remove <0>{{number}}</0> other then <0>{{name}}</0>, the items is deleted from the view.",
            "Are you sure you want to remove the items?": "Are you sure you want to remove the items?",
            "Also, all shared users will no longer have access and will be removed from the shared list.": "Also, all shared users will no longer have access and will be removed from the shared list.",
            "Select the folder path. If not specified, it is stored in the top-level path.": "Select the folder path. If not specified, it is stored in the top-level path.",
            "The folder path of the asset is a virtual path specified by the user and is different from the actual S3 folder path.": "The folder path of the asset is a virtual path specified by the user and is different from the actual S3 folder path.",
            "Deleting {{currentIndex}} of <0>{{deleteItemLength}}</0> assets": "Deleting {{currentIndex}} of <0>{{deleteItemLength}}</0> assets",
            "If you delete <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to delete?": "If you delete <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to delete?",
            "If you delete <0>{{name}}</0>,  will also be removed from reference and you won’t be able to revert this.<1/>Are you sure you want to delete?": "If you delete <0>{{name}}</0>,  will also be removed from reference and you won’t be able to revert this.<1/>Are you sure you want to delete?",
            "The download period is up to <0>{{period}}</0> days left.": "The download period is up to <0>{{period}}</0> days left.",
            "File {{item}} has been shared": "File {{item}} has been shared",
            "Asset {{item}} has been shared": "Asset {{item}} has been shared",
            "There was an error removing file {{item}}": "There was an error removing file {{item}}",
            "There was an error removing asset {{item}}": "There was an error removing asset {{item}}",
            "Discard unsaved changes?": "Discard unsaved changes?",
            "Asset {{item}} and {{length}} other items have been removed.": "Asset {{item}} and {{length}} other items have been removed.",
            "File {{item}} and {{length}} other items have been removed.": "File {{item}} and {{length}} other items have been removed.",
            "Asset {{item}} has been removed.": "Asset {{item}} has been removed.",
            "File {{item}} has been removed.": "File {{item}} has been removed.",
            "There was an error removing file {{item}} and {{length}} other items.": "There was an error removing file {{item}} and {{length}} other items.",
            "There was an error removing asset {{item}} and {{length}} other items.": "There was an error removing asset {{item}} and {{length}} other items.",
            "There was an error removing file {{item}}.": "There was an error removing file {{item}}.",
            "There was an error removing asset {{item}}.": "There was an error removing asset {{item}}.",
            "There was an error sharing file {{item}}.": "There was an error sharing file {{item}}.",
            "There was an error sharing asset {{item}}.": "There was an error sharing asset {{item}}.",
            "Since this is a category group that is not used in assets, you can check the created assets in 'categories not classified in assets'.": "Since this is a category group that is not used in assets, you can check the created assets in 'categories not classified in assets'.",
            "There was an error deleting folder {{item}}.": "There was an error deleting folder {{item}}.",
            "Deletion of folder {{item}} has been completed.": "Deletion of folder {{item}} has been completed.",
            "Creation of new folder {{item}} is completed.": "Creation of new folder {{item}} is completed.",
            "There was an error creating the new folder {{item}}.": "There was an error creating the new folder {{item}}.",
            "If you delete <0>{{name}}</0>, you won't be able to revert this.": "If you delete <0>{{name}}</0>, you won't be able to revert this.",
            "Sync requested.": "Sync requested.",
            "If you archive the asset, you will be charged the <0>90-day</0> archive<1/> amount immediately.<1/>Are you sure you want to archive?": "If you archive the asset, you will be charged the <0>90-day</0> archive<1/> amount immediately.<1/>Are you sure you want to archive?",
            "Move completed from {{item1}} to {{item2}}.": "Move completed from {{item1}} to {{item2}}.",
            "Moved '{{item1}}' into '{{item2}}'.": "Moved '{{item1}}' into '{{item2}}'.",
            "Failed to save the folder order change. Reverted to the original state.": "Failed to save the folder order change. Reverted to the original state.",
            "Failed to save the folder move. Reverted to the original state.": "Failed to save the folder move. Reverted to the original state.",
            "Refreshing the folder tree. Please try again.": "Refreshing the folder tree. Please try again.",
            "Error moving from {{item1}} to {{item2}}.": "Error moving from {{item1}} to {{item2}}.",
            "Error renaming from {{item1}} to {{item2}}.": "Error renaming from {{item1}} to {{item2}}.",
            "This folder contains assets.": "This folder contains assets.",
            "Rename completed from {{item1}} to {{item2}}.": "Rename completed from {{item1}} to {{item2}}.",
            "The sharing period for this file has expired. <0/> If you want to check the file you have selected, <0/> Please ask the sharer to share.": "The sharing period for this file has expired. <0/> If you want to check the file you have selected, <0/> Please ask the sharer to share.",
            "There was an error creating event trigger.": "There was an error creating event trigger.",
            "Error deleting asset '{{name}}'. {{line}} Please refresh the page and try again.": "Error deleting asset '{{name}}'. {{line}} Please refresh the page and try again.",
            "Asset '{{name}}' has been deleted.": "Asset '{{name}}' has been deleted.",
            "Error deleting asset '{{name}}' and {{count}} others. {{line}} Please refresh the page and try again.": "Error deleting asset '{{name}}' and {{count}} others. {{line}} Please refresh the page and try again.",
            "Asset '{{name}}' and {{count}} other assets have been deleted.": "Asset '{{name}}' and {{count}} other assets have been deleted.",
            "Error archiving asset '{{name}}'. {{line}} Please refresh the page and try again.": "Error archiving asset '{{name}}'. {{line}} Please refresh the page and try again.",
            "Asset '{{name}}' has been restored.": "Asset '{{name}}' has been restored.",
            "Error restoring asset '{{name}}'. {{line}} Please refresh the page and try again.": "Error restoring asset '{{name}}'. {{line}} Please refresh the page and try again.",
            "Error saving changes to {{resource}} settings. {{line}} Please refresh the page and try again.": "Error saving changes to {{resource}} settings. {{line}} Please refresh the page and try again.",
            "Changes to your {{resource}} settings have been saved.": "Changes to your {{resource}} settings have been saved.",
            "Event trigger '{{name}}' has been added.": "Event trigger '{{name}}' has been added.",
            "You don't have access. {{line}} Please contact the manager.": "You don't have access. {{line}} Please contact the manager.",
            "Error adding asset '{{name}}'. {{line}} Please refresh the page and try again.": "Error adding asset '{{name}}'. {{line}} Please refresh the page and try again.",
            "Error adding asset '{{name}}' and {{count}} others. {{line}} Please refresh the page and try again.": "Error adding asset '{{name}}' and {{count}} others. {{line}} Please refresh the page and try again.",
            "Asset '{{name}}' has been added.": "Asset '{{name}}' has been added.",
            "Asset '{{name}}' and {{count}} other assets have been added.": "Asset '{{name}}' and {{count}} other assets have been added.",
            "The access of asset '{{name}}' has been updated to private.": "The access of asset '{{name}}' has been updated to private.",
            "The access of asset '{{name}}' has been updated to public.": "The access of asset '{{name}}' has been updated to public.",
            "Error updating asset '{{name}}' with access to private. {{line}} Please refresh the page and try again.": "Error updating asset '{{name}}' with access to private. {{line}} Please refresh the page and try again.",
            "Error updating asset '{{name}}' with access to public. {{line}} Please refresh the page and try again.": "Error updating asset '{{name}}' with access to public. {{line}} Please refresh the page and try again.",
            "Event trigger '{{name}}' has been deleted.": "Event trigger '{{name}}' has been deleted.",
            "Error deleting event trigger '{{name}}'. {{line}} Please refresh the page and try again.": "Error deleting event trigger '{{name}}'. {{line}} Please refresh the page and try again.",
            "The name has been updated.": "The name has been updated.",
            "Attributions has been updated.": "Attributions has been updated.",
            "Tags has been updated.": "Tags has been updated.",
            "Error updating the name. {{line}} Please refresh the page and try again.": "Error updating the name. {{line}} Please refresh the page and try again.",
            "Error updating the description. {{line}} Please refresh the page and try again.": "Error updating the description. {{line}} Please refresh the page and try again.",
            "Error updating attributions. {{line}} Please refresh the page and try again.": "Error updating attributions. {{line}} Please refresh the page and try again.",
            "Error updating Tags. {{line}} Please refresh the page and try again.": "Error updating Tags. {{line}} Please refresh the page and try again.",
            "Error updating status to active. {{line}} Please refresh the page and try again.": "Error updating status to active. {{line}} Please refresh the page and try again.",
            "Error updating status to inactive. {{line}} Please refresh the page and try again.": "Error updating status to inactive. {{line}} Please refresh the page and try again.",
            "Error updating conditions. {{line}} Please refresh the page and try again.": "Error updating conditions. {{line}} Please refresh the page and try again.",
            "Error updating Actions. {{line}} Please refresh the page and try again.": "Error updating Actions. {{line}} Please refresh the page and try again.",
            "Status updated to active.": "Status updated to active.",
            "Status updated to inactive.": "Status updated to inactive.",
            "Conditions has been updated.": "Conditions has been updated.",
            "Actions has been updated.": "Actions has been updated.",
            "You don't have permission to access this item.": "You don't have permission to access this item.",
            "Page not found. {{line}} The page you are looking for doesn't exist or an other error occurred.": "Page not found. {{line}} The page you are looking for doesn't exist or an other error occurred.",
            "That's an error. {{line}} Please try again later.": "That's an error. {{line}} Please try again later.",
            "Your request resulted in an error. {{line}} please try again.": "Your request resulted in an error. {{line}} please try again.",
            "The download of asset '{{name}}' has been requested.": "The download of asset '{{name}}' has been requested.",
            "Error requesting download of asset '{{name}}'. {{line}} Please refresh the page and try again.": "Error requesting download of asset '{{name}}'. {{line}} Please refresh the page and try again.",
            "The file has been updated.": "The file has been updated.",
            "Error updating the file. {{line}} Please refresh the page and try again.": "Error updating the file. {{line}} Please refresh the page and try again.",
            "Error adding event trigger '{{name}}'. {{line}} Please refresh the page and try again.": "Error adding event trigger '{{name}}'. {{line}} Please refresh the page and try again.",
            "If you delete \"<0>{{name}}</0>\", you won’t be able to revert this.<1/>Are you sure you want to delete?": "If you delete \"<0>{{name}}</0>\", you won’t be able to revert this.<1/>Are you sure you want to delete?",
            "Deleting <0>{{currentIndex}}</0>  of <0>{{deleteItemLength}}</0> assets": "Deleting <0>{{currentIndex}}</0> of <0>{{deleteItemLength}}</0> assets",
            "\"<0>{{name}}</0>\" will be deleted forever and you won’t be abled to restore it.": "\"<0>{{name}}</0>\" will be deleted forever and you won’t be abled to restore it.",
            "If you navigate away from this page,<1/>your changes cannot be saved.": "If you navigate away from this page,<1/>your changes cannot be saved.",
            "“{{name}}” will be deleted forever and you won’t be abled to restore it.": "“{{name}}” will be deleted forever and you won’t be abled to restore it.",
            "It can only be deleted if there are no assets in the folder.": "It can only be deleted if there are no assets in the folder.",
            "Specify the folder location?": "Specify the folder location?",
            "Asset '{{name}}' has been moved from '{{fromFolder}}' to Folder '{{toFolder}}'.": "Asset '{{name}}' has been moved from '{{fromFolder}}' to Folder '{{toFolder}}'.",
            "Asset '{{name}}' and {{count}} other has been moved from '{{fromFolder}}' to Folder '{{toFolder}}'.": "Asset '{{name}}' and {{count}} other has been moved from '{{fromFolder}}' to Folder '{{toFolder}}'.",
            "It may take time to send mail when there are {{count}} or more shared files or folders. (Approximately 3 minutes per 1GB)": "It may take time to send mail when there are {{count}} or more shared files or folders. (Approximately 3 minutes per 1GB)",
            "Depending on the size of the shared file, it may take time to send the email. (Approximately 3 minutes per 1GB)": "Depending on the size of the shared file, it may take time to send the email. (Approximately 3 minutes per 1GB)",
            "If you restore this item now, you will also be charged for the <NewLine>remaining <Strong>{{n}} days.</Strong></NewLine>": "If you restore this item now, you will also be charged for the <NewLine>remaining <Strong>{{n}} days.</Strong></NewLine>",
            "No search results found.": "No search results found.",
            "Search for the owner of the asset.": "Search for the owner of the asset.",
            "Enter after typing": "Enter after typing",
            "Enter the extension in lowercase without a dot. (e.g. mp4)": "Enter the extension in lowercase without a dot. (e.g. mp4)",
            "The download of asset '{{name}}' and {{count}} other have been requested.": "The download of asset '{{name}}' and {{count}} other have been requested.",
            "Please select the project you wish to access.": "Please select the project you wish to access.",
            "Please search by asset name.": "Please search by asset name.",
            "Please enter the name.": "Please enter the name.",
            "Please enter the description.": "Please enter the description.",
            "Error saving changes to project details. {{line}} Please refresh the page and try again.": "Error saving changes to project details. {{line}} Please refresh the page and try again.",
            "Changes to your project details settings have been saved.": "Changes to your project details settings have been saved.",
            "Error adding project '{{name}}'. {{line}} Please refresh the page and try again.": "Error adding project '{{name}}'. {{line}} Please refresh the page and try again.",
            "Project '{{name}}' has been added.": "Project '{{name}}' has been added.",
            "The project lead has been updated.": "The project lead has been updated.",
            "Error updating the project lead. {{line}} Please refresh the page and try again.": "Error updating the project lead. {{line}} Please refresh the page and try again.",
            "Asset '{{name}}' has been archived.": "Asset '{{name}}' has been archived.",
            "This setting can lock the bucket so that other users cannot use the storage’s features (Copy, Move, Rename, Delete).": "This setting can lock the bucket so that other users cannot use the storage’s features (Copy, Move, Rename, Delete).",
            "This bucket is locked by another user and can only be downloaded.": "This bucket is locked by another user and can only be downloaded.",
            "Bucket '{{name}}' is feature locked for other users.": "Bucket '{{name}}' is feature locked for other users.",
            "Bucket '{{name}}' is feature unlocked for another user.": "Bucket '{{name}}' is feature unlocked for another user.",
            "Error occurred while feature-locking bucket '{{name}}' for another user. {{line}} Please refresh the page and try again.": "Error occurred while feature-locking bucket '{{name}}' for another user. {{line}} Please refresh the page and try again.",
            "Error occurred while attempting to feature unlock bucket '{{name}}' for another user. {{line}} Please refresh the page and try again.": "Error occurred while attempting to feature unlock bucket '{{name}}' for another user. {{line}} Please refresh the page and try again.",
            "No items match this filter": "No items match this filter",
            "None of achives matched this search": "None of achives matched this search",
            "Find items using another filter option.": "Find items using another filter option.",
            "Try another search, <br/> or use the search option to find an asset.": "Try another search, <br/> or use the search option to find an asset.",
            "You can archive by selecting the items you want to <br/> archive under “Assets”.": "You can archive by selecting the items you want to <br/> archive under “Assets”.",
            "No items have been archived yet.": "No items have been archived yet.",
            "Enter Asset Name": "Enter Asset Name",
            "Enter Archived ID": "Enter Archived ID",
            "Enter Asset ID": "Enter Asset ID",
            "Enter Archived by": "Enter Archived by",
            "Enter Owner": "Enter Owner",
            "Welcome": "Welcome",
            "You need to log in to your Megazone account to start CloudPlex.": "You need to log in to your Megazone account to start CloudPlex.",
            "Login with your Megazone account": "Login with your Megazone account",
            "Size of files Option : Number of files option is required. <NewLine/> Number of files option : Can be set without checking size of files.": "Size of files Option : Number of files option is required. <NewLine/> Number of files option : Can be set without checking size of files.",
            "If you archive the assets, you will be charged the <0>{{n}}-day</0> archive<1/> amount immediately.": "If you archive the assets, you will be charged the <0>{{n}}-day</0> archive<1/> amount immediately.",
            "If you archive the asset, you will be charged the <0>{{n}}-day</0> archive<1/> amount immediately.": "If you archive the asset, you will be charged the <0>{{n}}-day</0> archive<1/> amount immediately.",
            "If you restore this item now, you will also be charged for the <NewLine/>remaining days per asset.": "If you restore this item now, you will also be charged for the <NewLine/>remaining days per asset.",
            "Getting Access Token...": "Getting Access Token...",
            "Get Access Token": "Get Access Token",
            "To use CloudPlex Delivery's CDN, an Access Token must be issued.": "To use CloudPlex Delivery's CDN, an Access Token must be issued.",
            "Please search by asset name or ID.": "Please search by asset name or ID.",
            "No Collection items yet.": "No Collection items yet.",
            "Add it using the “Create” button.": "Add it using the “Create“ button.",
            "No linked collection yet.": "No linked collection yet.",
            "No assets yet.": "No assets yet.",
            "Add it using the “+” button.": "Add it using the “+” button.",
            "Please search by collection name.": "Please search by collection name.",
            "Selected assets can be archived by selecting the storage <NewLine/> class to be archived.": "Selected assets can be archived by selecting the storage <NewLine/> class to be archived.",
            "Selected assets can be restored by selecting a restore <NewLine/>option based on how they were archived.": "Selected assets can be restored by selecting a restore <NewLine/>option based on how they were archived.",
            "“{{name}}” and {{count}} others will be deleted forever and you won’t be abled to restore it.": "“{{name}}” and {{count}} others will be deleted forever and you won’t be abled to restore it.",
            "However, assets included in the collection are not deleted.": "However, assets included in the collection are not deleted.",
            "Deletion of collection {{item}} has been completed.": "Partial deletion of collection {{item}} has been completed.",
            "Partial deletion of collection {{item}} and {{count}} others have been completed.": "Partial deletion of collection {{item}} and {{count}} others has been completed.",
            "Deletion of collection {{item}} and {{count}} others have been completed.": "Deletion of collection {{item}} and {{count}} others have been completed.",
            "There was an error deleting collection": "There was an error deleting collection",
            "There was an error deleting collections": "There was an error deleting collections",
            "Size of files Option : If you choose your own assets, you can have up to {{maxAssets}}. <NewLine/> Keep the number of selected assets under {{maxAssets}}.": "Size of files Option : If you choose your own assets, you can have up to {{maxAssets}}. <NewLine/> Keep the number of selected assets under {{maxAssets}}.",
            "Select assets through search to put them in your collection.": "Select assets through search to put them in your collection.",
            "Select the folder containing the assets you want to put in your collection.": "Select the folder containing the assets you want to put in your collection.",
            "Select collections through search to put them in your collection.": "Select collections through search to put them in your collection.",
            "The maximum number of tags, {{maxCount}}, has been exceeded.": "The maximum number of tags, {{maxCount}}, has been exceeded.",
            "Please search by collection name or ID.": "Please search by collection name or ID.",
            "Deletion of content schema {{item}} has been completed.": "Deletion of content schema {{item}} has been completed.",
            "There was an error deleting content schema.": "There was an error deleting content schema.",
            "Content schema '{{name}}' has been added.": "Content schema '{{name}}' has been added.",
            "Up to 50 {{referenceType}} can be registered": "Up to 50 {{referenceType}} can be registered",
            "You can activate a fortress field right away, and you can additionally turn the field into a user camp.": "You can activate a fortress field right away, and you can additionally turn the field into a user camp.",
            "No projects are in use yet.": "No projects are in use yet.",
            "You must add at least 1 field for “Reference Fields”.<NewLine/> Only then can the schema status be changed to “active” and used in the project.": "You must add at least 1 field for “Reference Fields”.<NewLine/> Only then can the schema status be changed to “active” and used in the project.",
            "After opening the Fields panel via the “Add Fields” button,<NewLine/> add fields by dragging them to the “{{isReference}} Fields” layout.": "After opening the Fields panel via the “Add Fields” button,<NewLine/> add fields by dragging them to the “{{isReference}} Fields” layout.",
            "The name starts with English, contains at least 2 letters, and can only contain English, spaces, and numbers.": "The name starts with English, contains at least 2 letters, and can only contain English, spaces, and numbers.",
            "No items yet.": "No items yet.",
            "Add it using the “Add {{name}}” button.": "Add it using the “Add {{name}}” button.",
            "“{{name}}” will be removed.": "“{{name}}” will be removed.",
            "“{{name}}” and {{count}} others will be removed.": "“{{name}}” and {{count}} others will be removed.",
            "None of collection matched this search. {{line}} Try another search.": "None of collection matched this search. {{line}} Try another search.",
            "Delete the item?": "Delete the item?",
            "Delete these items?": "Delete these items?",
            "However, assets and content contained in {{schemaName}} are not deleted.": "However, assets and content contained in {{schemaName}} are not deleted.",
            "Select preview image through search to put them in your content.": "Select preview image through search to put them in your content.",
            "Deletion of custom content {{item}} and {{count}} others has been completed.": "Deletion of custom content {{item}} and {{count}} others has been completed.",
            "Deletion of custom content {{item}} has been completed.": "Deletion of custom content {{item}} has been completed.",
            "Please search by name or ID.": "Please search by name or ID.",
            "Please search by {{resourceType}} name or ID.": "Please search by {{resourceType}} name or ID.",
            "Try another search to find an content.": "Try another search to find an content.",
            "You must enter your authentication information to use the engine.": "You must enter your authentication information to use the engine.",
            "Delete message?": "Delete message?",
            "Deleting a message cannot be canceled.": "Deleting a message cannot be canceled.",
            "This message was deleted.": "This message was deleted.",
            "Please enter your message.": "Please enter your message.",
            "Would you like to make a private comment?": "Would you like to make a private comment?",
            "Please enter a private comment name.": "Please enter a private comment name.",
            "Add users to participate in private comments.": "Add users to participate in private comments.",
            "you can add users of the project to communicate with them.": "you can add users of the project to communicate with them.",
            "Would you like to change your private comment name?": "Would you like to change your private comment name?",
            "Are you sure you want to delete the private comment?": "Are you sure you want to delete the private comment?",
            "If you delete <0>\"{{name}}\"</0>, all messages will be deleted and cannot be restored after deletion.": "If you delete <0>\"{{name}}\"</0>, all messages will be deleted and cannot be restored after deletion.",
            "This is a message window where all the basics of the project can be seen.": "This is a message window where all the basics of the project can be seen.",
            "By entering @mention, you can send a comment to the designated member.": "By entering @mention, you can send a comment to the designated member.",
            "This is a message window that only added members can see.": "This is a message window that only added members can see.",
            "Please enter your user email.": "Please enter user email and press enter.",
            "Projects you want to allow access to": "Projects you want to allow access to",
            "Select the project you want to allow access to.": "Select the project you want to allow access to.",
            "Select the role you want to grant.": "Select the role you want to grant.",
            "Search by user email.": "Search by user email.",
            "Delete this role?": "Delete this role?",
            "Deletion of {{domain}} {{item}} has been completed.": "Deletion of {{domain}} {{item}} has been completed.",
            "Duplication of {{domain}} {{item}} has been completed.": "Duplication of {{domain}} {{item}} has been completed.",
            "Creation of {{domain}} {{item}} has been completed.": "Creation of {{domain}} {{item}} has been completed.",
            "There is no custom metadata yet.": "There is no custom metadata yet.",
            "To enter metadata, select one of the custom metadata options.": "To enter metadata, select one of the custom metadata options.",
            "Please enter a message. (Optional)": "Please enter a message. (Optional)",
            "Please enter user's name.": "Please enter user's name.",
            "Select assets.": "Select assets.",
            "If you change the applied custom metadata, all data entered will be lost.": "If you change the applied custom metadata, all data entered will be lost.",
            "After AI analyzes the content, the field values of the selected content schema are automatically filled in. Only one schema can be selected.": "After AI analyzes the content, the field values of the selected content schema are automatically filled in. Only one schema can be selected.",
            "Search by custom metadata name.": "Search by custom metadata name.",
            "There are no private comments.": "There are no private comments.",
            "Use the \"Create private comment\" button Make it.": "Use the \"Create private comment\" button Make it.",
            "Enter name or email": "Enter name or email",
            "Please enter a message for your request (Optional)": "Please enter a message for your request (Optional)",
            "Folder can only be deleted if there are no assets in the folder.": "Folder can only be deleted if there are no assets in the folder.",
            "Select collections in a specific folder?": "Select collections in a specific folder?",
            "This field is required.": "This field is required.",
            "Invalid invitation code or Your invitation link may have expired.": "Invalid invitation code or Your invitation link may have expired.",
            "Please contact your administrator to request a new invitation link.": "Please contact your administrator to request a new invitation link.",
            "Hello,<NewLine/>Welcome to LX Hausys Design Library.": "Hello,<NewLine/>Welcome to LX Hausys Design Library.",
            "Up to <strong>{{number}}</strong> attachments are allowed.": "Up to <strong>{{number}}</strong> attachments are allowed.",
            "Please select up to <strong>{{number}}</strong> files and try again.": "Please select up to <strong>{{number}}</strong> files and try again.",
            "You are currently planning to upload <strong>{{added}}</strong> files. If you would like to attach another file, please remove the file and try again.": "You are currently planning to upload <strong>{{added}}</strong> files. If you would like to attach another file, please remove the file and try again.",
            "You are currently planning to upload <strong>{{added}}</strong> files. Please select and attach up to <strong>{{remaining}}</strong> additional files.": "You are currently planning to upload <strong>{{added}}</strong> files. Please select and attach up to <strong>{{remaining}}</strong> additional files.",
            "The maximum capacity per attachment is up to <strong>{{maxSize}}</strong>.": "The maximum capacity per attachment is up to <strong>{{maxSize}}</strong>.",
            "The current file has exceeded its capacity. Please check the file to attach and try again.": "The current file has exceeded its capacity. Please check the file to attach and try again.",
            "Asset {{item}} duplication completed.": "Asset {{item}} duplication completed.",
            "\"Custom Metadata\" can be applied to an asset’s custom metadata and is available when its status is enabled.": "\"Custom Metadata\" can be applied to an asset’s custom metadata and is available when its status is enabled.",
            "Enter required fields for “{{name}}” <0>{{count}}</0>/{{total}}": "Enter required fields for “{{name}}” <0>{{count}}</0>/{{total}}",
            "and <0>{{count}}</0> more": "and <0>{{count}}</0> more",
            "There is no data for this widget.": "There is no data for this widget.",
            "There are no jobs yet.": "There are no jobs yet.",
            "This operation was not entirely successful.": "This operation was not entirely successful.",
            "Failed to load preview image. Please again.": "Failed to load preview image. Please again.",
            "Preview image Creating...": "Preview image Creating...",
            "Failed to load preview image. <NewLine/>please try again.": "Failed to load preview image. <NewLine/>please try again.",
            "Some assets are missing required metadata for electronic payment.<NewLine/> Please change the metadata type to Roll or Artwork and submit.": "Some assets are missing required metadata for electronic payment.<NewLine/> Please change the metadata type to Roll or Artwork and submit.",
            "Asset '{{name}}' has been requested.": "Asset '{{name}}' has been requested.",
            "Asset '{{name}}' and {{count}} other assets have been requested.": "Asset '{{name}}' and {{count}} other assets have been requested.",
            "Are you sure you want to turn off applying custom metadata?": "Are you sure you want to turn off applying custom metadata?",
            "Attribution cannot be empty. Please enter a valid attribution.": "Attribution cannot be empty. Please enter a valid attribution.",
            "If you turn off Custom Apply All Data, your input data is gone and cannot be recovered.": "If you turn off Custom Apply All Data, your input data is gone and cannot be recovered.",
            "Please search by role name": "Please search by role name",
            "Deleting the role “{{roleName}}” removes all permissions for users and groups set by that role.": "Deleting the role “{{roleName}}” removes all permissions for users and groups set by that role.",
            "The corresponding menu is selected in the project first entry screen settings above. If you do not want to display the menu, turn off the above settings.": "The corresponding menu is selected in the project first entry screen settings above. If you do not want to display the menu, turn off the above settings.",
            "Creating access token.": "Creating access token.",
            "Sucessfully created access token. Please check from the requested client.": "Sucessfully created access token. Please check from the requested client.",
            "Failed to create access token. Please try again from the requested client.": "Failed to create access token. Please try again from the requested client.",
            "Please select files to add": "Please select files to add",
            "“{{name}}’ is in use in projects.<0/> If you wish to delete it, please disable the schema in the project you are using.": "“{{name}}’ is in use in projects.<0/> If you wish to delete it, please disable the schema in the project you are using.",
            "Select {{resourceType}} through search to put them in your custom content.": "Select {{resourceType}} through search to put them in your custom content.",
            "The selected item is rejected": "The selected item is rejected",
            "The selected item is approved": "The selected item is approved",
            "The private comment is deleted.": "The private comment is deleted.",
            "There is no data": "There is no data",
            "The selected item has been requested to be archived.": "The selected item has been requested to be archived.",
            "Please search by name": "Please search by name",
            "Are you sure you want to delete that export file?": "Are you sure you want to delete that export file?",
            "If you delete a exported metadata, all settings and downloadable files will be deleted.": "If you delete a exported metadata, all settings and downloadable files will be deleted.",
            "Search for a project.": "Search for a project.",
            "Contains an overview of all selected assets.<NewLine/> The contents of hidden fields are revealed in the exported file.": "Contains an overview of all selected assets.<NewLine/> The contents of hidden fields are revealed in the exported file.",
            "There are no projects selected.": "Ther are no projects selected.",
            "Creation of new Metadata Export {{item}} is completed": "Creation of new Metadata Export {{item}} is completed",
            "No {{name}} items yet.": "No {{name}} items yet.",
            "The selected items have been requested to be archived.": "The selected items have been requested to be archived.",
            "You can choose a storage class to store your assets.": "You can choose a storage class to store your assets.",
            "Please search by content schema name": "Please search by content schema name",
            "Please search by DisplayAs or SoundsLike.": "Please search by DisplayAs or SoundsLike.",
            "A preview setting of '{{name}}' have been requested.": "A preview setting of '{{name}}' have been requested.",
            "This file size can be up to {{maxByte}} bytes.": "This file size can be up to {{maxByte}} bytes.",
            "Things to keep in mind when entering words": "Things to keep in mind when entering words",
            "Words similar to spoken sounds - Only Korean characters can be entered.": "Words similar to spoken sounds - Only Korean characters can be entered.",
            "If you want to create a URL, please change the status to Published.": "If you want to create a URL, please change the status to Published.",
            "The changed options is applied when it is ‘ACTIVE’, and if it is ‘INACTIVE’, the options is reset when the pop-up is closed.": "The changed options is applied when it is ‘ACTIVE’, and if it is ‘INACTIVE’, the options is reset when the pop-up is closed.",
            "Please search by audit log resourceId.": "Please search by audit log resource ID.",
            "Please search by vocabulary book name.": "Please search by vocabulary book name.",
            "You can enter English, numbers, spaces, and special characters (~!@#$%^&*()-_=+[{]}|;:’”,<.>/?).": "You can enter English, numbers, spaces, and special characters (~!@#$%^&*()-_=+[{]}|;:’”,<.>/?).",
            "Only English, -(Hyphen) can be entered.": "Only English, -(Hyphen) can be entered.",
            "You can enter Korean, English, numbers, spaces, and special characters (~!@#$%^&*()-_=+[{]}|;:’”,<.>/?).": "You can enter Korean, English, numbers, spaces, and special characters (~!@#$%^&*()-_=+[{]}|;:’”,<.>/?).",
            "Only Korean can be entered.": "Only Korean can be entered.",
            "An email will be sent to users with space admin permission.": "An email will be sent to users with space admin permission.",
            "No reports have been sent yet.": "No reports have been sent yet.",
            "{{action}} completed.": "{{action}} completed.",
            "When you enable automatic archiving, <0>you will be billed immediately for 90 or 180 days</0>, depending on the storage class option you select.": "When you enable automatic archiving, <0>you will be billed immediately for 90 or 180 days</0>, depending on the storage class option you select.",
            "This storage class is billed for <0>180 days</0> immediately after archiving.": "This storage class is billed for <0>180 days</0> immediately after archiving.",
            "Video images cannot be captured.": "Video images cannot be captured.",
            "To capture video images, the original source must contain an <0>mp4 or mov</0> file. <1/> Try capturing from a video or asset that has an mp4 or mov file.": "To capture video images, the original source must contain an <0>mp4 or mov</0> file. <1/> Try capturing from a video or asset that has an mp4 or mov file.",
            "Are you sure you want to delete the link??": "Are you sure you want to delete the link??",
            "Deleted links cannot be restored.": "Deleted links cannot be restored.",
            "This recipient will no longer be able to download from this link. Revoked access cannot be restored.": "This recipient will no longer be able to download from this link. Revoked access cannot be restored.",
            "Access has been revoked.": "Access has been revoked.",
            "Revoke this download link?": "Revoke this download link?",
            "'{{subject}}' shared with {{sharedWith}} will no longer be downloadable.": "'{{subject}}' shared with {{sharedWith}} will no longer be downloadable.",
            "A revoked link cannot be restored. Share again to send a new link.": "A revoked link cannot be restored. Share again to send a new link.",
            "Download link revoked.": "Download link revoked.",
            "Please add a link.": "Please add a link.",
            "This field must be in URL format.": "This field must be in URL format.",
            "Are you sure you want to delete this group?": "Are you sure you want to delete this group?",
            "Deleting the {{groupName}} group removes all permissions from users and roles set by that group.": "Deleting the {{groupName}} group removes all permissions from users and roles set by that group.",
            "If the problem persists, <0/> please contact the administrator.": "If the problem persists, <0/> please contact the administrator.",
            "Up to {{limit}} {{referenceType}} can be registered": "Up to {{limit}} {{referenceType}} can be registered",
            "Select Category Group": "Select Category Group",
            "Each menu (e.g. Assets) can be categorized into one category group.": "Each menu (e.g. Assets) can be categorized into one category group.",
            "Make sure the category group is in use <label>In use</label> status.": "Make sure the category group is in use <label>In use</label> status.",
            "If you apply a different category group, you can check the items in the <strong>'Uncategorized'</strong> in the category view.": "If you apply a different category group, you can check the items in the <strong>'Uncategorized'</strong> in the category view.",
            "No collection items yet.": "No collection items yet.",
            "There are no assets selected.": "There are no assets selected.",
            "Please select an item to enter the menu": "Please select an item to enter the menu",
            "Search by category name": "Search by category name",
            "There are no menus configured.": "There are no menus configured.",
            "Use the \"Add Menu\" button to add it.": "Use the \"Add Menu\" button to add it.",
            "'{{item}}' has been created.": "{{item}}' has been created.",
            "This menu is set as the first entry screen of the project and cannot be hidden.": "This menu is set as the first entry screen of the project and cannot be hidden.",
            "Please enter the menu name.": "Please enter the menu name.",
            "Menu name can be up to {{maxByte}} bytes.": "Menu name can be up to {{maxByte}} bytes.",
            "Please search by name.": "Please search by name.",
            "Deletion of vocabulary book {{item}} has been completed.": "Deletion of vocabulary book {{item}} has been completed.",
            "Deletion of vocabulary book {{item}} and {{count}} others has been completed.": "Deletion of vocabulary book {{item}} and {{count}} others has been completed.",
            "Content schema '{{name}}' has been created.": "Content schema '{{name}}' has been created.",
            "Content schema '{{name}}' has been updated.": "Content schema '{{name}}' has been updated.",
            "Enter last name": "Enter last name",
            "Enter first name": "Enter first name",
            "It's not possible to proceed as the archived menu isn't being used.": "It's not possible to proceed as the archived menu isn't being used.",
            "Asset lock has been disabled.": "Asset lock has been disabled.",
            "Asset lock has been enabled.": "Asset lock has been enabled.",
            "Lock this asset": "Lock this asset",
            "Select a category from the category group.": "Select a category from the category group.",
            "Sharing Period and Number of Downloads have expired. You can reset it.": "Sharing Period and Number of Downloads have expired. You can reset it.",
            "Number of Downloads has expired. You can reset it.": "Number of Downloads has expired. You can reset it.",
            "Sharing Period has expired. You can reset it.": "Sharing Period has expired. You can reset it.",
            "There are no shared users.": "There are no shared users.",
            "Processing download request...": "Processing download request...",
            "If you delete “{{name}}”, this property will be removed from all assets using this content schema, and it cannot be recovered.": "If you delete “{{name}}”, this property will be removed from all assets using this content schema, and it cannot be recovered.",
            "Drag and drop your file here, or upload a file from your PC or cloud.": "Drag and drop your file here, or upload a file from your PC or cloud.",
            "Go to the start page and select a project you have access to.": "Go to the start page and select a project you have access to.",
            "If you don’t have access to any projects, please contact your administrator.": "If you don’t have access to any projects, please contact your administrator.",
            "Please use the button below to go to the start page.": "Please use the button below to go to the start page.",
            "There is no page available for this comment.": "There is no page available for this comment.",
            "You do not have permission to access the page.": "You do not have permission to access the page.",
            "The custom metadata used in the asset is disabled.": "The custom metadata used in the asset is disabled.",
            "Selecting Use will make your project assets visible in the full asset search results. This may take some time to apply, depending on the amount of data.": "Selecting Use will make your project assets visible in the full asset search results. This may take some time to apply, depending on the amount of data.",
            "Data accessed through expedited retrieval for all objects except the largest archive objects (250MB or larger) is typically available within 1-5 minutes.": "Data accessed through expedited retrieval for all objects except the largest archive objects (250MB or larger) is typically available within 1-5 minutes.",
            "When restoring, Deep Archive storage will be charged for a minimum of 180 days, and other storage classes will be charged for a minimum of 90 days.": "When restoring, Deep Archive storage will be charged for a minimum of 180 days, and other storage classes will be charged for a minimum of 90 days.",
            "You will be charged when restoring an asset.": "You will be charged when restoring an asset.",
            "AI analysis identifies people, actions, and risk factors in videos and can automatically generate subtitles and text.": "AI analysis identifies people, actions, and risk factors in videos and can automatically generate subtitles and text.",
            "Please save or cancel your changes before adding a new task.": "Please save or cancel your changes before adding a new task.",
            "Please set the Input Path.": "Please set the Input Path.",
            "Are you sure you want to delete the task?": "Are you sure you want to delete the task?",
            "Deleting a task will cause all entered information to disappear and cannot be recovered.": "Deleting a task will cause all entered information to disappear and cannot be recovered.",
            "Please enter your email address and press Enter.": "Please enter your email address and press Enter.",
            "Share request to {{userName}}": "Share request to {{userName}}",
            "Changed share options to {{permission}} permission": "Changed share options to {{permission}} permission",
            "Changed share options to {{permission}} permission until {{expireDate}}": "Changed share options to {{permission}} permission until {{expireDate}}",
            "Changed share options to {{permission}} permission until {{expireDate}} with max {{maxDownloads}} downloads": "Changed share options to {{permission}} permission until {{expireDate}} with max {{maxDownloads}} downloads",
            "Changed share options to {{permission}} permission with max {{maxDownloads}} downloads": "Changed share options to {{permission}} permission with max {{maxDownloads}} downloads",
            "Sharing with {{user}} was updated": "Sharing with {{user}} was updated",
            "Sharing with {{user}} was removed": "Sharing with {{user}} was removed",
            "Shared with {{user}}": "Shared with {{user}}",
            "Shared with {{grantees}} permission": "Shared with {{grantees}} permission",
            "Shared with {{grantees}} permission until {{expireDate}}": "Shared with {{grantees}} permission until {{expireDate}}",
            "Shared with {{grantees}} permission until {{expireDate}} with max {{maxDownloads}} downloads": "Shared with {{grantees}} permission until {{expireDate}} with max {{maxDownloads}} downloads",
            "Shared with {{grantees}} permission with max {{maxDownloads}} downloads": "Shared with {{grantees}} permission with max {{maxDownloads}} downloads",
            "Shared link to {{names}}": "Shared link to {{names}}",
            "It's not possible to proceed as the {{menuName}} menu isn't being used.": "It's not possible to proceed as the {{menuName}} menu isn't being used.",
            "No users have been registered yet.": "No users have been registered yet.",
            "Click the User invitation button at the top to add a user.": "Click the User invitation button at the top to add a user.",
            "Please search by name or email": "Please search by name or email",
            "Search by project name": "Search by project name",
            "Search by bucket name": "Search by bucket name",
            "\"{{name}}\" will be deleted forever and you won't be abled to restore it.": "\"{{name}}\" will be deleted forever and you won't be abled to restore it.",
            "\"{{name}}\" and {{count}} others will be deleted forever and you won't be abled to restore it.": "\"{{name}}\" and {{count}} others will be deleted forever and you won't be abled to restore it.",
            "The service is located in {{region}}.": "The service is located in {{region}}.",
            "Please select a region.": "Please select a region.",
            "Please copy the JSON below to create an IAM Permission.": "Please copy the JSON below to create an IAM Permission.",
            "Please apply the role trust relationship by replacing {REPLACE_WITH_YOUR_EXTERNAL_ACCOUNT_ID} in the JSON below with the account ID you want to use.": "Please apply the role trust relationship by replacing {REPLACE_WITH_YOUR_EXTERNAL_ACCOUNT_ID} in the JSON below with the account ID you want to use.",
            "Please copy the Role ARN and paste it into the external account input field for <0>AWS account connection</0>.": "Please copy the Role ARN and paste it into the external account input field for <0>AWS account connection</0>.",
            "Please enter the AWS Role ARN.": "Please enter the AWS Role ARN.",
            "Please search by user name.": "Please search by user name.",
            "Please search by group name.": "Please search by group name.",
            "Please select a new owner": "Please select a new owner",
            "Changing the owner may result in the existing owner losing permissions and some features being restricted.": "Changing the owner may result in the existing owner losing permissions and some features being restricted.",
            "Are you sure you want to delete this?": "Are you sure you want to delete this?",
            "Please click Add roles button to grant roles to this user.": "Please click Add roles button to grant roles to this user.",
            "No group is granted": "No group is granted",
            "There are no groups yet.": "There are no groups yet.",
            "Please click Manage Access button to add group to this project.": "Please click Manage Access button to add group to this project.",
            "There are no users yet.": "There are no users yet.",
            "Please click Manage Access button to add user to this project.": "Please click Manage Access button to add user to this project.",
            "You can create up to {{n}} tags.": "You can create up to {{n}} tags.",
            "Update owner to {{name}}": "Update owner to {{name}}",
            "URL not found": "URL not found",
            "The URL has been deleted or the menu does not exist.": "The URL has been deleted or the menu does not exist.",
            "You must enter your credentials to use the engine.": "You must enter your credentials to use the engine.",
            "When uploading via pop-up, empty folders are excluded.<NewLine/> To upload empty folders as well, please drag the folders directly into the asset list.": "When uploading via pop-up, empty folders are excluded.<NewLine/> To upload empty folders as well, please drag the folders directly into the asset list.",
            "If the capacity is more than {{limit}}, the print file will be automatically extracted and automatic captions will be generated.": "If the capacity is more than {{limit}}, the print file will be automatically extracted and automatic captions will be generated.",
            "It is only available at the all project level.": "It is only available at the all project level.",
            "There is no data available.": "There is no data available.",
            "The maximum upload size is {{size}}.": "The maximum upload size is {{size}}.",
            "Please select a repository.": "Please select a repository.",
            "Remove user from role?": "Remove user from role?",
            "If you remove the user {{userName}}, assigned permission will be removed.": "If you remove the user {{userName}}, assigned permission will be removed.",
            "Remove group from role?": "Remove group from role?",
            "If you remove the group {{groupName}}, assigned permission will be removed.": "If you remove the group {{groupName}}, assigned permission will be removed.",
            "There is no file.": "There is no file.",
            "mentioned you in a comment": "mentioned you in a comment",
            "replied to your comment": "replied to your comment",
            "invited you to a private comment": "invited you to a private comment",
            "There are no notifications yet.": "There are no notifications yet.",
            "Notifications will be deleted after 7 days.": "Notifications will be deleted after 7 days.",
            "The item does not exist": "The item does not exist",
            "Analysis completed, but there are no results for {{name}}.": "Analysis completed, but there are no results for {{name}}.",
            "An error occurred during analysis and the operation could not be completed.": "An error occurred during analysis and the operation could not be completed.",
            "Analyzing now uses the proxy video.": "Analyzing now uses the proxy video.",
            "The proxy video is still being created, so analyzing now uses the original and takes longer.": "The proxy video is still being created, so analyzing now uses the original and takes longer.",
            "The proxy video could not be created, so it is analyzed with the original.": "The proxy video could not be created, so it is analyzed with the original.",
            "There is no proxy video, so it is analyzed with the original.": "There is no proxy video, so it is analyzed with the original.",
            "Proxy videos are only created for assets registered after auto generation is turned on.": "Proxy videos are only created for assets registered after auto generation is turned on.",
            "There was a problem for a moment.": "There was a problem for a moment.",
            "There was a problem processing your request. Please try again later.": "There was a problem processing your request. Please try again later.",
            "AI usage quota has been exceeded.": "AI usage quota has been exceeded.",
            "You have reached the AI usage limit. Please contact your administrator to increase the quota.": "You have reached the AI usage limit. Please contact your administrator to increase the quota.",
            "No values were extracted.": "No values were extracted.",
            "The analysis finished, but no values matching the schema fields were returned. Retrying may produce the same result.": "The analysis finished, but no values matching the schema fields were returned. Retrying may produce the same result.",
            "I recommend the video highlights.": "I recommend the video highlights.",
            "Enter a prompt for AI": "Enter a prompt for AI",
            "What can I help with?": "What can I help with?",
            "Please enter the prompt.": "Please enter the prompt.",
            "Preset status has been updated.": "Preset status has been updated.",
            "Deletion of preset {{item}} has been completed.": "Deletion of preset {{item}} has been completed.",
            "Preset has been duplicated successfully.": "Preset has been duplicated successfully.",
            "Failed to send the prompt preset.": "Failed to send the prompt preset.",
            "'{{name}}' will be deleted forever and you won't be able to restore it.": "'{{name}}' will be deleted forever and you won't be able to restore it.",
            "No preset items yet.": "No preset items yet.",
            "No content schema items yet.": "No content schema items yet.",
            "Create it using the “Create” button.": "Create it using the “Create” button.",
            "To use the AI-Workspace, the original source must contain an <0>mp4 or mov</0> file.": "To use the AI-Workspace, the original source must contain an <0>mp4 or mov</0> file.",
            "Name is required.": "Name is required.",
            "Prompt is required.": "Prompt is required.",
            "The selected tags have been saved to the metadata.": "The selected tags have been saved to the metadata.",
            "Please select the required items from the recommended tags.": "Please select the required items from the recommended tags.",
            "Please select a template.": "Please select a template.",
            "Your session has expired. Please start a new conversation.": "Your session has expired. Please start a new conversation.",
            "Generating results": "Generating results",
            "There is no description yet. Bring an AI description or enter it directly.": "There is no description yet. Bring an AI description or enter it directly.",
            "Please write a description.": "Please write a description.",
            "To capture video images, it must be an <0>mp4 or mov</0> file. <1/> Try capturing from mp4 or mov assets.": "To capture video images, it must be an <0>mp4 or mov</0> file. <1/> Try capturing from mp4 or mov assets.",
            "The video cannot be edited.": "The video cannot be edited.",
            "To edit a video, it must be an <0>mp4 or mov</0> file. <1/> Edit in mp4 or mov assets.": "To edit a video, it must be an <0>mp4 or mov</0> file. <1/> Edit in mp4 or mov assets.",
            "To edit a video, the original source must contain an <0>mp4 or mov</0> file. <1/> Edit videos or assets that contain mp4 or mov files.": "To edit a video, the original source must contain an <0>mp4 or mov</0> file. <1/> Edit videos or assets that contain mp4 or mov files.",
            "You can play it directly on mobile with the QR code.": "You can play it directly on mobile with the QR code.",
            "Analyze videos with AI": "Analyze videos with AI",
            "to easily manage your videos.": "to easily manage your videos.",
            "Video AI analysis can extract labels for specific people, objects, patterns, and actions in videos, and manage inappropriate or dangerous content.": "Video AI analysis can extract labels for specific people, objects, patterns, and actions in videos, and manage inappropriate or dangerous content.",
            "Additionally, it can automatically convert video audio to text and automatically generate captions to easily manage videos.": "Additionally, it can automatically convert video audio to text and automatically generate captions to easily manage videos.",
            "{{resourceName}} '{{name}}' has been added.": "{{resourceName}} '{{name}}' has been added.",
            "{{resourceName}} '{{name}}' and {{count}} others have been added.": "{{resourceName}} '{{name}}' and {{count}} others have been added.",
            "This field can be up to {{maxLength}} characters.": "This field can be up to {{maxLength}} characters.",
            "The description can be up to {{maxLength}} characters long.": "The description can be up to {{maxLength}} characters long.",
            "The comment field can be up to {{maxLength}} characters long.": "The comment field can be up to {{maxLength}} characters long.",
            "Menu name can be up to {{maxLength}} bytes.": "Menu name can be up to {{maxLength}} bytes.",
            "The description can be up to {{maxLength}} characters": "The description can be up to {{maxLength}} characters",
            "Request to create download link successfully": "Request to create download link successfully",
            "Auto set by {{name}}": "Auto set by {{name}}",
            "request completed": "request completed",
            "Each menu (e.g. Asset) can categorize items by setting one category group.": "Each menu (e.g. Asset) can categorize items by setting one category group.",
            "Make sure the category group is currently <InUse>In Use</InUse> for the target menu (e.g. Asset).": "Make sure the category group is currently <InUse>In Use</InUse> for the target menu (e.g. Asset).",
            "If you apply a different category group, those items can be found under '<NotClassified>Categories Not Classified into Assets</NotClassified>' in the category view.": "If you apply a different category group, those items can be found under '<NotClassified>Categories Not Classified into Assets</NotClassified>' in the category view.",
            "Category groups allow you to classify and manage items conveniently.": "Category groups allow you to classify and manage items conveniently.",
            "Assets can be created successfully only when no values are empty. If not used, please delete.": "Assets can be created successfully only when no values are empty. If not used, please delete.",
            "The name field be up to {{title}} characters long.": "The name field be up to {{title}} characters long.",
            "The selected {{type}} has been saved to the metadata.": "The selected {{type}} has been saved to the metadata.",
            "ㆍSingle IP : xxx.xxx.xxx.xxx\n ㆍIP Range : xxx.xxx.xxx.xxx~zzz.zzz.zzz.zzz\n ㆍCIDR : xxx.xxx.xxx.xxx/yy\n ㆍSeparate by newlines": "ㆍSingle IP : xxx.xxx.xxx.xxx\n ㆍIP Range : xxx.xxx.xxx.xxx~zzz.zzz.zzz.zzz\n ㆍCIDR : xxx.xxx.xxx.xxx/yy\n ㆍSeparate by newlines",
            "Add it using the “Add Collection” button.": "Add it using the “Add Collection” button.",
            "ㆍCIDR : xxx.xxx.xxx.xxx/yy\n \n ㆍseparate by newlines": "ㆍCIDR : xxx.xxx.xxx.xxx/yy\n \n ㆍseparate by newlines",
            "This is not a valid URL pattern": "This is not a valid URL pattern",
            "If you delete <0>{{name}}</0>, You won’t be able to revert this.<1/>Are you sure you want to delete <0>{{name}}</0>?": "If you delete <0>{{name}}</0>, You won’t be able to revert this.<1/>Are you sure you want to delete <0>{{name}}</0>?",
            "If you archive the asset, you will be charged <0>the {{n}}-day</0> archive amount immediately.": "If you archive the asset, you will be charged <0>the {{n}}-day</0> archive amount immediately.",
            "up to <0> {{number}} </0> days.": "up to <0> {{number}} </0> days.",
            "Creation of event trigger has been completed.": "Creation of event trigger has been completed.",
            "Please search by folder name": "Please search by folder name",
            "Folder": "Folder",
            "invited you to a thread": "invited you to a thread",
            "You will be notified by email <0/> whether the asset has been shared.": "You will be notified by email <0/> whether the asset has been shared.",
            "The description has been updated.": "The description has been updated.",
            "Up to 50 {{referenceType}}s can be registered": "Up to 50 {{referenceType}}s can be registered",
            "The status has been changed.": "The status has been changed.",
            "Are you sure you want to delete this workflow?": "Are you sure you want to delete this workflow?",
            "If you delete this workflow, it cannot be recovered.": "If you delete this workflow, it cannot be recovered.",
            "An event that triggers the workflow to run.": "An event that triggers the workflow to run.",
            "Branches the workflow based on conditions.": "Branches the workflow based on conditions.",
            "Proceeds to the next step when the task is completed.": "Proceeds to the next step when the task is completed.",
            "When the created asset's media type is {{values}}": "When the created asset's media type is {{values}}",
            "When the file extension is {{values}}": "When the file extension is {{values}}",
            "Branch files based on file extension": "Branch files based on file extension",
            "Branch files based on file size": "Branch files based on file size",
            "Branch files based on media type": "Branch files based on media type",
            "Branch files based on asset size": "Branch files based on asset size",
            "When an object is created in the S3 bucket": "When an object is created in the S3 bucket",
            "When an asset is created in the current project": "When an asset is created in the current project",
            "Submit transcode task to pipeline": "Submit transcode task to pipeline",
            "Create an asset from a file (waits until preview extraction completes)": "Create an asset from a file (waits until preview extraction completes)",
            "Attach metadata to asset": "Attach metadata to asset",
            "System preset-based single type job": "System preset-based single type job",
            "Archive to the specified storage class": "Archive to the specified storage class",
            "Publish a video to SNS": "Publish a video to SNS",
            "This trigger has no additional conditions.": "This trigger has no additional conditions.",
            "Exactly one of {{keys}} is required": "Exactly one of {{keys}} is required",
            "One of {{keys}} is required": "One of {{keys}} is required",
            "{{keys}} cannot be used together": "{{keys}} cannot be used together",
            "Use AI workspace metadata.": "Use AI workspace metadata.",
            "Enter manually.": "Enter manually.",
            "Data updated at {{timestamp}} ({{offset}})": "Data updated at {{timestamp}} ({{offset}})",
            "Based on {{start}} ~ {{end}} ({{offset}})": "Based on {{start}} ~ {{end}} ({{offset}})",
            "{{month}} settlement confirmed": "{{month}} settlement confirmed",
            "{{percent}}% in use": "{{percent}}% in use",
            "Concurrent session limit {{max}}": "Max concurrent session limit {{max}}",
            "Monthly base fee {{fee}}": "Monthly base fee {{fee}}",
            "Monthly base fee none": "No monthly base fee",
            "Base fee : {{fee}}": "Monthly base fee : {{fee}}",
            "Base fee : none": "Monthly base fee : none",
            "Usage fee : {{minutes}} min × {{rate}}": "Usage fee : {{minutes}} min × {{rate}}",
            "Usage fee : {{minutes}} min": "Usage fee : {{minutes}} min",
            "{{days}} days": "{{days}} days",
            "Failed to load billing information.": "Failed to load billing information.",
            "There is no active subscription for this tenant.": "There is no active subscription for this tenant.",
            "ㆍSingle IP : xxx.xxx.xxx.xxx\nㆍIP Range : xxx.xxx.xxx.xxx~zzz.zzz.zzz.zzz\nㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍSeparate by newlines": "ㆍSingle IP : xxx.xxx.xxx.xxx\nㆍIP Range : xxx.xxx.xxx.xxx~zzz.zzz.zzz.zzz\nㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍSeparate by newlines",
            "ㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍseparate by newlines": "ㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍseparate by newlines",
            "Clicking apply replaces the matching field of the custom metadata below the video with the extracted value.": "Clicking apply replaces the matching field of the custom metadata below the video with the extracted value.",
            "This segment has no duration, so it cannot be added.": "This segment has no duration, so it cannot be added.",
            "Replaces the current metadata with the selected preset schema's metadata and saves it. Changes cannot be undone.": "Replaces the current metadata with the selected preset schema's metadata and saves it. Changes cannot be undone.",
            "The current metadata is replaced with the metadata from the selected preset schema. You can revert to the previous state until the metadata is saved.": "The current metadata is replaced with the metadata from the selected preset schema. You can revert to the previous state until the metadata is saved.",
            "Replaces the current metadata with the selected preset schema's metadata. You cannot save if required fields are empty. Enter the required values and then save.": "Replaces the current metadata with the selected preset schema's metadata. You cannot save if required fields are empty. Enter the required values and then save.",
            "Saving deletes the existing custom metadata and replaces it with the AI-extracted metadata. Changes cannot be undone. Do you want to continue?": "Saving deletes the existing custom metadata and replaces it with the AI-extracted metadata. Changes cannot be undone. Do you want to continue?",
            "Saving deletes the existing custom metadata and replaces it with the current settings. Changes cannot be undone. Do you want to continue?": "Saving deletes the existing custom metadata and replaces it with the current settings. Changes cannot be undone. Do you want to continue?",
            "Select the items to save as custom metadata from the extracted values. You can edit the values before saving.": "Select the items to save as custom metadata from the extracted values. You can edit the values before saving.",
            "The metadata has been saved.": "The metadata has been saved.",
            "This asset uses the <0>'{{current}}'</0> schema, which differs from the preset schema({{preset}}). Field-level replacement is not available; replacing the schema applies all extracted values and clears the existing input data.": "This asset uses the <0>'{{current}}'</0> schema, which differs from the preset schema({{preset}}). Field-level replacement is not available; replacing the schema applies all extracted values and clears the existing input data.",
            "Setting the preset schema({{preset}}) applies all extracted values.": "Setting the preset schema({{preset}}) applies all extracted values.",
            "Set the preset schema to show it here.": "Set the preset schema to show it here.",
            "Do you want to unpublish the public URL?": "Do you want to unpublish the public URL?",
            "Due to CDN cache, it may take up to a few minutes to actually block access.": "Due to CDN cache, it may take up to a few minutes to actually block access.",
            "Each URL stays the same even if you update the file.": "Each URL stays the same even if you update the file.",
            "Failed to copy the URL.": "Failed to copy the URL.",
            "Failed to open the URL.": "Failed to open the URL.",
            "Failed to publish. Please try again later.": "Failed to publish. Please try again later.",
            "Failed to publish. Unpublish and try publishing again.": "Failed to publish. Unpublish and try publishing again.",
            "Failed to unpublish. Please try again later.": "Failed to unpublish. Please try again later.",
            "Publishing the public URL has been requested.": "Publishing the public URL has been requested.",
            "Publishing {{count}} captions has been requested.": "Publishing {{count}} captions has been requested.",
            "Publishing {{count}} images has been requested.": "Publishing {{count}} images has been requested.",
            "The public URL has been copied.": "The public URL has been copied.",
            "The public URL has been unpublished.": "The public URL has been unpublished.",
            "The public URL of <0>{{target}}</0> will no longer be accessible.": "The public URL of <0>{{target}}</0> will no longer be accessible.",
            "There is no published asset.": "There is no published asset.",
            "This asset is published via CDN. The issued URL stays the same even if you update the file.": "This asset is published via CDN. The issued URL stays the same even if you update the file.",
            "To share privately with specific users, use <0>Actions → Share link</0>.": "To share privately with specific users, use <0>Actions → Share link</0>.",
            "Failed to load the public URL list.": "Failed to load the public URL list.",
            "You do not have permission to publish this asset.": "You do not have permission to publish this asset.",
            "{{count}} captions have been unpublished.": "{{count}} captions have been unpublished.",
            "{{count}} images have been unpublished.": "{{count}} images have been unpublished.",
            "Invalid pattern.": "Invalid pattern.",
            "This field should be a number.": "This field should be a number.",
            "This field can be from {{min}} characters.": "This field can be from {{min}} characters.",
            "This field can be up to {{max}}.": "This field can be up to {{max}}.",
            "This field can be at least {{min}}.": "This field can be at least {{min}}.",
            "Duplicate value.": "Duplicate value.",
            "Already exists. Try something else.": "Already exists. Try something else.",
            "If you detach <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to detach <0>{{name}}</0>?": "If you detach <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to detach <0>{{name}}</0>?",
            "The asset has <0>{{count}}</0> elements attached.<1/>If the asset is detached, the elements are also detached.": "The asset has <0>{{count}}</0> elements attached.<1/>If the asset is detached, the elements are also detached.",
            "Remove connected MediaLive input.": "Remove connected MediaLive input.",
            "<0>{{name}}</0> is in use.<1/> If you delete this template, you won’t be able to revert this.<1/> Are you sure you want to delete?": "<0>{{name}}</0> is in use.<1/> If you delete this template, you won’t be able to revert this.<1/> Are you sure you want to delete?",
            "Empty values must be filled in when actually used.": "Empty values must be filled in when actually used.",
            "If you delete <0>{{count}}</0> other than <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to delete <0>{{count}}</0> other than <0>{{name}}</0>?": "If you delete <0>{{count}}</0> other than <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to delete <0>{{count}}</0> other than <0>{{name}}</0>?",
            "If you remove all shares on <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to remove all shares on <0>{{name}}</0>?": "If you remove all shares on <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to remove all shares on <0>{{name}}</0>?",
            "If you remove all shares on <0>{{count}}</0> other than <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to remove all shares on <0>{{count}}</0> other than <0>{{name}}</0>?": "If you remove all shares on <0>{{count}}</0> other than <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to remove all shares on <0>{{count}}</0> other than <0>{{name}}</0>?",
            "If you remove <0>{{name}}</0>, the item is deleted from the view.<1/>Other users will still have access.<1/>Are you sure you want to remove the item?": "If you remove <0>{{name}}</0>, the item is deleted from the view.<1/>Other users will still have access.<1/>Are you sure you want to remove the item?",
            "If you remove <0>{{count}}</0> other than <0>{{name}}</0>, the item is deleted from the view.<1/>Other users will still have access.<1/>Are you sure you want to remove the item?": "If you remove <0>{{count}}</0> other than <0>{{name}}</0>, the item is deleted from the view.<1/>Other users will still have access.<1/>Are you sure you want to remove the item?",
            "Share request completed": "Share request completed",
            "The selected item is restored": "The selected item is restored",
            "Error occurs!": "Error occurs!",
            "Create Completed.": "Create Completed.",
            "Overlap other processing": "Overlap other processing",
            "Users and teams added.": "Users and teams added.",
            "Please enter the subject.": "Please enter the subject.",
            "Lineups still exist on date": "Lineups still exist on date",
            "Approval completed.": "Approval completed.",
            "Rejection completed.": "Rejection completed.",
            "The Shared with list is Changed": "The Shared with list is Changed",
            "The selected item is Approved": "The selected item is Approved",
            "The selected item is Rejected": "The selected item is Rejected",
            "The selected item is Deleted": "The selected item is Deleted",
            "This page isn't working. {{line}} Please contact the manager.": "This page isn't working. {{line}} Please contact the manager.",
            "Select {{resourceType}} through search to put them in your content.": "Select {{resourceType}} through search to put them in your content.",
            "Words to display - You can enter English, numbers, spaces, and special characters (~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?).": "Words to display - You can enter English, numbers, spaces, and special characters (~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?).",
            "Words similar to spoken sounds - Only English, -(Hyphen) can be entered.": "Words similar to spoken sounds - Only English, -(Hyphen) can be entered.",
            "Words to display - You can enter Korean, English, numbers, spaces, and special characters (~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?).": "Words to display - You can enter Korean, English, numbers, spaces, and special characters (~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?).",
            "Deletion of vocabulary phrase {{item}} has been completed.": "Deletion of vocabulary phrase {{item}} has been completed.",
            "Deletion of vocabulary phrase {{item}} and {{count}} others has been completed.": "Deletion of vocabulary phrase {{item}} and {{count}} others has been completed.",
            "Failed to load analysis results.": "Failed to load analysis results.",
            "There are no video segments to edit for the selected labels.": "There are no video segments to edit for the selected labels.",
            "Imported {{segmentCount}} segments of {{labels}} selected in {{engine}} as edit segments.": "Imported <0>{{segmentCount}}</0> segments of <1>{{labels}}</1> selected in <2>{{engine}}</2> as edit segments.",
            "You can select up to {{max}} labels.": "You can select up to {{max}} labels.",
            "All {{max}} timestamps selected. Deselect one to add another.": "All {{max}} timestamps selected. Deselect one to add another.",
            "AI analysis uses the proxy video.": "AI analysis uses the proxy video.",
            "Creating a proxy video. Analyzing now uses the original and takes longer.": "Creating a proxy video. Analyzing now uses the original and takes longer.",
            "The proxy video could not be created. AI analysis will use the original.": "The proxy video could not be created. AI analysis will use the original.",
            "The proxy video is used by AI Analysis, AI Workspace, and the Adobe plugin.": "The proxy video is used by AI Analysis, AI Workspace, and the Adobe plugin.",
            "Without it, AI Analysis runs on the original and can be slow or fail on size limits, and the Adobe plugin downloads the original file. This choice applies to assets created from now on.": "Without it, AI Analysis runs on the original and can be slow or fail on size limits, and the Adobe plugin downloads the original file. This choice applies to assets created from now on.",
            "No proxy video. Proxy auto-generation applies only to videos registered after it was selected.": "No proxy video. Proxy auto-generation applies only to videos registered after it was selected.",
            "Proxy video - a small copy used for AI analysis and preview.": "Proxy video - a small copy used for AI analysis and preview.",
            "The start date must be on or before the end date.": "The start date must be on or before the end date.",
            "Finish or cancel the field being edited before saving.": "Finish or cancel the field being edited before saving.",
            "This value is not one of the allowed options.": "This value is not one of the allowed options.",
            "Assets closer to the top <0>match your search more accurately</0>.": "Assets closer to the top <0>match your search more accurately</0>.",
            "Requests that failed. The file may have been deleted or the URL may have been unpublished.": "Requests that failed. The file may have been deleted or the URL may have been unpublished."
        },
        "code": {
            "WORKFLOW_EMPTY_TREE_INCOMPLETE": "The workflow is empty.",
            "WORKFLOW_MISSING_TRIGGER_INCOMPLETE": "A TRIGGER step is required.",
            "WORKFLOW_MISSING_END_INCOMPLETE": "An END step is required.",
            "WORKFLOW_MISSING_TASK_INCOMPLETE": "At least one task step is required.",
            "WORKFLOW_START_NO_NEXT_INCOMPLETE": "The START step must be connected to a next step.",
            "WORKFLOW_UNTERMINATED_PATH_INCOMPLETE": "Every path must end at an END step.",
            "WORKFLOW_CHOICE_NO_NEXT_INCOMPLETE": "The condition (CHOICE) step must have a next step.",
            "WORKFLOW_BRANCH_COUNT_INCOMPLETE": "A parallel block requires 2 to 5 branches. Add more branches.",
            "WORKFLOW_BRANCH_COUNT_FATAL": "A parallel block allows only 2 to 5 branches.",
            "WORKFLOW_SHAPE_UNKNOWN_KEY_FATAL": "The step contains unknown properties.",
            "WORKFLOW_SHAPE_NAME_FATAL": "The step name is invalid.",
            "WORKFLOW_SHAPE_SCHEMA_FATAL": "The step schema information is invalid.",
            "WORKFLOW_SHAPE_CONDITION_FATAL": "The step condition format is invalid.",
            "WORKFLOW_SHAPE_NEXT_FATAL": "The step's next connection structure is invalid.",
            "WORKFLOW_SHAPE_STEP_FATAL": "A connected step has an invalid structure.",
            "WORKFLOW_NODE_CAP_FATAL": "The workflow exceeds the maximum number of steps allowed.",
            "WORKFLOW_BRANCH_NODE_CAP_FATAL": "A parallel branch exceeds the maximum number of steps allowed.",
            "WORKFLOW_ROOT_NOT_START_FATAL": "The workflow must start with a START step.",
            "WORKFLOW_DUPLICATE_START_FATAL": "There can be only one START step.",
            "WORKFLOW_DUPLICATE_TRIGGER_FATAL": "There can be only one TRIGGER step.",
            "WORKFLOW_DUPLICATE_END_FATAL": "There can be only one END step.",
            "WORKFLOW_TRIGGER_NOT_AFTER_START_FATAL": "A TRIGGER step must come right after the START step.",
            "WORKFLOW_DUPLICATE_NAME_FATAL": "Step names must be unique.",
            "WORKFLOW_MULTIPLE_PARALLEL_FATAL": "Only one parallel block is allowed.",
            "WORKFLOW_NAME_CHARSET_FATAL": "The step name contains invalid characters.",
            "WORKFLOW_NAME_RESERVED_PREFIX_FATAL": "The step name cannot start with a reserved prefix (\"__\").",
            "WORKFLOW_UNKNOWN_SCHEMA_FATAL": "The step's schema does not exist in the catalog.",
            "WORKFLOW_CONDITION_SPEC_DEFERRED": "The step's condition does not meet the required specification.",
            "WORKFLOW_END_HAS_NEXT_FATAL": "The END step cannot have a next step.",
            "WORKFLOW_START_BRANCHES_FATAL": "The START step cannot connect directly to a parallel block.",
            "WORKFLOW_NEXT_IS_START_FATAL": "A step cannot transition to the START step.",
            "WORKFLOW_NESTED_PARALLEL_FATAL": "Nested parallel blocks are not allowed.",
            "WORKFLOW_NOT_PARALLELIZABLE_FATAL": "This step cannot be used as a parallel branch.",
            "WORKFLOW_FORBIDDEN_IN_BRANCH_FATAL": "START, TRIGGER, and END steps cannot be used inside a parallel branch.",
            "WORKFLOW_INPUT_NOT_SATISFIED_DEFERRED": "The step's input conditions are not satisfied by the available outputs of previous steps.",
            "WORKFLOW_DSL_NOT_BINDABLE_FATAL": "This field does not allow a DSL binding.",
            "WORKFLOW_DSL_MALFORMED_DEFERRED": "The DSL binding format is invalid.",
            "WORKFLOW_DSL_TARGET_NOT_FOUND_DEFERRED": "The DSL binding refers to a step or output that does not exist.",
            "WORKFLOW_DSL_OUT_OF_SCOPE_DEFERRED": "The DSL binding references a step that is out of scope.",
            "OPERATION_ERROR": "The storage operation failed.",
            "OPERATION_COMPLETED": "The storage operation was successful.",
            "OPERATION_PARTIAL_COMPLETED": "The requested operation was partially successful.",
            "SUCCESS": "The operation was successful.",
            "S3_OPERATION_FAIL": "Operation failed on storage.",
            "NOT_EXIST_OBJECT_FROM_S3": "The file does not exist in storage.",
            "NOT_EXIST_OBJECT_FROM_SOURCE_DB": "The record does not exist in the index DB.",
            "OVERLAP_OTHER_PROCESSING": "The operation is failed due to the overlapped process.",
            "FAIL_TO_CHANGE_STATUS": "An error occurred while changing the file state.",
            "USER_DECISION_REQUIRED": "Duplicate files occur, user required to choose to overwrite or skip.",
            "UNKNOWN_ERROR": "An unknown error has occurred.",
            "DOWNLOAD_JOB_REJECTED_BY_SIZE": "The download job was rejected due to a file size.",
            "DOWNLOAD_JOB_REJECTED_BY_COUNT": "The download job was rejected due to a file count.",
            "DOWNLOAD_JOB_REJECTED_BY_FOLDER": "The download job was rejected due to a request contained a folder.",
            "RESOURCE_NOT_FOUND": "The source file has been deleted.",
            "OPERATION_FAILED": "The storage operation failed.",
            "OPERATION_ABORTED": "The storage operation aborted.",
            "INTERNAL_ERROR": "An internal error has occurred.",
            "CPA_INFO_PANEL_ASSETS_DESC_1": "Assets are any content files that can be stored digitally, and contain metadata about the files.",
            "CPA_INFO_PANEL_ASSETS_DESC_2": "On the asset page, you can check the list of registered assets, upload a file to make it an asset through \"Add Asset\", or edit/manage/download the information of an existing asset.",
            "CPA_INFO_PANEL_ASSETS_ACTIONS_DESC": "<H4>Actions</H4>\nBy creating and managing files as assets, you can perform the following actions.\n<List>\n<ListItem>Add images, documents, audio files, and video files of various file types</ListItem>\n<ListItem>Add or edit metadata information for files</ListItem>\n<ListItem>Group and manage assets through tags or folders</ListItem>\n<ListItem>Search by asset name, ID, extension, file type, owner, created date, and tags</ListItem>\n</List>",
            "CPA_INFO_PANEL_ASSETS_GRID_DESC": "<H4>Grid/List Layout</H4>\nThe list of assets can be checked in a grid or list layout, and when set to a list layout, the user can specify whether or not to expose the table column.\n(Name, Type, Size, Access, Owner, Created, Last Updated)",
            "CPA_INFO_PANEL_ASSETS_ADD_DESC": "<H4>Add Asset</H4>\nYou can make files into assets by clicking the \"Add Assets\" button, or by drag & drop files into the list.",
            "CPA_INFO_PANEL_ASSET_DETAIL_DESC": "Asset Details allows you to check the detailed information of an asset.",
            "CPA_INFO_PANEL_ASSET_DETAIL_OVERVIEW_DESC": "<H4>Overview</H4>\nThe overview allows you to view the basic details of an asset, modify its access and folder location.",
            "CPA_INFO_PANEL_ASSET_DETAIL_METADATA_DESC": "<H4>Metadata</H4>\nMetadata can view and edit Attributions and Tag information.",
            "CPA_INFO_PANEL_ASSET_DETAIL_ACTION_DESC": "<H4>Action</H4>\nYou can 'Download/Archive/Delete' those assets.",
            "CPA_INFO_PANEL_ASSET_DETAIL_ARCHIVE_DESC": "<H4>Archive</H4>\nArchive options can be set by the project manager in project settings, and either S3 Glacier Flexible Retrieval / S3 Glacier Deep Archive can be selected and used.<NewLine/>\nArchived files are cheaper, but recovering them takes time.",
            "CPA_INFO_PANEL_ASSET_SEARCH_DESC": "You can check the search results in the asset list.<NewLine/>\nYou can search by asset name in the search bar or by opening the search options window and applying detailed search conditions.",
            "CPA_INFO_PANEL_ASSET_SEARCH_OPTIONS_DESC": "<H4>Search Options</H4>\nSearch options include Asset Name, ID, Extension, Type, Owner, Created, and Tag. You can perform a detailed search for an asset by applying the desired detailed option.",
            "CPA_INFO_PANEL_ASSET_SEARCH_GO_TO_DESC": "<H4>Go to List</H4>\nTo return to the asset list, simply click the 'Go to list (←)' button.",
            "CPA_INFO_PANEL_ADD_ASSETS_DESC": "Many different file types can be made into assets.",
            "CPA_INFO_PANEL_ADD_ASSETS_DETAILS_DESC": "<H4>Asset Details</H4>\nYou can browse the files directly or drag and drop to see the selected files, and rename the selected files to the asset name you want.<NewLine/>\nIn addition, you can register as an asset by selecting whether or not to grant access to the asset and creating metadata.",
            "CPA_INFO_PANEL_ADD_ASSETS_ACCESS_DESC": "<H4>Access</H4>\nAccess rights can be selected as PUBLIC/PRIVATE.<NewLine/>\nIf PUBLIC is selected, it is open to all, and if PRIVATE is selected, it is private to all.",
            "Project:Assets:Archive": "Assets Archive permission.",
            "Project:Assets:Edit": "Assets Edit permission.",
            "Project:Assets:Read": "Assets Read permission.",
            "Project:Categories:Edit": "Categories Edit permission.",
            "Project:Categories:Read": "Categories Read permission.",
            "Project:Channels:Edit": "Channels Edit permission.",
            "Project:Channels:Read": "Channels Read permission.",
            "Project:Comments:Edit": "Comments Edit permission.",
            "Project:Comments:Read": "Comments Read permission.",
            "Project:CustomContents:Edit": "Custom Contents Edit permission.",
            "Project:CustomContents:Read": "Custom Contents Read permission.",
            "Project:Dashboard:Edit": "Dashboard Edit permission.",
            "Project:Dashboard:Read": "Dashboard Read permission.",
            "Project:Download:Download": "Download permission.",
            "Project:Folders:Edit": "Folders Edit permission.",
            "Project:Folders:Read": "Folders Read permission.",
            "Project:IntegratedSearch:Read": "Integrated Search Read permission.",
            "Project:InteractiveVideos:Edit": "Interactive Videos Edit permission.",
            "Project:InteractiveVideos:Read": "Interactive Videos Read permission.",
            "Project:Music:Edit": "Music Edit permission.",
            "Project:Music:Read": "Music Read permission.",
            "Project:People:Edit": "People Edit permission.",
            "Project:People:Read": "People Read permission.",
            "Project:Photo:Edit": "Photo Edit permission.",
            "Project:Photo:Read": "Photo Read permission.",
            "Project:Shares:External": "External Shares permission.",
            "Project:Shares:Internal": "Internal Shares permission.",
            "Project:Statistics:Edit": "Statistics Edit permission.",
            "Project:Statistics:Read": "Statistics Read permission.",
            "Project:Storages:Edit": "Storages Edit permission.",
            "Project:Storages:Read": "Storages Read permission.",
            "Project:Users&Groups:Read": "Users & Groups Read permission.",
            "Project:Videos:Edit": "Videos Edit permission.",
            "Project:Videos:Publish": "Videos Publish permission.",
            "Project:Videos:Read": "Videos Read permission.",
            "Project:Shares:InternalRequest": "Internal Request permission."
        },
        "audit": {
            "Retrieve list of Actions": "Retrieve list of Actions",
            "Retrieve list of AI Face collections": "Retrieve list of AI Face collections",
            "Delete AI Face collection": "Delete AI Face collection",
            "Update AI Face collection": "Update AI Face collection",
            "Retrieve list of archived assets": "Retrieve list of archived assets",
            "Retrieve archived asset details": "Retrieve archived asset details",
            "Restore archived asset": "Restore archived asset",
            "Retrieve list of assets": "Retrieve list of assets",
            "Create asset": "Create asset",
            "Retrieve asset details": "Retrieve asset details",
            "Update asset": "Update asset",
            "Delete asset": "Delete asset",
            "Activate asset": "Activate asset",
            "Archive asset": "Archive asset",
            "Create file in asset": "Create file in asset",
            "Add files to asset": "Add files to asset",
            "Delete file from asset": "Delete file from asset",
            "Update file in asset": "Update file in asset",
            "Update tags of asset": "Update tags of asset",
            "Delete tag from asset": "Delete tag from asset",
            "Inactivate asset": "Inactivate asset",
            "Attach People to asset": "Attach People to asset",
            "Detach People from asset": "Detach People from asset",
            "Retrieve asset status": "Retrieve asset status",
            "Retrieve upload URL for asset": "Retrieve upload URL for asset",
            "Retrieve list of audit logs": "Retrieve list of audit logs",
            "Retrieve audit log details": "Retrieve audit log details",
            "Send HEAD request to storage file": "Send HEAD request to storage file",
            "Retrieve list of category groups": "Retrieve list of category groups",
            "Retrieve category group details": "Retrieve category group details",
            "Update category group": "Update category group",
            "Delete category group": "Delete category group",
            "Retrieve list of categories": "Retrieve list of categories",
            "Create category": "Create category",
            "Delete categories in bulk": "Delete categories in bulk",
            "Retrieve category details": "Retrieve category details",
            "Update category": "Update category",
            "Delete category": "Delete category",
            "Retrieve list of CDNs": "Retrieve list of CDNs",
            "Create CDN": "Create CDN",
            "Retrieve CDN details": "Retrieve CDN details",
            "Update CDN": "Update CDN",
            "Delete CDN": "Delete CDN",
            "Retrieve list of channels": "Retrieve list of channels",
            "Create channel": "Create channel",
            "Retrieve channel details": "Retrieve channel details",
            "Update channel": "Update channel",
            "Delete channel": "Delete channel",
            "Update channel case": "Update channel case",
            "Retrieve list of channel inputs": "Retrieve list of channel inputs",
            "Retrieve channel input details": "Retrieve channel input details",
            "Retrieve channel encoder details": "Retrieve channel encoder details",
            "Reclaim channel": "Reclaim channel",
            "Request channel approval": "Request channel approval",
            "Retrieve list of channel schedules": "Retrieve list of channel schedules",
            "Update channel schedules in bulk": "Update channel schedules in bulk",
            "Delete channel schedules in bulk": "Delete channel schedules in bulk",
            "Delete channel schedule": "Delete channel schedule",
            "Retrieve channel schedule details": "Retrieve channel schedule details",
            "Update channel schedule": "Update channel schedule",
            "Start channel": "Start channel",
            "Retrieve channel state": "Retrieve channel state",
            "Stop channel": "Stop channel",
            "Request DRM token for video": "Request DRM token for video",
            "Retrieve Presigned URL of Master file for container format video": "Retrieve Presigned URL of Master file for container format video",
            "Retrieve Presigned URL of Daughter file for container format video": "Retrieve Presigned URL of Daughter file for container format video",
            "Retrieve list of transcode jobs": "Retrieve list of transcode jobs",
            "Create transcode job": "Create transcode job",
            "Create and start transcode job": "Create and start transcode job",
            "Retrieve upload URL for transcode job": "Retrieve upload URL for transcode job",
            "Retrieve transcode job details": "Retrieve transcode job details",
            "Update transcode job": "Update transcode job",
            "Delete transcode job": "Delete transcode job",
            "Cancel transcode job": "Cancel transcode job",
            "Retrieve transcode job status": "Retrieve transcode job status",
            "Correct transcode job status": "Correct transcode job status",
            "Start transcode job": "Start transcode job",
            "Retrieve list of listings": "Retrieve list of listings",
            "Create listing": "Create listing",
            "Retrieve listing details": "Retrieve listing details",
            "Update listing": "Update listing",
            "Delete listing": "Delete listing",
            "Retrieve list of lineups": "Retrieve list of lineups",
            "Create lineup": "Create lineup",
            "Delete lineups in bulk": "Delete lineups in bulk",
            "Create lineups in bulk": "Create lineups in bulk",
            "Retrieve lineup details": "Retrieve lineup details",
            "Update lineup": "Update lineup",
            "Delete lineup": "Delete lineup",
            "Retrieve list of scheduled lineups after current time": "Retrieve list of scheduled lineups after current time",
            "Retrieve list of localization resources": "Retrieve list of localization resources",
            "Retrieve localization resource details": "Retrieve localization resource details",
            "Retrieve current user information": "Retrieve current user information",
            "Retrieve list of Actions allowed for current user in project": "Retrieve list of Actions allowed for current user in project",
            "Retrieve list of Actions allowed for current user in space": "Retrieve list of Actions allowed for current user in space",
            "Request PoPs user synchronization": "Request PoPs user synchronization",
            "Retrieve list of metadata fields": "Retrieve list of metadata fields",
            "Create metadata field": "Create metadata field",
            "Retrieve metadata field details": "Retrieve metadata field details",
            "Update metadata field": "Update metadata field",
            "Delete metadata field": "Delete metadata field",
            "Retrieve list of metadata schemas": "Retrieve list of metadata schemas",
            "Create metadata schema": "Create metadata schema",
            "Register metadata schema": "Register metadata schema",
            "Retrieve metadata schema details": "Retrieve metadata schema details",
            "Update metadata schema": "Update metadata schema",
            "Delete metadata schema": "Delete metadata schema",
            "Retrieve list of People": "Retrieve list of People",
            "Create People": "Create People",
            "Update People": "Update People",
            "Delete People": "Delete People",
            "Retrieve People details": "Retrieve People details",
            "Retrieve list of transcode pipelines": "Retrieve list of transcode pipelines",
            "Retrieve transcode pipeline details": "Retrieve transcode pipeline details",
            "Retrieve embed URL": "Retrieve embed URL",
            "Retrieve shared URL": "Retrieve shared URL",
            "Retrieve list of SNS accounts": "Retrieve list of SNS accounts",
            "Create SNS account": "Create SNS account",
            "Retrieve SNS account details": "Retrieve SNS account details",
            "Delete SNS account": "Delete SNS account",
            "Update SNS account": "Update SNS account",
            "Retrieve SNS posting history": "Retrieve SNS posting history",
            "Retrieve list of videos posted to SNS": "Retrieve list of videos posted to SNS",
            "Post video to SNS": "Post video to SNS",
            "Retrieve SNS video details": "Retrieve SNS video details",
            "Retrieve transcode profile details": "Retrieve transcode profile details",
            "Retrieve list of programmes": "Retrieve list of programmes",
            "Create programme": "Create programme",
            "Retrieve programme details": "Retrieve programme details",
            "Update programme": "Update programme",
            "Delete programme": "Delete programme",
            "Retrieve list of projects": "Retrieve list of projects",
            "Create project": "Create project",
            "Delete project": "Delete project",
            "Retrieve project details": "Retrieve project details",
            "Update project": "Update project",
            "Retrieve list of assignable members to project": "Retrieve list of assignable members to project",
            "Retrieve list of assignable teams to project": "Retrieve list of assignable teams to project",
            "Retrieve list of assigned project members": "Retrieve list of assigned project members",
            "Retrieve list of assigned project teams": "Retrieve list of assigned project teams",
            "Retrieve list of project members": "Retrieve list of project members",
            "Assign member to project": "Assign member to project",
            "Unassign member from project": "Unassign member from project",
            "Add storages to project": "Add storages to project",
            "Update project storages": "Update project storages",
            "Retrieve list of project teams": "Retrieve list of project teams",
            "Assign team to project": "Assign team to project",
            "Unassign team from project": "Unassign team from project",
            "Create player": "Create player",
            "Retrieve list of players": "Retrieve list of players",
            "Create player profile": "Create player profile",
            "Retrieve list of player profiles": "Retrieve list of player profiles",
            "Retrieve player profile details": "Retrieve player profile details",
            "Update player profile": "Update player profile",
            "Delete player profile": "Delete player profile",
            "Retrieve player details": "Retrieve player details",
            "Update player": "Update player",
            "Delete player": "Delete player",
            "Create player resource": "Create player resource",
            "Retrieve list of player resources": "Retrieve list of player resources",
            "Retrieve player resource details": "Retrieve player resource details",
            "Update player resource": "Update player resource",
            "Delete player resource": "Delete player resource",
            "Retrieve upload URL for resource": "Retrieve upload URL for resource",
            "Create role": "Create role",
            "Retrieve list of roles": "Retrieve list of roles",
            "Retrieve role details": "Retrieve role details",
            "Update role": "Update role",
            "Delete role": "Delete role",
            "Attach permissions to role": "Attach permissions to role",
            "Retrieve list of permissions in role": "Retrieve list of permissions in role",
            "Detach permission from role": "Detach permission from role",
            "Retrieve list of settings": "Retrieve list of settings",
            "Create project settings": "Create project settings",
            "Delete project settings": "Delete project settings",
            "Create space settings": "Create space settings",
            "Delete space settings": "Delete space settings",
            "Create statistics": "Create statistics",
            "Retrieve list of statistics widget groups": "Retrieve list of statistics widget groups",
            "Create statistics widget group": "Create statistics widget group",
            "Delete statistics widget group": "Delete statistics widget group",
            "Retrieve list of widgets in specific statistics widget group": "Retrieve list of widgets in specific statistics widget group",
            "Update statistics widgets": "Update statistics widgets",
            "Retrieve list of statistics widgets": "Retrieve list of statistics widgets",
            "Create statistics Aggregation": "Create statistics Aggregation",
            "Create statistics Feature": "Create statistics Feature",
            "Create statistics Resource": "Create statistics Resource",
            "Retrieve list of stream inputs": "Retrieve list of stream inputs",
            "Create stream input": "Create stream input",
            "Retrieve list of whitelists": "Retrieve list of whitelists",
            "Retrieve stream input details": "Retrieve stream input details",
            "Update stream input": "Update stream input",
            "Delete stream input": "Delete stream input",
            "Retrieve list of teams": "Retrieve list of teams",
            "Retrieve team details": "Retrieve team details",
            "Retrieve list of team members": "Retrieve list of team members",
            "Retrieve list of event triggers": "Retrieve list of event triggers",
            "Create event trigger": "Create event trigger",
            "Retrieve event trigger details": "Retrieve event trigger details",
            "Delete event trigger": "Delete event trigger",
            "Update event trigger": "Update event trigger",
            "Retrieve upload URL for event trigger": "Retrieve upload URL for event trigger",
            "Retrieve list of users": "Retrieve list of users",
            "Retrieve user details": "Retrieve user details",
            "Update user": "Update user",
            "Delete user": "Delete user",
            "Retrieve list of videos": "Retrieve list of videos",
            "Create video": "Create video",
            "Retrieve video details": "Retrieve video details",
            "Update video": "Update video",
            "Delete video": "Delete video",
            "Activate video": "Activate video",
            "Request caption creation via video": "Request caption creation via video",
            "Delete caption from video": "Delete caption from video",
            "Update caption in video": "Update caption in video",
            "Inactivate video": "Inactivate video",
            "Attach People to video": "Attach People to video",
            "Detach People from video": "Detach People from video",
            "Create posters for video in bulk": "Create posters for video in bulk",
            "Delete poster from video": "Delete poster from video",
            "Create SNS posting for video": "Create SNS posting for video",
            "Retrieve video status": "Retrieve video status",
            "Retrieve Thumbnail profiles for video": "Retrieve Thumbnail profiles for video",
            "Create category group": "Create category group",
            "Retrieve list of Resource Buckets": "Retrieve list of Resource Buckets",
            "Create Resource Buckets in bulk": "Create Resource Buckets in bulk",
            "Retrieve list of files in asset": "Retrieve list of files in asset",
            "Retrieve list of Searchable Buckets": "Retrieve list of Searchable Buckets",
            "Create Searchable Bucket": "Create Searchable Bucket",
            "Delete Searchable Bucket": "Delete Searchable Bucket",
            "Retrieve Searchable Bucket details": "Retrieve Searchable Bucket details",
            "Update Searchable Bucket": "Update Searchable Bucket",
            "Register Searchable Bucket": "Register Searchable Bucket",
            "Delete schedule": "Delete schedule",
            "Retrieve list of asset types": "Retrieve list of asset types",
            "Create asset type": "Create asset type",
            "Retrieve list of asset extensions": "Retrieve list of asset extensions",
            "Create asset extension": "Create asset extension",
            "Retrieve schedule details": "Retrieve schedule details",
            "Retrieve list of schedules": "Retrieve list of schedules",
            "Delete schedules in bulk": "Delete schedules in bulk",
            "Update schedule": "Update schedule",
            "Create schedules in bulk": "Create schedules in bulk",
            "Start schedule": "Start schedule",
            "Stop schedule": "Stop schedule",
            "Lock schedule": "Lock schedule",
            "End schedule": "End schedule",
            "Request asset download": "Request asset download",
            "Retrieve asset download details": "Retrieve asset download details",
            "Retrieve schedule history details": "Retrieve schedule history details",
            "Retrieve list of schedule histories": "Retrieve list of schedule histories",
            "Retrieve hidden metadata field value": "Retrieve hidden metadata field value",
            "Retrieve list of shared configurations for video": "Retrieve list of shared configurations for video",
            "Create shared configuration for video": "Create shared configuration for video",
            "Retrieve shared configuration details for video": "Retrieve shared configuration details for video",
            "Update shared configuration for video": "Update shared configuration for video",
            "Delete shared configuration from video": "Delete shared configuration from video",
            "Retrieve list of content schemas": "Retrieve list of content schemas",
            "Attach teaser images to video in bulk": "Attach teaser images to video in bulk",
            "Detach teaser image from video": "Detach teaser image from video",
            "Attach teaser videos to video in bulk": "Attach teaser videos to video in bulk",
            "Detach teaser video from video": "Detach teaser video from video",
            "Retrieve list of music": "Retrieve list of music",
            "Retrieve music details": "Retrieve music details",
            "Update music": "Update music",
            "Delete music": "Delete music",
            "Create music": "Create music",
            "Add file to music": "Add file to music",
            "Update file in music": "Update file in music",
            "Delete file from music": "Delete file from music",
            "Retrieve list of photos": "Retrieve list of photos",
            "Retrieve photo details": "Retrieve photo details",
            "Update photo": "Update photo",
            "Delete photo": "Delete photo",
            "Create photo": "Create photo",
            "Add file to photo": "Add file to photo",
            "Update file in photo": "Update file in photo",
            "Delete file from photo": "Delete file from photo",
            "Retrieve asset file download link": "Retrieve asset file download link",
            "Retrieve download information": "Retrieve download information",
            "Search": "Search",
            "Retrieve list of attributions": "Retrieve list of attributions",
            "Create attribution": "Create attribution",
            "Retrieve attribution details": "Retrieve attribution details",
            "Update attribution": "Update attribution",
            "Delete attribution": "Delete attribution",
            "Retrieve list of asset files": "Retrieve list of asset files",
            "Retrieve list of file versions in asset": "Retrieve list of file versions in asset",
            "Attach categories to asset in bulk": "Attach categories to asset in bulk",
            "Detach categories from asset in bulk": "Detach categories from asset in bulk",
            "Retrieve list of attribution keys": "Retrieve list of attribution keys",
            "Update owner of asset": "Update owner of asset",
            "Retrieve dashboard data": "Retrieve dashboard data",
            "Retrieve list of Actions for role": "Retrieve list of Actions for role",
            "Retrieve list of file meta keys": "Retrieve list of file meta keys",
            "Update project member": "Update project member",
            "Update project team": "Update project team",
            "Retrieve list of related contents in asset": "Retrieve list of related contents in asset",
            "Retrieve list of asynchronous Jobs": "Retrieve list of asynchronous Jobs",
            "Create asynchronous Job": "Create asynchronous Job",
            "Update asynchronous Job": "Update asynchronous Job",
            "Create asynchronous Job Action": "Create asynchronous Job Action",
            "Retrieve list of Tasks in asynchronous Job": "Retrieve list of Tasks in asynchronous Job",
            "Create Task in asynchronous Job": "Create Task in asynchronous Job",
            "Update Task in asynchronous Job": "Update Task in asynchronous Job",
            "Request action on specific storage": "Request action on specific storage",
            "Retrieve asynchronous Job details": "Retrieve asynchronous Job details",
            "Retrieve asynchronous Job Alias": "Retrieve asynchronous Job Alias",
            "Create Alias for asynchronous Job": "Create Alias for asynchronous Job",
            "Retrieve list of asynchronous Job Types": "Retrieve list of asynchronous Job Types",
            "Create asynchronous Job Type": "Create asynchronous Job Type",
            "Retrieve asynchronous Job Type details": "Retrieve asynchronous Job Type details",
            "Update asynchronous Job Type": "Update asynchronous Job Type",
            "Delete asynchronous Job Type": "Delete asynchronous Job Type",
            "Retrieve list of Actions in asynchronous Job Type": "Retrieve list of Actions in asynchronous Job Type",
            "Create Action in asynchronous Job Type": "Create Action in asynchronous Job Type",
            "Update Action in asynchronous Job Type": "Update Action in asynchronous Job Type",
            "Delete Action in asynchronous Job Type": "Delete Action in asynchronous Job Type",
            "Update music in bulk": "Update music in bulk",
            "Update photos in bulk": "Update photos in bulk",
            "Retrieve list of hidden metadata": "Retrieve list of hidden metadata",
            "Update People in bulk": "Update People in bulk",
            "Retrieve list of item sets for metadata": "Retrieve list of item sets for metadata",
            "Create item set for metadata": "Create item set for metadata",
            "Update item set for metadata": "Update item set for metadata",
            "Delete item set for metadata": "Delete item set for metadata",
            "Retrieve list of elements in item set": "Retrieve list of elements in item set",
            "Update videos in bulk": "Update videos in bulk",
            "Start asynchronous Job": "Start asynchronous Job",
            "Complete asynchronous Job": "Complete asynchronous Job",
            "Start Task in asynchronous Job": "Start Task in asynchronous Job",
            "Complete Task in asynchronous Job": "Complete Task in asynchronous Job",
            "Create asynchronous Job Alias": "Create asynchronous Job Alias",
            "Retrieve asynchronous Job Alias details": "Retrieve asynchronous Job Alias details",
            "Request fms action on specific storage": "Request fms action on specific storage",
            "Retrieve list of Searchable Buckets by admin": "Retrieve list of Searchable Buckets by admin",
            "Retrieve list of download jobs": "Retrieve list of download jobs",
            "Request download": "Request download",
            "Retrieve download job details": "Retrieve download job details",
            "Retrieve list of download job tasks": "Retrieve list of download job tasks",
            "Retrieve download job task details": "Retrieve download job task details",
            "Retrieve download link": "Retrieve download link",
            "Retrieve list of Batch Jobs": "Retrieve list of Batch Jobs",
            "Create Batch Job": "Create Batch Job",
            "Retrieve Batch Job details": "Retrieve Batch Job details",
            "Retrieve list of Batch Job Tasks": "Retrieve list of Batch Job Tasks",
            "Retrieve Batch Job Task details": "Retrieve Batch Job Task details",
            "Retrieve Presigned URL for S3 file": "Retrieve Presigned URL for S3 file",
            "Initiate multipart upload session for S3 file": "Initiate multipart upload session for S3 file",
            "Complete multipart upload for S3 file": "Complete multipart upload for S3 file",
            "Abort multipart upload for S3 file": "Abort multipart upload for S3 file",
            "Retrieve Presigned URL for part upload in S3 file": "Retrieve Presigned URL for part upload in S3 file",
            "Retrieve Presigned URL for upload in S3 file": "Retrieve Presigned URL for upload in S3 file",
            "Retrieve integrated search list": "Retrieve integrated search list",
            "Retrieve list of Resource Buckets assigned to me": "Retrieve list of Resource Buckets assigned to me",
            "Retrieve Task details in asynchronous Job": "Retrieve Task details in asynchronous Job",
            "Retrieve list of integrated search domains": "Retrieve list of integrated search domains",
            "Create integrated search domain": "Create integrated search domain",
            "Retrieve integrated search domain details": "Retrieve integrated search domain details",
            "Delete integrated search domain": "Delete integrated search domain",
            "Retrieve list of shared links": "Retrieve list of shared links",
            "Share link": "Share link",
            "Retrieve shared link details": "Retrieve shared link details",
            "Delete shared link": "Delete shared link",
            "Retrieve list of AWS S3 buckets": "Retrieve list of AWS S3 buckets",
            "Retrieve list of internal shares": "Retrieve list of internal shares",
            "Create internal share": "Create internal share",
            "Retrieve internal share details": "Retrieve internal share details",
            "Update internal share": "Update internal share",
            "Update requester action in internal share": "Update requester action in internal share",
            "Update approver action in internal share": "Update approver action in internal share",
            "Retrieve list of approver candidates for internal share": "Retrieve list of approver candidates for internal share",
            "Retrieve list of shared resources": "Retrieve list of shared resources",
            "Share resource": "Share resource",
            "Retrieve shared resource details": "Retrieve shared resource details",
            "Delete shared resource": "Delete shared resource",
            "Retrieve list of grantees for shared resource": "Retrieve list of grantees for shared resource",
            "Add grantee to shared resource": "Add grantee to shared resource",
            "Retrieve grantee details for shared resource": "Retrieve grantee details for shared resource",
            "Update grantee for shared resource": "Update grantee for shared resource",
            "Remove grantee from shared resource": "Remove grantee from shared resource",
            "Check share permission": "Check share permission",
            "Retrieve list of resources shared with me": "Retrieve list of resources shared with me",
            "Retrieve details of resource shared with me": "Retrieve details of resource shared with me",
            "Delete resource shared with me": "Delete resource shared with me",
            "Retrieve list of drives": "Retrieve list of drives",
            "Retrieve drive details": "Retrieve drive details",
            "Update drive": "Update drive",
            "Retrieve list of folders": "Retrieve list of folders",
            "Create folder": "Create folder",
            "Retrieve folder details": "Retrieve folder details",
            "Update folder": "Update folder",
            "Delete folder": "Delete folder",
            "Move folder": "Move folder",
            "Retrieve list of metadata templates": "Retrieve list of metadata templates",
            "Create metadata template": "Create metadata template",
            "Retrieve metadata template details": "Retrieve metadata template details",
            "Update metadata template": "Update metadata template",
            "Delete metadata template": "Delete metadata template",
            "Register metadata template": "Register metadata template",
            "Retrieve list of dashboard widgets": "Retrieve list of dashboard widgets",
            "Create dashboard widget": "Create dashboard widget",
            "Retrieve dashboard widget details": "Retrieve dashboard widget details",
            "Update dashboard widget": "Update dashboard widget",
            "Delete dashboard widget": "Delete dashboard widget",
            "Retrieve list of dashboard widget data": "Retrieve list of dashboard widget data",
            "Retrieve list of storage folders": "Retrieve list of storage folders",
            "Retrieve list of storage files": "Retrieve list of storage files",
            "Move asset": "Move asset",
            "Request storage action": "Request storage action",
            "Lock Searchable Bucket": "Lock Searchable Bucket",
            "Unlock Searchable Bucket": "Unlock Searchable Bucket",
            "Retrieve list of multipart upload jobs": "Retrieve list of multipart upload jobs",
            "Retrieve list of parts in multipart upload job": "Retrieve list of parts in multipart upload job",
            "Retrieve list of collections": "Retrieve list of collections",
            "Create collection": "Create collection",
            "Retrieve collection details": "Retrieve collection details",
            "Update collection": "Update collection",
            "Delete collection": "Delete collection",
            "Retrieve list of items in collection": "Retrieve list of items in collection",
            "Update collection tags": "Update collection tags",
            "Retrieve list of linked collections": "Retrieve list of linked collections",
            "Request collection action": "Request collection action",
            "Retrieve list of content field types": "Retrieve list of content field types",
            "Create content field type": "Create content field type",
            "Retrieve content field type details": "Retrieve content field type details",
            "Update content field type": "Update content field type",
            "Delete content field type": "Delete content field type",
            "Create content schema": "Create content schema",
            "Request content schema field action": "Request content schema field action",
            "Retrieve content schema details": "Retrieve content schema details",
            "Update content schema": "Update content schema",
            "Delete content schema": "Delete content schema",
            "Request content schema action": "Request content schema action",
            "Retrieve list of projects assigned to content schema": "Retrieve list of projects assigned to content schema",
            "Retrieve list of custom contents": "Retrieve list of custom contents",
            "Create custom content": "Create custom content",
            "Retrieve custom content details": "Retrieve custom content details",
            "Update custom content": "Update custom content",
            "Delete custom content": "Delete custom content",
            "Request custom content action": "Request custom content action",
            "Retrieve custom content field details": "Retrieve custom content field details",
            "Request custom content action in bulk": "Request custom content action in bulk",
            "Retrieve list of AI caption jobs": "Retrieve list of AI caption jobs",
            "Create AI caption job": "Create AI caption job",
            "Retrieve AI caption job details": "Retrieve AI caption job details",
            "Retrieve list of AI analysis jobs": "Retrieve list of AI analysis jobs",
            "Create AI analysis job": "Create AI analysis job",
            "Retrieve AI analysis job details": "Retrieve AI analysis job details",
            "Delete AI analysis job": "Delete AI analysis job",
            "Retrieve list of AI analysis job summaries": "Retrieve list of AI analysis job summaries",
            "Retrieve list of AI analysis job results": "Retrieve list of AI analysis job results",
            "Retrieve list of AI analysis job original results": "Retrieve list of AI analysis job original results",
            "Retrieve AI analysis job original result details": "Retrieve AI analysis job original result details",
            "Callback for AI analysis job engine": "Callback for AI analysis job engine",
            "Retrieve list of dictation vocabularies": "Retrieve list of dictation vocabularies",
            "Create dictation vocabulary": "Create dictation vocabulary",
            "Retrieve dictation vocabulary details": "Retrieve dictation vocabulary details",
            "Delete dictation vocabulary": "Delete dictation vocabulary",
            "Update dictation vocabulary": "Update dictation vocabulary",
            "Retrieve list of phrases in vocabulary": "Retrieve list of phrases in vocabulary",
            "Request vocabulary phrase action": "Request vocabulary phrase action",
            "Retrieve list of notifications": "Retrieve list of notifications",
            "Create notification": "Create notification",
            "Retrieve notification details": "Retrieve notification details",
            "Update notification": "Update notification",
            "Delete notification": "Delete notification",
            "Retrieve list of notification subscriptions": "Retrieve list of notification subscriptions",
            "Subscribe to notification": "Subscribe to notification",
            "Retrieve notification subscription details": "Retrieve notification subscription details",
            "Unsubscribe from notification": "Unsubscribe from notification",
            "Retrieve list of notification conditions": "Retrieve list of notification conditions",
            "Update notification conditions": "Update notification conditions",
            "Retrieve list of domain events": "Retrieve list of domain events",
            "Retrieve download links for AI analysis job": "Retrieve download links for AI analysis job",
            "Retrieve list of asset versions": "Retrieve list of asset versions",
            "Create asset version": "Create asset version",
            "Retrieve asset version details": "Retrieve asset version details",
            "Delete asset version": "Delete asset version",
            "Retrieve list of comment threads": "Retrieve list of comment threads",
            "Create comment thread": "Create comment thread",
            "Retrieve list of comments in thread": "Retrieve list of comments in thread",
            "Create comment": "Create comment",
            "Update comment": "Update comment",
            "Delete comment": "Delete comment",
            "Request comment action": "Request comment action",
            "Delete comment thread": "Delete comment thread",
            "Retrieve comment details": "Retrieve comment details",
            "Update comment thread": "Update comment thread",
            "Retrieve list of comments": "Retrieve list of comments",
            "Retrieve list of Action Groups": "Retrieve list of Action Groups",
            "Retrieve Action Group details": "Retrieve Action Group details",
            "Retrieve list of my space permissions": "Retrieve list of my space permissions",
            "Retrieve list of my project permissions": "Retrieve list of my project permissions",
            "Request role action": "Request role action",
            "Retrieve list of entities by role": "Retrieve list of entities by role",
            "Assign role to entity": "Assign role to entity",
            "Remove role from entity": "Remove role from entity",
            "Create user": "Create user",
            "Create team": "Create team",
            "Update team": "Update team",
            "Delete team": "Delete team",
            "Assign member to team": "Assign member to team",
            "Retrieve team member details": "Retrieve team member details",
            "Remove member from team": "Remove member from team",
            "Assign project member": "Assign project member",
            "Retrieve project member details": "Retrieve project member details",
            "Remove project member": "Remove project member",
            "Assign project team": "Assign project team",
            "Retrieve project team details": "Retrieve project team details",
            "Remove project team": "Remove project team",
            "Retrieve list of project team members": "Retrieve list of project team members",
            "Retrieve project team member details": "Retrieve project team member details",
            "Retrieve list of Resource Types": "Retrieve list of Resource Types",
            "Copy asset": "Copy asset",
            "Retrieve list of collections by asset": "Retrieve list of collections by asset",
            "Delete users in bulk": "Delete users in bulk",
            "Request team action": "Request team action",
            "Delete teams in bulk": "Delete teams in bulk",
            "Remove project members in bulk": "Remove project members in bulk",
            "Remove project teams in bulk": "Remove project teams in bulk",
            "Retrieve list of linked assets": "Retrieve list of linked assets",
            "Add linked asset": "Add linked asset",
            "Remove linked asset": "Remove linked asset",
            "Create comment attachment": "Create comment attachment",
            "Delete comment attachment": "Delete comment attachment",
            "Request user action": "Request user action",
            "Retrieve list of project admins": "Retrieve list of project admins",
            "Request project action": "Request project action",
            "Retrieve list of project member's teams": "Retrieve list of project member's teams",
            "Retrieve list of project member's roles": "Retrieve list of project member's roles",
            "Retrieve list of project team's roles": "Retrieve list of project team's roles",
            "Retrieve comment thread details": "Retrieve comment thread details",
            "Retrieve list of thread entities": "Retrieve list of thread entities",
            "Create thread entity": "Create thread entity",
            "Retrieve list of pending users for space invitation": "Retrieve list of pending users for space invitation",
            "Request space user invitation": "Request space user invitation",
            "Retrieve list of pending users for project invitation": "Retrieve list of pending users for project invitation",
            "Request project user invitation": "Request project user invitation",
            "Retrieve list of assignable members to team": "Retrieve list of assignable members to team",
            "Create exported metadata job": "Create exported metadata job",
            "Retrieve list of exported metadata jobs": "Retrieve list of exported metadata jobs",
            "Retrieve exported metadata job details": "Retrieve exported metadata job details",
            "Update exported metadata job": "Update exported metadata job",
            "Delete exported metadata job": "Delete exported metadata job",
            "Retrieve upload Presigned URL for preview resource": "Retrieve upload Presigned URL for preview resource",
            "Request preview resource action": "Request preview resource action",
            "Retrieve list of audit log search keys": "Retrieve list of audit log search keys",
            "Retrieve embed URL for posting": "Retrieve embed URL for posting",
            "Request role management action": "Request role management action",
            "Retrieve list of report settings": "Retrieve list of report settings",
            "Retrieve report setting details": "Retrieve report setting details",
            "Update report setting": "Update report setting",
            "Retrieve list of reports": "Retrieve list of reports",
            "Retrieve report details": "Retrieve report details",
            "Retrieve list of report subscribers": "Retrieve list of report subscribers",
            "Capture asset frame": "Capture asset frame",
            "Retrieve list of links": "Retrieve list of links",
            "Create link": "Create link",
            "Update link": "Update link",
            "Delete link": "Delete link",
            "Create drive": "Create drive",
            "Delete drive": "Delete drive",
            "Validate share grantee": "Validate share grantee",
            "Apply asset owner lock": "Apply asset owner lock",
            "Release asset owner lock": "Release asset owner lock",
            "Create video clip from asset": "Create video clip from asset",
            "Retrieve list of favorite resources": "Retrieve list of favorite resources",
            "Create favorite resource": "Create favorite resource",
            "Delete favorite resource": "Delete favorite resource",
            "Retrieve list of custom menu sets": "Retrieve list of custom menu sets",
            "Create custom menu set": "Create custom menu set",
            "Retrieve custom menu set details": "Retrieve custom menu set details",
            "Update custom menu set": "Update custom menu set",
            "Delete custom menu set": "Delete custom menu set",
            "Request custom menu set action": "Request custom menu set action",
            "Retrieve list of custom menus": "Retrieve list of custom menus",
            "Create custom menu": "Create custom menu",
            "Retrieve custom menu details": "Retrieve custom menu details",
            "Update custom menu": "Update custom menu",
            "Delete custom menu": "Delete custom menu",
            "Retrieve list of asset histories": "Retrieve list of asset histories",
            "Retrieve asset history details": "Retrieve asset history details",
            "Retrieve integrated search detailed list": "Retrieve integrated search detailed list",
            "Retrieve list of my requests": "Retrieve list of my requests",
            "Retrieve my request details": "Retrieve my request details",
            "Update my request": "Update my request",
            "Delete my request": "Delete my request",
            "Create request": "Create request",
            "Retrieve list of requests": "Retrieve list of requests",
            "Retrieve request details": "Retrieve request details",
            "Update request": "Update request",
            "Delete request": "Delete request",
            "Update request status": "Update request status",
            "Create attachment in my request": "Create attachment in my request",
            "Delete attachment from my request": "Delete attachment from my request",
            "Create attachment in request": "Create attachment in request",
            "Delete attachment from request": "Delete attachment from request",
            "Retrieve list of request categories": "Retrieve list of request categories",
            "Retrieve list of assets shared with me": "Retrieve list of assets shared with me",
            "Share asset": "Share asset",
            "Retrieve list of shared assets": "Retrieve list of shared assets",
            "Unshare asset": "Unshare asset",
            "Assign request assignee": "Assign request assignee",
            "Retrieve custom metadata details of asset": "Retrieve custom metadata details of asset",
            "Retrieve list of projects for asset shared with me": "Retrieve list of projects for asset shared with me",
            "Retrieve list of user agreements": "Retrieve list of user agreements",
            "Retrieve user agreement details": "Retrieve user agreement details",
            "Update user agreement consent": "Update user agreement consent",
            "Create favorite resources in bulk": "Create favorite resources in bulk",
            "Delete favorite resources in bulk": "Delete favorite resources in bulk",
            "Retrieve list of supported regions by provider": "Retrieve list of supported regions by provider",
            "Update asset share": "Update asset share",
            "Retrieve list of assets I shared": "Retrieve list of assets I shared",
            "Retrieve list of projects for asset shared by me": "Retrieve list of projects for asset shared by me",
            "Retrieve list of asset owners": "Retrieve list of asset owners",
            "Retrieve list of usage metric tenants": "Retrieve list of usage metric tenants",
            "Retrieve list of usage metrics": "Retrieve list of usage metrics",
            "Retrieve list of usage metric data": "Retrieve list of usage metric data",
            "Retrieve assignable storages": "Retrieve assignable storages",
            "Retrieve assigned storages": "Retrieve assigned storages",
            "Manage project storages": "Manage project storages",
            "Update owners of assets in bulk": "Update owners of assets in bulk",
            "Callback for Gen AI service": "Callback for Gen AI service",
            "Create AI job in request": "Create AI job in request",
            "AI Source Synchronization": "AI Source Synchronization",
            "Delete Gen AI Source": "Delete Gen AI Source",
            "Create prompt preset": "Create prompt preset",
            "Update prompt preset": "Update prompt preset",
            "Delete prompt preset": "Delete prompt preset",
            "Update prompt preset status": "Update prompt preset status"
        }
    }
}
